typeof JSON != "object" && (JSON = {}),
function() {
    function f(e) {
        return e < 10 ? "0" + e : e
    }
    function quote(e) {
        return escapable.lastIndex = 0,
        escapable.test(e) ? '"' + e.replace(escapable, function(e) {
            var t = meta[e];
            return typeof t == "string" ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
        }) + '"' : '"' + e + '"'
    }
    function str(e, t) {
        var n, r, i, s, o = gap, u, a = t[e];
        a && typeof a == "object" && typeof a.toJSON == "function" && (a = a.toJSON(e)),
        typeof rep == "function" && (a = rep.call(t, e, a));
        switch (typeof a) {
        case "string":
            return quote(a);
        case "number":
            return isFinite(a) ? String(a) : "null";
        case "boolean":
        case "null":
            return String(a);
        case "object":
            if (!a) {
                return "null"
            }
            gap += indent,
            u = [];
            if (Object.prototype.toString.apply(a) === "[object Array]") {
                s = a.length;
                for (n = 0; n < s; n += 1) {
                    u[n] = str(n, a) || "null"
                }
                return i = u.length === 0 ? "[]" : gap ? "[\n" + gap + u.join(",\n" + gap) + "\n" + o + "]" : "[" + u.join(",") + "]",
                gap = o,
                i
            }
            if (rep && typeof rep == "object") {
                s = rep.length;
                for (n = 0; n < s; n += 1) {
                    typeof rep[n] == "string" && (r = rep[n],
                    i = str(r, a),
                    i && u.push(quote(r) + (gap ? ": " : ":") + i))
                }
            } else {
                for (r in a) {
                    Object.prototype.hasOwnProperty.call(a, r) && (i = str(r, a),
                    i && u.push(quote(r) + (gap ? ": " : ":") + i))
                }
            }
            return i = u.length === 0 ? "{}" : gap ? "{\n" + gap + u.join(",\n" + gap) + "\n" + o + "}" : "{" + u.join(",") + "}",
            gap = o,
            i
        }
    }
    typeof Date.prototype.toJSON != "function" && (Date.prototype.toJSON = function(e) {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z" : null
    }
    ,
    String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function(e) {
        return this.valueOf()
    }
    );
    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g, gap, indent, meta = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    }, rep;
    typeof JSON.stringify != "function" && (JSON.stringify = function(e, t, n) {
        var r;
        gap = "",
        indent = "";
        if (typeof n == "number") {
            for (r = 0; r < n; r += 1) {
                indent += " "
            }
        } else {
            typeof n == "string" && (indent = n)
        }
        rep = t;
        if (!t || typeof t == "function" || typeof t == "object" && typeof t.length == "number") {
            return str("", {
                "": e
            })
        }
        throw new Error("JSON.stringify")
    }
    ),
    typeof JSON.parse != "function" && (JSON.parse = function(text, reviver) {
        function walk(e, t) {
            var n, r, i = e[t];
            if (i && typeof i == "object") {
                for (n in i) {
                    Object.prototype.hasOwnProperty.call(i, n) && (r = walk(i, n),
                    r !== undefined ? i[n] = r : delete i[n])
                }
            }
            return reviver.call(e, t, i)
        }
        var j;
        text = String(text),
        cx.lastIndex = 0,
        cx.test(text) && (text = text.replace(cx, function(e) {
            return "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
        }));
        if (/^[\],:{}\s]*$/.test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@").replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, "]").replace(/(?:^|:|,)(?:\s*\[)+/g, ""))) {
            return j = eval("(" + text + ")"),
            typeof reviver == "function" ? walk({
                "": j
            }, "") : j
        }
        throw new SyntaxError("JSON.parse")
    }
    )
}(),
function(c, a) {
    var d = c.History = c.History || {}
      , b = c.jQuery;
    if (typeof d.Adapter != "undefined") {
        throw new Error("History.js Adapter has already been loaded...")
    }
    d.Adapter = {
        on: function(g, f, h) {
            b(g).on(f, h)
        },
        trigger: function(g, f, h) {
            b(g).trigger(f, h)
        },
        extractEventData: function(h, j, g) {
            var f = j && j.originalEvent && j.originalEvent[h] || g && g[h] || a;
            return f
        },
        onDomLoad: function(f) {
            b(f)
        }
    },
    typeof d.init != "undefined" && d.init()
}(window),
function(f, b) {
    var h = f.document
      , d = f.setTimeout || d
      , a = f.clearTimeout || a
      , c = f.setInterval || c
      , g = f.History = f.History || {};
    if (typeof g.initHtml4 != "undefined") {
        throw new Error("History.js HTML4 Support has already been loaded...")
    }
    g.initHtml4 = function() {
        if (typeof g.initHtml4.initialized != "undefined") {
            return !1
        }
        g.initHtml4.initialized = !0,
        g.enabled = !0,
        g.savedHashes = [],
        g.isLastHash = function(j) {
            var i = g.getHashByIndex(), k;
            return k = j === i,
            k
        }
        ,
        g.isHashEqual = function(j, i) {
            return j = encodeURIComponent(j).replace(/%25/g, "%"),
            i = encodeURIComponent(i).replace(/%25/g, "%"),
            j === i
        }
        ,
        g.saveHash = function(i) {
            return g.isLastHash(i) ? !1 : (g.savedHashes.push(i),
            !0)
        }
        ,
        g.getHashByIndex = function(j) {
            var i = null;
            return typeof j == "undefined" ? i = g.savedHashes[g.savedHashes.length - 1] : j < 0 ? i = g.savedHashes[g.savedHashes.length + j] : i = g.savedHashes[j],
            i
        }
        ,
        g.discardedHashes = {},
        g.discardedStates = {},
        g.discardState = function(m, k, o) {
            var l = g.getHashByState(m), j;
            return j = {
                discardedState: m,
                backState: o,
                forwardState: k
            },
            g.discardedStates[l] = j,
            !0
        }
        ,
        g.discardHash = function(k, i, l) {
            var j = {
                discardedHash: k,
                backState: l,
                forwardState: i
            };
            return g.discardedHashes[k] = j,
            !0
        }
        ,
        g.discardedState = function(j) {
            var i = g.getHashByState(j), k;
            return k = g.discardedStates[i] || !1,
            k
        }
        ,
        g.discardedHash = function(j) {
            var i = g.discardedHashes[j] || !1;
            return i
        }
        ,
        g.recycleState = function(j) {
            var i = g.getHashByState(j);
            return g.discardedState(j) && delete g.discardedStates[i],
            !0
        }
        ,
        g.emulated.hashChange && (g.hashChangeInit = function() {
            g.checkerFunction = null;
            var l = "", m, k, j, e, n = Boolean(g.getHash());
            return g.isInternetExplorer() ? (m = "historyjs-iframe",
            k = h.createElement("iframe"),
            k.setAttribute("id", m),
            k.setAttribute("src", "#"),
            k.style.display = "none",
            h.body.appendChild(k),
            k.contentWindow.document.open(),
            k.contentWindow.document.close(),
            j = "",
            e = !1,
            g.checkerFunction = function() {
                if (e) {
                    return !1
                }
                e = !0;
                var o = g.getHash()
                  , i = g.getHash(k.contentWindow.document);
                return o !== l ? (l = o,
                i !== o && (j = i = o,
                k.contentWindow.document.open(),
                k.contentWindow.document.close(),
                k.contentWindow.document.location.hash = g.escapeHash(o)),
                g.Adapter.trigger(f, "hashchange")) : i !== j && (j = i,
                n && i === "" ? g.back() : g.setHash(i, !1)),
                e = !1,
                !0
            }
            ) : g.checkerFunction = function() {
                var i = g.getHash() || "";
                return i !== l && (l = i,
                g.Adapter.trigger(f, "hashchange")),
                !0
            }
            ,
            g.intervalList.push(c(g.checkerFunction, g.options.hashChangeInterval)),
            !0
        }
        ,
        g.Adapter.onDomLoad(g.hashChangeInit)),
        g.emulated.pushState && (g.onHashChange = function(l) {
            var p = l && l.newURL || g.getLocationHref(), o = g.getHashByUrl(p), k = null, m = null, j = null, e;
            return g.isLastHash(o) ? (g.busy(!1),
            !1) : (g.doubleCheckComplete(),
            g.saveHash(o),
            o && g.isTraditionalAnchor(o) ? (g.Adapter.trigger(f, "anchorchange"),
            g.busy(!1),
            !1) : (k = g.extractState(g.getFullUrl(o || g.getLocationHref()), !0),
            g.isLastSavedState(k) ? (g.busy(!1),
            !1) : (m = g.getHashByState(k),
            e = g.discardedState(k),
            e ? (g.getHashByIndex(-2) === g.getHashByState(e.forwardState) ? g.back(!1) : g.forward(!1),
            !1) : (g.pushState(k.data, k.title, encodeURI(k.url), !1),
            !0))))
        }
        ,
        g.Adapter.on(f, "hashchange", g.onHashChange),
        g.pushState = function(w, j, e, m) {
            e = encodeURI(e).replace(/%25/g, "%");
            if (g.getHashByUrl(e)) {
                throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).")
            }
            if (m !== !1 && g.busy()) {
                return g.pushQueue({
                    scope: g,
                    callback: g.pushState,
                    args: arguments,
                    queue: m
                }),
                !1
            }
            g.busy(!0);
            var x = g.createStateObject(w, j, e)
              , v = g.getHashByState(x)
              , q = g.getState(!1)
              , o = g.getHashByState(q)
              , k = g.getHash()
              , p = g.expectedStateId == x.id;
            return g.storeState(x),
            g.expectedStateId = x.id,
            g.recycleState(x),
            g.setTitle(x),
            v === o ? (g.busy(!1),
            !1) : (g.saveState(x),
            p || g.Adapter.trigger(f, "statechange"),
            !g.isHashEqual(v, k) && !g.isHashEqual(v, g.getShortUrl(g.getLocationHref())) && g.setHash(v, !1),
            g.busy(!1),
            !0)
        }
        ,
        g.replaceState = function(v, j, e, m) {
            e = encodeURI(e).replace(/%25/g, "%");
            if (g.getHashByUrl(e)) {
                throw new Error("History.js does not support states with fragment-identifiers (hashes/anchors).")
            }
            if (m !== !1 && g.busy()) {
                return g.pushQueue({
                    scope: g,
                    callback: g.replaceState,
                    args: arguments,
                    queue: m
                }),
                !1
            }
            g.busy(!0);
            var w = g.createStateObject(v, j, e)
              , q = g.getHashByState(w)
              , p = g.getState(!1)
              , o = g.getHashByState(p)
              , k = g.getStateByIndex(-2);
            return g.discardState(p, w, k),
            q === o ? (g.storeState(w),
            g.expectedStateId = w.id,
            g.recycleState(w),
            g.setTitle(w),
            g.saveState(w),
            g.Adapter.trigger(f, "statechange"),
            g.busy(!1)) : g.pushState(w.data, w.title, w.url, !1),
            !0
        }
        ),
        g.emulated.pushState && g.getHash() && !g.emulated.hashChange && g.Adapter.onDomLoad(function() {
            g.Adapter.trigger(f, "hashchange")
        })
    }
    ,
    typeof g.init != "undefined" && g.init()
}(window),
function(x, C) {
    var k = x.console || C
      , b = x.document
      , q = x.navigator
      , D = !1
      , j = x.setTimeout
      , B = x.clearTimeout
      , A = x.setInterval
      , w = x.clearInterval
      , m = x.JSON
      , z = x.alert
      , v = x.History = x.History || {}
      , g = x.history;
    try {
        D = x.sessionStorage,
        D.setItem("TEST", "1"),
        D.removeItem("TEST")
    } catch (y) {
        D = !1
    }
    m.stringify = m.stringify || m.encode,
    m.parse = m.parse || m.decode;
    if (typeof v.init != "undefined") {
        throw new Error("History.js Core has already been loaded...")
    }
    v.init = function(a) {
        return typeof v.Adapter == "undefined" ? !1 : (typeof v.initCore != "undefined" && v.initCore(),
        typeof v.initHtml4 != "undefined" && v.initHtml4(),
        !0)
    }
    ,
    v.initCore = function(e) {
        if (typeof v.initCore.initialized != "undefined") {
            return !1
        }
        v.initCore.initialized = !0,
        v.options = v.options || {},
        v.options.hashChangeInterval = v.options.hashChangeInterval || 100,
        v.options.safariPollInterval = v.options.safariPollInterval || 500,
        v.options.doubleCheckInterval = v.options.doubleCheckInterval || 500,
        v.options.disableSuid = v.options.disableSuid || !1,
        v.options.storeInterval = v.options.storeInterval || 1000,
        v.options.busyDelay = v.options.busyDelay || 250,
        v.options.debug = v.options.debug || !1,
        v.options.initialTitle = v.options.initialTitle || b.title,
        v.options.html4Mode = v.options.html4Mode || !1,
        v.options.delayInit = v.options.delayInit || !1,
        v.intervalList = [],
        v.clearAllIntervals = function() {
            var f, d = v.intervalList;
            if (typeof d != "undefined" && d !== null) {
                for (f = 0; f < d.length; f++) {
                    w(d[f])
                }
                v.intervalList = null
            }
        }
        ,
        v.debug = function() {
            (v.options.debug || !1) && v.log.apply(v, arguments)
        }
        ,
        v.log = function() {
            var E = typeof k != "undefined" && typeof k.log != "undefined" && typeof k.log.apply != "undefined", n = b.getElementById("log"), l, p, F, h, d;
            E ? (h = Array.prototype.slice.call(arguments),
            l = h.shift(),
            typeof k.debug != "undefined" ? k.debug.apply(k, [l, h]) : k.log.apply(k, [l, h])) : l = "\n" + arguments[0] + "\n";
            for (p = 1,
            F = arguments.length; p < F; ++p) {
                d = arguments[p];
                if (typeof d == "object" && typeof m != "undefined") {
                    try {
                        d = m.stringify(d)
                    } catch (r) {}
                }
                l += "\n" + d + "\n"
            }
            return n ? (n.value += l + "\n-----\n",
            n.scrollTop = n.scrollHeight - n.clientHeight) : E || z(l),
            !0
        }
        ,
        v.getInternetExplorerMajorVersion = function() {
            var d = v.getInternetExplorerMajorVersion.cached = typeof v.getInternetExplorerMajorVersion.cached != "undefined" ? v.getInternetExplorerMajorVersion.cached : function() {
                var h = 3
                  , f = b.createElement("div")
                  , i = f.getElementsByTagName("i");
                while ((f.innerHTML = "<!--[if gt IE " + ++h + "]><i></i><![endif]-->") && i[0]) {}
                return h > 4 ? h : !1
            }();
            return d
        }
        ,
        v.isInternetExplorer = function() {
            var d = v.isInternetExplorer.cached = typeof v.isInternetExplorer.cached != "undefined" ? v.isInternetExplorer.cached : Boolean(v.getInternetExplorerMajorVersion());
            return d
        }
        ,
        v.options.html4Mode ? v.emulated = {
            pushState: !0,
            hashChange: !0
        } : v.emulated = {
            pushState: !Boolean(x.history && x.history.pushState && x.history.replaceState && !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(q.userAgent) && !/AppleWebKit\/5([0-2]|3[0-2])/i.test(q.userAgent)),
            hashChange: Boolean(!("onhashchange"in x || "onhashchange"in b) || v.isInternetExplorer() && v.getInternetExplorerMajorVersion() < 8)
        },
        v.enabled = !v.emulated.pushState,
        v.bugs = {
            setHash: Boolean(!v.emulated.pushState && q.vendor === "Apple Computer, Inc." && /AppleWebKit\/5([0-2]|3[0-3])/.test(q.userAgent)),
            safariPoll: Boolean(!v.emulated.pushState && q.vendor === "Apple Computer, Inc." && /AppleWebKit\/5([0-2]|3[0-3])/.test(q.userAgent)),
            ieDoubleCheck: Boolean(v.isInternetExplorer() && v.getInternetExplorerMajorVersion() < 8),
            hashEscape: Boolean(v.isInternetExplorer() && v.getInternetExplorerMajorVersion() < 7)
        },
        v.isEmptyObject = function(f) {
            for (var d in f) {
                if (f.hasOwnProperty(d)) {
                    return !1
                }
            }
            return !0
        }
        ,
        v.cloneObject = function(f) {
            var d, h;
            return f ? (d = m.stringify(f),
            h = m.parse(d)) : h = {},
            h
        }
        ,
        v.getRootUrl = function() {
            var d = b.location.protocol + "//" + (b.location.hostname || b.location.host);
            if (b.location.port || !1) {
                d += ":" + b.location.port
            }
            return d += "/",
            d
        }
        ,
        v.getBaseHref = function() {
            var f = b.getElementsByTagName("base")
              , d = null
              , h = "";
            return f.length === 1 && (d = f[0],
            h = d.href.replace(/[^\/]+$/, "")),
            h = h.replace(/\/+$/, ""),
            h && (h += "/"),
            h
        }
        ,
        v.getBaseUrl = function() {
            var d = v.getBaseHref() || v.getBasePageUrl() || v.getRootUrl();
            return d
        }
        ,
        v.getPageUrl = function() {
            var f = v.getState(!1, !1), d = (f || {}).url || v.getLocationHref(), h;
            return h = d.replace(/\/+$/, "").replace(/[^\/]+$/, function(l, i, o) {
                return /\./.test(l) ? l : l + "/"
            }),
            h
        }
        ,
        v.getBasePageUrl = function() {
            var d = v.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, function(h, f, i) {
                return /[^\/]$/.test(h) ? "" : h
            }).replace(/\/+$/, "") + "/";
            return d
        }
        ,
        v.getFullUrl = function(h, d) {
            var i = h
              , f = h.substring(0, 1);
            return d = typeof d == "undefined" ? !0 : d,
            /[a-z]+\:\/\//.test(h) || (f === "/" ? i = v.getRootUrl() + h.replace(/^\/+/, "") : f === "#" ? i = v.getPageUrl().replace(/#.*/, "") + h : f === "?" ? i = v.getPageUrl().replace(/[\?#].*/, "") + h : d ? i = v.getBaseUrl() + h.replace(/^(\.\/)+/, "") : i = v.getBasePageUrl() + h.replace(/^(\.\/)+/, "")),
            i.replace(/\#$/, "")
        }
        ,
        v.getShortUrl = function(h) {
            var d = h
              , i = v.getBaseUrl()
              , f = v.getRootUrl();
            return v.emulated.pushState && (d = d.replace(i, "")),
            d = d.replace(f, "/"),
            v.isTraditionalAnchor(d) && (d = "./" + d),
            d = d.replace(/^(\.\/)+/g, "./").replace(/\#$/, ""),
            d
        }
        ,
        v.getLocationHref = function(d) {
            return d = d || b,
            d.URL === d.location.href ? d.location.href : d.location.href === decodeURIComponent(d.URL) ? d.URL : d.location.hash && decodeURIComponent(d.location.href.replace(/^[^#]+/, "")) === d.location.hash ? d.location.href : d.URL.indexOf("#") == -1 && d.location.href.indexOf("#") != -1 ? d.location.href : d.URL || d.location.href
        }
        ,
        v.store = {},
        v.idToState = v.idToState || {},
        v.stateToId = v.stateToId || {},
        v.urlToId = v.urlToId || {},
        v.storedStates = v.storedStates || [],
        v.savedStates = v.savedStates || [],
        v.normalizeStore = function() {
            v.store.idToState = v.store.idToState || {},
            v.store.urlToId = v.store.urlToId || {},
            v.store.stateToId = v.store.stateToId || {}
        }
        ,
        v.getState = function(f, d) {
            typeof f == "undefined" && (f = !0),
            typeof d == "undefined" && (d = !0);
            var h = v.getLastSavedState();
            return !h && d && (h = v.createStateObject()),
            f && (h = v.cloneObject(h),
            h.url = h.cleanUrl || h.url),
            h
        }
        ,
        v.getIdByState = function(f) {
            var d = v.extractId(f.url), h;
            if (!d) {
                h = v.getStateString(f);
                if (typeof v.stateToId[h] != "undefined") {
                    d = v.stateToId[h]
                } else {
                    if (typeof v.store.stateToId[h] != "undefined") {
                        d = v.store.stateToId[h]
                    } else {
                        for (; ; ) {
                            d = (new Date).getTime() + String(Math.random()).replace(/\D/g, "");
                            if (typeof v.idToState[d] == "undefined" && typeof v.store.idToState[d] == "undefined") {
                                break
                            }
                        }
                        v.stateToId[h] = d,
                        v.idToState[d] = f
                    }
                }
            }
            return d
        }
        ,
        v.normalizeState = function(f) {
            var d, h;
            if (!f || typeof f != "object") {
                f = {}
            }
            if (typeof f.normalized != "undefined") {
                return f
            }
            if (!f.data || typeof f.data != "object") {
                f.data = {}
            }
            return d = {},
            d.normalized = !0,
            d.title = f.title || "",
            d.url = v.getFullUrl(f.url ? f.url : v.getLocationHref()),
            d.hash = v.getShortUrl(d.url),
            d.data = v.cloneObject(f.data),
            d.id = v.getIdByState(d),
            d.cleanUrl = d.url.replace(/\??\&_suid.*/, ""),
            d.url = d.cleanUrl,
            h = !v.isEmptyObject(d.data),
            (d.title || h) && v.options.disableSuid !== !0 && (d.hash = v.getShortUrl(d.url).replace(/\??\&_suid.*/, ""),
            /\?/.test(d.hash) || (d.hash += "?"),
            d.hash += "&_suid=" + d.id),
            d.hashedUrl = v.getFullUrl(d.hash),
            (v.emulated.pushState || v.bugs.safariPoll) && v.hasUrlDuplicate(d) && (d.url = d.hashedUrl),
            d
        }
        ,
        v.createStateObject = function(h, d, i) {
            var f = {
                data: h,
                title: d,
                url: i
            };
            return f = v.normalizeState(f),
            f
        }
        ,
        v.getStateById = function(d) {
            d = String(d);
            var f = v.idToState[d] || v.store.idToState[d] || C;
            return f
        }
        ,
        v.getStateString = function(h) {
            var d, i, f;
            return d = v.normalizeState(h),
            i = {
                data: d.data,
                title: h.title,
                url: h.url
            },
            f = m.stringify(i),
            f
        }
        ,
        v.getStateId = function(f) {
            var d, h;
            return d = v.normalizeState(f),
            h = d.id,
            h
        }
        ,
        v.getHashByState = function(f) {
            var d, h;
            return d = v.normalizeState(f),
            h = d.hash,
            h
        }
        ,
        v.extractId = function(l) {
            var f, o, h, d;
            return l.indexOf("#") != -1 ? d = l.split("#")[0] : d = l,
            o = /(.*)\&_suid=([0-9]+)$/.exec(d),
            h = o ? o[1] || l : l,
            f = o ? String(o[2] || "") : "",
            f || !1
        }
        ,
        v.isTraditionalAnchor = function(f) {
            var d = !/[\/\?\.]/.test(f);
            return d
        }
        ,
        v.extractState = function(l, f) {
            var o = null, h, d;
            return f = f || !1,
            h = v.extractId(l),
            h && (o = v.getStateById(h)),
            o || (d = v.getFullUrl(l),
            h = v.getIdByUrl(d) || !1,
            h && (o = v.getStateById(h)),
            !o && f && !v.isTraditionalAnchor(l) && (o = v.createStateObject(null, null, d))),
            o
        }
        ,
        v.getIdByUrl = function(d) {
            var f = v.urlToId[d] || v.store.urlToId[d] || C;
            return f
        }
        ,
        v.getLastSavedState = function() {
            return v.savedStates[v.savedStates.length - 1] || C
        }
        ,
        v.getLastStoredState = function() {
            return v.storedStates[v.storedStates.length - 1] || C
        }
        ,
        v.hasUrlDuplicate = function(f) {
            var d = !1, h;
            return h = v.extractState(f.url),
            d = h && h.id !== f.id,
            d
        }
        ,
        v.storeState = function(d) {
            return v.urlToId[d.url] = d.id,
            v.storedStates.push(v.cloneObject(d)),
            d
        }
        ,
        v.isLastSavedState = function(l) {
            var f = !1, o, h, d;
            return v.savedStates.length && (o = l.id,
            h = v.getLastSavedState(),
            d = h.id,
            f = o === d),
            f
        }
        ,
        v.saveState = function(d) {
            return v.isLastSavedState(d) ? !1 : (v.savedStates.push(v.cloneObject(d)),
            !0)
        }
        ,
        v.getStateByIndex = function(f) {
            var d = null;
            return typeof f == "undefined" ? d = v.savedStates[v.savedStates.length - 1] : f < 0 ? d = v.savedStates[v.savedStates.length + f] : d = v.savedStates[f],
            d
        }
        ,
        v.getCurrentIndex = function() {
            var d = null;
            return v.savedStates.length < 1 ? d = 0 : d = v.savedStates.length - 1,
            d
        }
        ,
        v.getHash = function(f) {
            var d = v.getLocationHref(f), h;
            return h = v.getHashByUrl(d),
            h
        }
        ,
        v.unescapeHash = function(f) {
            var d = v.normalizeHash(f);
            return d = decodeURIComponent(d),
            d
        }
        ,
        v.normalizeHash = function(f) {
            var d = f.replace(/[^#]*#/, "").replace(/#.*/, "");
            return d
        }
        ,
        v.setHash = function(h, f) {
            var l, d;
            return f !== !1 && v.busy() ? (v.pushQueue({
                scope: v,
                callback: v.setHash,
                args: arguments,
                queue: f
            }),
            !1) : (v.busy(!0),
            l = v.extractState(h, !0),
            l && !v.emulated.pushState ? v.pushState(l.data, l.title, l.url, !1) : v.getHash() !== h && (v.bugs.setHash ? (d = v.getPageUrl(),
            v.pushState(null, null, d + "#" + h, !1)) : b.location.hash = h),
            v)
        }
        ,
        v.escapeHash = function(d) {
            var f = v.normalizeHash(d);
            return f = x.encodeURIComponent(f),
            v.bugs.hashEscape || (f = f.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")),
            f
        }
        ,
        v.getHashByUrl = function(f) {
            var d = String(f).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
            return d = v.unescapeHash(d),
            d
        }
        ,
        v.setTitle = function(h) {
            var f = h.title, l;
            f || (l = v.getStateByIndex(0),
            l && l.url === h.url && (f = l.title || v.options.initialTitle));
            try {
                b.getElementsByTagName("title")[0].innerHTML = f.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ")
            } catch (d) {}
            return b.title = f,
            v
        }
        ,
        v.queues = [],
        v.busy = function(f) {
            typeof f != "undefined" ? v.busy.flag = f : typeof v.busy.flag == "undefined" && (v.busy.flag = !1);
            if (!v.busy.flag) {
                B(v.busy.timeout);
                var d = function() {
                    var i, l, h;
                    if (v.busy.flag) {
                        return
                    }
                    for (i = v.queues.length - 1; i >= 0; --i) {
                        l = v.queues[i];
                        if (l.length === 0) {
                            continue
                        }
                        h = l.shift(),
                        v.fireQueueItem(h),
                        v.busy.timeout = j(d, v.options.busyDelay)
                    }
                };
                v.busy.timeout = j(d, v.options.busyDelay)
            }
            return v.busy.flag
        }
        ,
        v.busy.flag = !1,
        v.fireQueueItem = function(d) {
            return d.callback.apply(d.scope || v, d.args || [])
        }
        ,
        v.pushQueue = function(d) {
            return v.queues[d.queue || 0] = v.queues[d.queue || 0] || [],
            v.queues[d.queue || 0].push(d),
            v
        }
        ,
        v.queue = function(f, d) {
            return typeof f == "function" && (f = {
                callback: f
            }),
            typeof d != "undefined" && (f.queue = d),
            v.busy() ? v.pushQueue(f) : v.fireQueueItem(f),
            v
        }
        ,
        v.clearQueue = function() {
            return v.busy.flag = !1,
            v.queues = [],
            v
        }
        ,
        v.stateChanged = !1,
        v.doubleChecker = !1,
        v.doubleCheckComplete = function() {
            return v.stateChanged = !0,
            v.doubleCheckClear(),
            v
        }
        ,
        v.doubleCheckClear = function() {
            return v.doubleChecker && (B(v.doubleChecker),
            v.doubleChecker = !1),
            v
        }
        ,
        v.doubleCheck = function(d) {
            return v.stateChanged = !1,
            v.doubleCheckClear(),
            v.bugs.ieDoubleCheck && (v.doubleChecker = j(function() {
                return v.doubleCheckClear(),
                v.stateChanged || d(),
                !0
            }, v.options.doubleCheckInterval)),
            v
        }
        ,
        v.safariStatePoll = function() {
            var d = v.extractState(v.getLocationHref()), f;
            if (!v.isLastSavedState(d)) {
                return f = d,
                f || (f = v.createStateObject()),
                v.Adapter.trigger(x, "popstate"),
                v
            }
            return
        }
        ,
        v.back = function(d) {
            return d !== !1 && v.busy() ? (v.pushQueue({
                scope: v,
                callback: v.back,
                args: arguments,
                queue: d
            }),
            !1) : (v.busy(!0),
            v.doubleCheck(function() {
                v.back(!1)
            }),
            g.go(-1),
            !0)
        }
        ,
        v.forward = function(d) {
            return d !== !1 && v.busy() ? (v.pushQueue({
                scope: v,
                callback: v.forward,
                args: arguments,
                queue: d
            }),
            !1) : (v.busy(!0),
            v.doubleCheck(function() {
                v.forward(!1)
            }),
            g.go(1),
            !0)
        }
        ,
        v.go = function(f, d) {
            var h;
            if (f > 0) {
                for (h = 1; h <= f; ++h) {
                    v.forward(d)
                }
            } else {
                if (!(f < 0)) {
                    throw new Error("History.go: History.go requires a positive or negative integer passed.")
                }
                for (h = -1; h >= f; --h) {
                    v.back(d)
                }
            }
            return v
        }
        ;
        if (v.emulated.pushState) {
            var c = function() {};
            v.pushState = v.pushState || c,
            v.replaceState = v.replaceState || c
        } else {
            v.onPopState = function(f, u) {
                var l = !1, d = !1, h, p;
                return v.doubleCheckComplete(),
                h = v.getHash(),
                h ? (p = v.extractState(h || v.getLocationHref(), !0),
                p ? v.replaceState(p.data, p.title, p.url, !1) : (v.Adapter.trigger(x, "anchorchange"),
                v.busy(!1)),
                v.expectedStateId = !1,
                !1) : (l = v.Adapter.extractEventData("state", f, u) || !1,
                l ? d = v.getStateById(l) : v.expectedStateId ? d = v.getStateById(v.expectedStateId) : d = v.extractState(v.getLocationHref()),
                d || (d = v.createStateObject(null, null, v.getLocationHref())),
                v.expectedStateId = !1,
                v.isLastSavedState(d) ? (v.busy(!1),
                !1) : (v.storeState(d),
                v.saveState(d),
                v.setTitle(d),
                v.Adapter.trigger(x, "statechange"),
                v.busy(!1),
                !0))
            }
            ,
            v.Adapter.on(x, "popstate", v.onPopState),
            v.pushState = function(f, o, l, d) {
                if (v.getHashByUrl(l) && v.emulated.pushState) {
                    throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).")
                }
                if (d !== !1 && v.busy()) {
                    return v.pushQueue({
                        scope: v,
                        callback: v.pushState,
                        args: arguments,
                        queue: d
                    }),
                    !1
                }
                v.busy(!0);
                var h = v.createStateObject(f, o, l);
                return v.isLastSavedState(h) ? v.busy(!1) : (v.storeState(h),
                v.expectedStateId = h.id,
                g.pushState(h.id, h.title, h.url),
                v.Adapter.trigger(x, "popstate")),
                !0
            }
            ,
            v.replaceState = function(f, o, l, d) {
                if (v.getHashByUrl(l) && v.emulated.pushState) {
                    throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).")
                }
                if (d !== !1 && v.busy()) {
                    return v.pushQueue({
                        scope: v,
                        callback: v.replaceState,
                        args: arguments,
                        queue: d
                    }),
                    !1
                }
                v.busy(!0);
                var h = v.createStateObject(f, o, l);
                return v.isLastSavedState(h) ? v.busy(!1) : (v.storeState(h),
                v.expectedStateId = h.id,
                g.replaceState(h.id, h.title, h.url),
                v.Adapter.trigger(x, "popstate")),
                !0
            }
        }
        if (D) {
            try {
                v.store = m.parse(D.getItem("History.store")) || {}
            } catch (a) {
                v.store = {}
            }
            v.normalizeStore()
        } else {
            v.store = {},
            v.normalizeStore()
        }
        v.Adapter.on(x, "unload", v.clearAllIntervals),
        v.saveState(v.storeState(v.extractState(v.getLocationHref(), !0))),
        D && (v.onUnload = function() {
            var l, f, o;
            try {
                l = m.parse(D.getItem("History.store")) || {}
            } catch (h) {
                l = {}
            }
            l.idToState = l.idToState || {},
            l.urlToId = l.urlToId || {},
            l.stateToId = l.stateToId || {};
            for (f in v.idToState) {
                if (!v.idToState.hasOwnProperty(f)) {
                    continue
                }
                l.idToState[f] = v.idToState[f]
            }
            for (f in v.urlToId) {
                if (!v.urlToId.hasOwnProperty(f)) {
                    continue
                }
                l.urlToId[f] = v.urlToId[f]
            }
            for (f in v.stateToId) {
                if (!v.stateToId.hasOwnProperty(f)) {
                    continue
                }
                l.stateToId[f] = v.stateToId[f]
            }
            v.store = l,
            v.normalizeStore(),
            o = m.stringify(l);
            try {
                D.setItem("History.store", o)
            } catch (d) {
                if (d.code !== DOMException.QUOTA_EXCEEDED_ERR) {
                    throw d
                }
                D.length && (D.removeItem("History.store"),
                D.setItem("History.store", o))
            }
        }
        ,
        v.intervalList.push(A(v.onUnload, v.options.storeInterval)),
        v.Adapter.on(x, "beforeunload", v.onUnload),
        v.Adapter.on(x, "unload", v.onUnload));
        if (!v.emulated.pushState) {
            v.bugs.safariPoll && v.intervalList.push(A(v.safariStatePoll, v.options.safariPollInterval));
            if (q.vendor === "Apple Computer, Inc." || (q.appCodeName || "") === "Mozilla") {
                v.Adapter.on(x, "hashchange", function() {
                    v.Adapter.trigger(x, "popstate")
                }),
                v.getHash() && v.Adapter.onDomLoad(function() {
                    v.Adapter.trigger(x, "hashchange")
                })
            }
        }
    }
    ,
    (!v.options || !v.options.delayInit) && v.init()
}(window);
/**
 * bxSlider v4.2.17
 * Copyright 2013-2017 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */
!function(t){var e={mode:"horizontal",slideSelector:"",infiniteLoop:!0,hideControlOnEnd:!1,speed:500,easing:null,slideMargin:0,startSlide:0,randomStart:!1,captions:!1,ticker:!1,tickerHover:!1,adaptiveHeight:!1,adaptiveHeightSpeed:500,video:!1,useCSS:!0,preloadImages:"visible",responsive:!0,slideZIndex:50,wrapperClass:"bx-wrapper",touchEnabled:!0,swipeThreshold:50,oneToOneTouch:!0,preventDefaultSwipeX:!0,preventDefaultSwipeY:!1,ariaLive:!0,ariaHidden:!0,keyboardEnabled:!1,pager:!0,pagerType:"full",pagerShortSeparator:" / ",pagerSelector:null,buildPager:null,pagerCustom:null,controls:!0,nextText:"Next",prevText:"Prev",nextSelector:null,prevSelector:null,autoControls:!1,startText:"Start",stopText:"Stop",autoControlsCombine:!1,autoControlsSelector:null,auto:!1,pause:4e3,autoStart:!0,autoDirection:"next",stopAutoOnClick:!1,autoHover:!1,autoDelay:0,autoSlideForOnePage:!1,minSlides:1,maxSlides:1,moveSlides:0,slideWidth:0,shrinkItems:!1,onSliderLoad:function(){return!0},onSlideBefore:function(){return!0},onSlideAfter:function(){return!0},onSlideNext:function(){return!0},onSlidePrev:function(){return!0},onSliderResize:function(){return!0},onAutoChange:function(){return!0}};t.fn.bxSlider=function(n){if(0===this.length)return this;if(this.length>1)return this.each(function(){t(this).bxSlider(n)}),this;var s={},o=this,r=t(window).width(),a=t(window).height();if(!t(o).data("bxSlider")){var l=function(){t(o).data("bxSlider")||(s.settings=t.extend({},e,n),s.settings.slideWidth=parseInt(s.settings.slideWidth),s.children=o.children(s.settings.slideSelector),s.children.length<s.settings.minSlides&&(s.settings.minSlides=s.children.length),s.children.length<s.settings.maxSlides&&(s.settings.maxSlides=s.children.length),s.settings.randomStart&&(s.settings.startSlide=Math.floor(Math.random()*s.children.length)),s.active={index:s.settings.startSlide},s.carousel=s.settings.minSlides>1||s.settings.maxSlides>1,s.carousel&&(s.settings.preloadImages="all"),s.minThreshold=s.settings.minSlides*s.settings.slideWidth+(s.settings.minSlides-1)*s.settings.slideMargin,s.maxThreshold=s.settings.maxSlides*s.settings.slideWidth+(s.settings.maxSlides-1)*s.settings.slideMargin,s.working=!1,s.controls={},s.interval=null,s.animProp="vertical"===s.settings.mode?"top":"left",s.usingCSS=s.settings.useCSS&&"fade"!==s.settings.mode&&function(){for(var t=document.createElement("div"),e=["WebkitPerspective","MozPerspective","OPerspective","msPerspective"],i=0;i<e.length;i++)if(void 0!==t.style[e[i]])return s.cssPrefix=e[i].replace("Perspective","").toLowerCase(),s.animProp="-"+s.cssPrefix+"-transform",!0;return!1}(),"vertical"===s.settings.mode&&(s.settings.maxSlides=s.settings.minSlides),o.data("origStyle",o.attr("style")),o.children(s.settings.slideSelector).each(function(){t(this).data("origStyle",t(this).attr("style"))}),d())},d=function(){var e=s.children.eq(s.settings.startSlide);o.wrap('<div class="'+s.settings.wrapperClass+'"><div class="bx-viewport"></div></div>'),s.viewport=o.parent(),s.settings.ariaLive&&!s.settings.ticker&&s.viewport.attr("aria-live","polite"),s.loader=t('<div class="bx-loading" />'),s.viewport.prepend(s.loader),o.css({width:"horizontal"===s.settings.mode?1e3*s.children.length+215+"%":"auto",position:"relative"}),s.usingCSS&&s.settings.easing?o.css("-"+s.cssPrefix+"-transition-timing-function",s.settings.easing):s.settings.easing||(s.settings.easing="swing"),s.viewport.css({width:"100%",overflow:"hidden",position:"relative"}),s.viewport.parent().css({maxWidth:u()}),s.children.css({float:"horizontal"===s.settings.mode?"left":"none",listStyle:"none",position:"relative"}),s.children.css("width",h()),"horizontal"===s.settings.mode&&s.settings.slideMargin>0&&s.children.css("marginRight",s.settings.slideMargin),"vertical"===s.settings.mode&&s.settings.slideMargin>0&&s.children.css("marginBottom",s.settings.slideMargin),"fade"===s.settings.mode&&(s.children.css({position:"absolute",zIndex:0,display:"none"}),s.children.eq(s.settings.startSlide).css({zIndex:s.settings.slideZIndex,display:"block"})),s.controls.el=t('<div class="bx-controls" />'),s.settings.captions&&k(),s.active.last=s.settings.startSlide===f()-1,s.settings.video&&o.fitVids(),"none"===s.settings.preloadImages?e=null:("all"===s.settings.preloadImages||s.settings.ticker)&&(e=s.children),s.settings.ticker?s.settings.pager=!1:(s.settings.controls&&C(),s.settings.auto&&s.settings.autoControls&&T(),s.settings.pager&&b(),(s.settings.controls||s.settings.autoControls||s.settings.pager)&&s.viewport.after(s.controls.el)),null===e?g():c(e,g)},c=function(e,i){var n=e.find('img:not([src=""]), iframe').length,s=0;if(0===n)return void i();e.find('img:not([src=""]), iframe').each(function(){t(this).one("load error",function(){++s===n&&i()}).each(function(){(this.complete||""==this.src)&&t(this).trigger("load")})})},g=function(){if(s.settings.infiniteLoop&&"fade"!==s.settings.mode&&!s.settings.ticker){var e="vertical"===s.settings.mode?s.settings.minSlides:s.settings.maxSlides,i=s.children.slice(0,e).clone(!0).addClass("bx-clone"),n=s.children.slice(-e).clone(!0).addClass("bx-clone");s.settings.ariaHidden&&(i.attr("aria-hidden",!0),n.attr("aria-hidden",!0)),o.append(i).prepend(n)}s.loader.remove(),m(),"vertical"===s.settings.mode&&(s.settings.adaptiveHeight=!0),s.viewport.height(p()),o.redrawSlider(),s.settings.onSliderLoad.call(o,s.active.index),s.initialized=!0,s.settings.responsive&&t(window).on("resize",U),s.settings.auto&&s.settings.autoStart&&(f()>1||s.settings.autoSlideForOnePage)&&L(),s.settings.ticker&&O(),s.settings.pager&&z(s.settings.startSlide),s.settings.controls&&q(),s.settings.touchEnabled&&!s.settings.ticker&&X(),s.settings.keyboardEnabled&&!s.settings.ticker&&t(document).keydown(B)},p=function(){var e=0,n=t();if("vertical"===s.settings.mode||s.settings.adaptiveHeight)if(s.carousel){var o=1===s.settings.moveSlides?s.active.index:s.active.index*x();for(n=s.children.eq(o),i=1;i<=s.settings.maxSlides-1;i++)n=o+i>=s.children.length?n.add(s.children.eq(i-1)):n.add(s.children.eq(o+i))}else n=s.children.eq(s.active.index);else n=s.children;return"vertical"===s.settings.mode?(n.each(function(i){e+=t(this).outerHeight()}),s.settings.slideMargin>0&&(e+=s.settings.slideMargin*(s.settings.minSlides-1))):e=Math.max.apply(Math,n.map(function(){return t(this).outerHeight(!1)}).get()),"border-box"===s.viewport.css("box-sizing")?e+=parseFloat(s.viewport.css("padding-top"))+parseFloat(s.viewport.css("padding-bottom"))+parseFloat(s.viewport.css("border-top-width"))+parseFloat(s.viewport.css("border-bottom-width")):"padding-box"===s.viewport.css("box-sizing")&&(e+=parseFloat(s.viewport.css("padding-top"))+parseFloat(s.viewport.css("padding-bottom"))),e},u=function(){var t="100%";return s.settings.slideWidth>0&&(t="horizontal"===s.settings.mode?s.settings.maxSlides*s.settings.slideWidth+(s.settings.maxSlides-1)*s.settings.slideMargin:s.settings.slideWidth),t},h=function(){var t=s.settings.slideWidth,e=s.viewport.width();if(0===s.settings.slideWidth||s.settings.slideWidth>e&&!s.carousel||"vertical"===s.settings.mode)t=e;else if(s.settings.maxSlides>1&&"horizontal"===s.settings.mode){if(e>s.maxThreshold)return t;e<s.minThreshold?t=(e-s.settings.slideMargin*(s.settings.minSlides-1))/s.settings.minSlides:s.settings.shrinkItems&&(t=Math.floor((e+s.settings.slideMargin)/Math.ceil((e+s.settings.slideMargin)/(t+s.settings.slideMargin))-s.settings.slideMargin))}return t},v=function(){var t=1,e=null;return"horizontal"===s.settings.mode&&s.settings.slideWidth>0?s.viewport.width()<s.minThreshold?t=s.settings.minSlides:s.viewport.width()>s.maxThreshold?t=s.settings.maxSlides:(e=s.children.first().width()+s.settings.slideMargin,t=Math.floor((s.viewport.width()+s.settings.slideMargin)/e)||1):"vertical"===s.settings.mode&&(t=s.settings.minSlides),t},f=function(){var t=0,e=0,i=0;if(s.settings.moveSlides>0){if(!s.settings.infiniteLoop){for(;e<s.children.length;)++t,e=i+v(),i+=s.settings.moveSlides<=v()?s.settings.moveSlides:v();return i}t=Math.ceil(s.children.length/x())}else t=Math.ceil(s.children.length/v());return t},x=function(){return s.settings.moveSlides>0&&s.settings.moveSlides<=v()?s.settings.moveSlides:v()},m=function(){var t,e,i;s.children.length>s.settings.maxSlides&&s.active.last&&!s.settings.infiniteLoop?"horizontal"===s.settings.mode?(e=s.children.last(),t=e.position(),S(-(t.left-(s.viewport.width()-e.outerWidth())),"reset",0)):"vertical"===s.settings.mode&&(i=s.children.length-s.settings.minSlides,t=s.children.eq(i).position(),S(-t.top,"reset",0)):(t=s.children.eq(s.active.index*x()).position(),s.active.index===f()-1&&(s.active.last=!0),void 0!==t&&("horizontal"===s.settings.mode?S(-t.left,"reset",0):"vertical"===s.settings.mode&&S(-t.top,"reset",0)))},S=function(e,i,n,r){var a,l;s.usingCSS?(l="vertical"===s.settings.mode?"translate3d(0, "+e+"px, 0)":"translate3d("+e+"px, 0, 0)",o.css("-"+s.cssPrefix+"-transition-duration",n/1e3+"s"),"slide"===i?(o.css(s.animProp,l),0!==n?o.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(e){t(e.target).is(o)&&(o.off("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),A())}):A()):"reset"===i?o.css(s.animProp,l):"ticker"===i&&(o.css("-"+s.cssPrefix+"-transition-timing-function","linear"),o.css(s.animProp,l),0!==n?o.on("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",function(e){t(e.target).is(o)&&(o.off("transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"),S(r.resetValue,"reset",0),F())}):(S(r.resetValue,"reset",0),F()))):(a={},a[s.animProp]=e,"slide"===i?o.animate(a,n,s.settings.easing,function(){A()}):"reset"===i?o.css(s.animProp,e):"ticker"===i&&o.animate(a,n,"linear",function(){S(r.resetValue,"reset",0),F()}))},w=function(){for(var e="",i="",n=f(),o=0;o<n;o++)i="",s.settings.buildPager&&t.isFunction(s.settings.buildPager)||s.settings.pagerCustom?(i=s.settings.buildPager(o),s.pagerEl.addClass("bx-custom-pager")):(i=o+1,s.pagerEl.addClass("bx-default-pager")),e+='<div class="bx-pager-item"><a href="" data-slide-index="'+o+'" class="bx-pager-link">'+i+"</a></div>";s.pagerEl.html(e)},b=function(){s.settings.pagerCustom?s.pagerEl=t(s.settings.pagerCustom):(s.pagerEl=t('<div class="bx-pager" />'),s.settings.pagerSelector?t(s.settings.pagerSelector).html(s.pagerEl):s.controls.el.addClass("bx-has-pager").append(s.pagerEl),w()),s.pagerEl.on("click touchend","a",I)},C=function(){s.controls.next=t('<a class="bx-next" href="">'+s.settings.nextText+"</a>"),s.controls.prev=t('<a class="bx-prev" href="">'+s.settings.prevText+"</a>"),s.controls.next.on("click touchend",P),s.controls.prev.on("click touchend",E),s.settings.nextSelector&&t(s.settings.nextSelector).append(s.controls.next),s.settings.prevSelector&&t(s.settings.prevSelector).append(s.controls.prev),s.settings.nextSelector||s.settings.prevSelector||(s.controls.directionEl=t('<div class="bx-controls-direction" />'),s.controls.directionEl.append(s.controls.prev).append(s.controls.next),s.controls.el.addClass("bx-has-controls-direction").append(s.controls.directionEl))},T=function(){s.controls.start=t('<div class="bx-controls-auto-item"><a class="bx-start" href="">'+s.settings.startText+"</a></div>"),s.controls.stop=t('<div class="bx-controls-auto-item"><a class="bx-stop" href="">'+s.settings.stopText+"</a></div>"),s.controls.autoEl=t('<div class="bx-controls-auto" />'),s.controls.autoEl.on("click",".bx-start",M),s.controls.autoEl.on("click",".bx-stop",y),s.settings.autoControlsCombine?s.controls.autoEl.append(s.controls.start):s.controls.autoEl.append(s.controls.start).append(s.controls.stop),s.settings.autoControlsSelector?t(s.settings.autoControlsSelector).html(s.controls.autoEl):s.controls.el.addClass("bx-has-controls-auto").append(s.controls.autoEl),D(s.settings.autoStart?"stop":"start")},k=function(){s.children.each(function(e){var i=t(this).find("img:first").attr("title");void 0!==i&&(""+i).length&&t(this).append('<div class="bx-caption"><span>'+i+"</span></div>")})},P=function(t){t.preventDefault(),s.controls.el.hasClass("disabled")||(s.settings.auto&&s.settings.stopAutoOnClick&&o.stopAuto(),o.goToNextSlide())},E=function(t){t.preventDefault(),s.controls.el.hasClass("disabled")||(s.settings.auto&&s.settings.stopAutoOnClick&&o.stopAuto(),o.goToPrevSlide())},M=function(t){o.startAuto(),t.preventDefault()},y=function(t){o.stopAuto(),t.preventDefault()},I=function(e){var i,n;e.preventDefault(),s.controls.el.hasClass("disabled")||(s.settings.auto&&s.settings.stopAutoOnClick&&o.stopAuto(),i=t(e.currentTarget),void 0!==i.attr("data-slide-index")&&(n=parseInt(i.attr("data-slide-index")))!==s.active.index&&o.goToSlide(n))},z=function(e){var i=s.children.length;if("short"===s.settings.pagerType)return s.settings.maxSlides>1&&(i=Math.ceil(s.children.length/s.settings.maxSlides)),void s.pagerEl.html(e+1+s.settings.pagerShortSeparator+i);s.pagerEl.find("a").removeClass("active"),s.pagerEl.each(function(i,n){t(n).find("a").eq(e).addClass("active")})},A=function(){if(s.settings.infiniteLoop){var t="";0===s.active.index?t=s.children.eq(0).position():s.active.index===f()-1&&s.carousel?t=s.children.eq((f()-1)*x()).position():s.active.index===s.children.length-1&&(t=s.children.eq(s.children.length-1).position()),t&&("horizontal"===s.settings.mode?S(-t.left,"reset",0):"vertical"===s.settings.mode&&S(-t.top,"reset",0))}s.working=!1,s.settings.onSlideAfter.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index)},D=function(t){s.settings.autoControlsCombine?s.controls.autoEl.html(s.controls[t]):(s.controls.autoEl.find("a").removeClass("active"),s.controls.autoEl.find("a:not(.bx-"+t+")").addClass("active"))},q=function(){1===f()?(s.controls.prev.addClass("disabled"),s.controls.next.addClass("disabled")):!s.settings.infiniteLoop&&s.settings.hideControlOnEnd&&(0===s.active.index?(s.controls.prev.addClass("disabled"),s.controls.next.removeClass("disabled")):s.active.index===f()-1?(s.controls.next.addClass("disabled"),s.controls.prev.removeClass("disabled")):(s.controls.prev.removeClass("disabled"),s.controls.next.removeClass("disabled")))},H=function(){o.startAuto()},W=function(){o.stopAuto()},L=function(){s.settings.autoDelay>0?setTimeout(o.startAuto,s.settings.autoDelay):(o.startAuto(),t(window).focus(H).blur(W)),s.settings.autoHover&&o.hover(function(){s.interval&&(o.stopAuto(!0),s.autoPaused=!0)},function(){s.autoPaused&&(o.startAuto(!0),s.autoPaused=null)})},O=function(){var e,i,n,r,a,l,d,c,g=0;"next"===s.settings.autoDirection?o.append(s.children.clone().addClass("bx-clone")):(o.prepend(s.children.clone().addClass("bx-clone")),e=s.children.first().position(),g="horizontal"===s.settings.mode?-e.left:-e.top),S(g,"reset",0),s.settings.pager=!1,s.settings.controls=!1,s.settings.autoControls=!1,s.settings.tickerHover&&(s.usingCSS?(r="horizontal"===s.settings.mode?4:5,s.viewport.hover(function(){i=o.css("-"+s.cssPrefix+"-transform"),n=parseFloat(i.split(",")[r]),S(n,"reset",0)},function(){c=0,s.children.each(function(e){c+="horizontal"===s.settings.mode?t(this).outerWidth(!0):t(this).outerHeight(!0)}),a=s.settings.speed/c,l="horizontal"===s.settings.mode?"left":"top",d=a*(c-Math.abs(parseInt(n))),F(d)})):s.viewport.hover(function(){o.stop()},function(){c=0,s.children.each(function(e){c+="horizontal"===s.settings.mode?t(this).outerWidth(!0):t(this).outerHeight(!0)}),a=s.settings.speed/c,l="horizontal"===s.settings.mode?"left":"top",d=a*(c-Math.abs(parseInt(o.css(l)))),F(d)})),F()},F=function(t){var e,i,n,r=t||s.settings.speed,a={left:0,top:0},l={left:0,top:0};"next"===s.settings.autoDirection?a=o.find(".bx-clone").first().position():l=s.children.first().position(),e="horizontal"===s.settings.mode?-a.left:-a.top,i="horizontal"===s.settings.mode?-l.left:-l.top,n={resetValue:i},S(e,"ticker",r,n)},N=function(e){var i=t(window),n={top:i.scrollTop(),left:i.scrollLeft()},s=e.offset();return n.right=n.left+i.width(),n.bottom=n.top+i.height(),s.right=s.left+e.outerWidth(),s.bottom=s.top+e.outerHeight(),!(n.right<s.left||n.left>s.right||n.bottom<s.top||n.top>s.bottom)},B=function(t){var e=document.activeElement.tagName.toLowerCase();if(null==new RegExp(e,["i"]).exec("input|textarea")&&N(o)){if(39===t.keyCode)return P(t),!1;if(37===t.keyCode)return E(t),!1}},X=function(){s.touch={start:{x:0,y:0},end:{x:0,y:0}},s.viewport.on("touchstart MSPointerDown pointerdown",Y),s.viewport.on("click",".bxslider a",function(t){s.viewport.hasClass("click-disabled")&&(t.preventDefault(),s.viewport.removeClass("click-disabled"))})},Y=function(e){if(!t(e.target).is("a")&&("touchstart"===e.type||0===e.button))if(e.preventDefault(),s.controls.el.addClass("disabled"),s.working)s.controls.el.removeClass("disabled");else{s.touch.originalPos=o.position();var i=e.originalEvent,n=void 0!==i.changedTouches?i.changedTouches:[i],r="function"==typeof PointerEvent;if(r&&void 0===i.pointerId)return;s.touch.start.x=n[0].pageX,s.touch.start.y=n[0].pageY,s.viewport.get(0).setPointerCapture&&(s.pointerId=i.pointerId,s.viewport.get(0).setPointerCapture(s.pointerId)),s.originalClickTarget=i.originalTarget||i.target,s.originalClickButton=i.button,s.originalClickButtons=i.buttons,s.originalEventType=i.type,s.hasMove=!1,s.viewport.on("touchmove MSPointerMove pointermove",R),s.viewport.on("touchend MSPointerUp pointerup",Z),s.viewport.on("MSPointerCancel pointercancel",V)}},V=function(t){t.preventDefault(),S(s.touch.originalPos.left,"reset",0),s.controls.el.removeClass("disabled"),s.viewport.off("MSPointerCancel pointercancel",V),s.viewport.off("touchmove MSPointerMove pointermove",R),s.viewport.off("touchend MSPointerUp pointerup",Z),s.viewport.get(0).releasePointerCapture&&s.viewport.get(0).releasePointerCapture(s.pointerId)},R=function(t){var e=t.originalEvent,i=void 0!==e.changedTouches?e.changedTouches:[e],n=Math.abs(i[0].pageX-s.touch.start.x),o=Math.abs(i[0].pageY-s.touch.start.y),r=0,a=0;s.hasMove=!0,3*n>o&&s.settings.preventDefaultSwipeX?t.preventDefault():3*o>n&&s.settings.preventDefaultSwipeY&&t.preventDefault(),"touchmove"!==t.type&&t.preventDefault(),"fade"!==s.settings.mode&&s.settings.oneToOneTouch&&("horizontal"===s.settings.mode?(a=i[0].pageX-s.touch.start.x,r=s.touch.originalPos.left+a):(a=i[0].pageY-s.touch.start.y,r=s.touch.originalPos.top+a),S(r,"reset",0))},Z=function(e){e.preventDefault(),s.viewport.off("touchmove MSPointerMove pointermove",R),s.controls.el.removeClass("disabled");var i=e.originalEvent,n=void 0!==i.changedTouches?i.changedTouches:[i],r=0,a=0;s.touch.end.x=n[0].pageX,s.touch.end.y=n[0].pageY,"fade"===s.settings.mode?(a=Math.abs(s.touch.start.x-s.touch.end.x))>=s.settings.swipeThreshold&&(s.touch.start.x>s.touch.end.x?o.goToNextSlide():o.goToPrevSlide(),o.stopAuto()):("horizontal"===s.settings.mode?(a=s.touch.end.x-s.touch.start.x,r=s.touch.originalPos.left):(a=s.touch.end.y-s.touch.start.y,r=s.touch.originalPos.top),!s.settings.infiniteLoop&&(0===s.active.index&&a>0||s.active.last&&a<0)?S(r,"reset",200):Math.abs(a)>=s.settings.swipeThreshold?(a<0?o.goToNextSlide():o.goToPrevSlide(),o.stopAuto()):S(r,"reset",200)),s.viewport.off("touchend MSPointerUp pointerup",Z),s.viewport.get(0).releasePointerCapture&&s.viewport.get(0).releasePointerCapture(s.pointerId),!1!==s.hasMove||0!==s.originalClickButton&&"touchstart"!==s.originalEventType||t(s.originalClickTarget).trigger({type:"click",button:s.originalClickButton,buttons:s.originalClickButtons})},U=function(e){if(s.initialized)if(s.working)window.setTimeout(U,10);else{var i=t(window).width(),n=t(window).height();r===i&&a===n||(r=i,a=n,o.redrawSlider(),s.settings.onSliderResize.call(o,s.active.index))}},j=function(t){var e=v();s.settings.ariaHidden&&!s.settings.ticker&&(s.children.attr("aria-hidden","true"),s.children.slice(t,t+e).attr("aria-hidden","false"))},Q=function(t){return t<0?s.settings.infiniteLoop?f()-1:s.active.index:t>=f()?s.settings.infiniteLoop?0:s.active.index:t};return o.goToSlide=function(e,i){var n,r,a,l,d=!0,c=0,g={left:0,top:0},u=null;if(s.oldIndex=s.active.index,s.active.index=Q(e),!s.working&&s.active.index!==s.oldIndex){if(s.working=!0,void 0!==(d=s.settings.onSlideBefore.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index))&&!d)return s.active.index=s.oldIndex,void(s.working=!1);"next"===i?s.settings.onSlideNext.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index)||(d=!1):"prev"===i&&(s.settings.onSlidePrev.call(o,s.children.eq(s.active.index),s.oldIndex,s.active.index)||(d=!1)),s.active.last=s.active.index>=f()-1,(s.settings.pager||s.settings.pagerCustom)&&z(s.active.index),s.settings.controls&&q(),"fade"===s.settings.mode?(s.settings.adaptiveHeight&&s.viewport.height()!==p()&&s.viewport.animate({height:p()},s.settings.adaptiveHeightSpeed),s.children.filter(":visible").fadeOut(s.settings.speed).css({zIndex:0}),s.children.eq(s.active.index).css("zIndex",s.settings.slideZIndex+1).fadeIn(s.settings.speed,function(){t(this).css("zIndex",s.settings.slideZIndex),A()})):(s.settings.adaptiveHeight&&s.viewport.height()!==p()&&s.viewport.animate({height:p()},s.settings.adaptiveHeightSpeed),!s.settings.infiniteLoop&&s.carousel&&s.active.last?"horizontal"===s.settings.mode?(u=s.children.eq(s.children.length-1),g=u.position(),c=s.viewport.width()-u.outerWidth()):(n=s.children.length-s.settings.minSlides,g=s.children.eq(n).position()):s.carousel&&s.active.last&&"prev"===i?(r=1===s.settings.moveSlides?s.settings.maxSlides-x():(f()-1)*x()-(s.children.length-s.settings.maxSlides),u=o.children(".bx-clone").eq(r),g=u.position()):"next"===i&&0===s.active.index?(g=o.find("> .bx-clone").eq(s.settings.maxSlides).position(),s.active.last=!1):e>=0&&(l=e*parseInt(x()),g=s.children.eq(l).position()),void 0!==g&&(a="horizontal"===s.settings.mode?-(g.left-c):-g.top,S(a,"slide",s.settings.speed)),s.working=!1),s.settings.ariaHidden&&j(s.active.index*x())}},o.goToNextSlide=function(){if((s.settings.infiniteLoop||!s.active.last)&&!0!==s.working){var t=parseInt(s.active.index)+1;o.goToSlide(t,"next")}},o.goToPrevSlide=function(){if((s.settings.infiniteLoop||0!==s.active.index)&&!0!==s.working){var t=parseInt(s.active.index)-1;o.goToSlide(t,"prev")}},o.startAuto=function(t){s.interval||(s.interval=setInterval(function(){"next"===s.settings.autoDirection?o.goToNextSlide():o.goToPrevSlide()},s.settings.pause),s.settings.onAutoChange.call(o,!0),s.settings.autoControls&&!0!==t&&D("stop"))},o.stopAuto=function(t){s.autoPaused&&(s.autoPaused=!1),s.interval&&(clearInterval(s.interval),s.interval=null,s.settings.onAutoChange.call(o,!1),s.settings.autoControls&&!0!==t&&D("start"))},o.getCurrentSlide=function(){return s.active.index},o.getCurrentSlideElement=function(){return s.children.eq(s.active.index)},o.getSlideElement=function(t){return s.children.eq(t)},o.getSlideCount=function(){return s.children.length},o.isWorking=function(){return s.working},o.redrawSlider=function(){s.children.add(o.find(".bx-clone")).outerWidth(h()),s.viewport.css("height",p()),s.settings.ticker||m(),s.active.last&&(s.active.index=f()-1),s.active.index>=f()&&(s.active.last=!0),s.settings.pager&&!s.settings.pagerCustom&&(w(),z(s.active.index)),s.settings.ariaHidden&&j(s.active.index*x())},o.destroySlider=function(){s.initialized&&(s.initialized=!1,t(".bx-clone",this).remove(),s.children.each(function(){void 0!==t(this).data("origStyle")?t(this).attr("style",t(this).data("origStyle")):t(this).removeAttr("style")}),void 0!==t(this).data("origStyle")?this.attr("style",t(this).data("origStyle")):t(this).removeAttr("style"),t(this).unwrap().unwrap(),s.controls.el&&s.controls.el.remove(),s.controls.next&&s.controls.next.remove(),s.controls.prev&&s.controls.prev.remove(),s.pagerEl&&s.settings.controls&&!s.settings.pagerCustom&&s.pagerEl.remove(),t(".bx-caption",this).remove(),s.controls.autoEl&&s.controls.autoEl.remove(),clearInterval(s.interval),s.settings.responsive&&t(window).off("resize",U),s.settings.keyboardEnabled&&t(document).off("keydown",B),t(this).removeData("bxSlider"),t(window).off("blur",W).off("focus",H))},o.reloadSlider=function(e){void 0!==e&&(n=e),o.destroySlider(),l(),t(o).data("bxSlider",this)},l(),t(o).data("bxSlider",this),this}}}(jQuery);
/*!
  * VERSION: 1.15.0
  * DATE: 2014-12-03
  * UPDATES AND DOCS AT: http://www.greensock.com
  * 
  * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
  *
  * @license Copyright (c) 2008-2014, GreenSock. All rights reserved.
  * This work is subject to the terms at http://www.greensock.com/terms_of_use.html or for
  * Club GreenSock members, the software agreement that was issued with your membership.
  * 
  * @author: Jack Doyle, jack@greensock.com
  **/
var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;
(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function() {
      _gsScope._gsDefine("TweenMax", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(z, q, k) {
              var A = function(c) {
                      var l, a = [],
                          h = c.length;
                      for (l = 0; l !== h; a.push(c[l++])) {}
                      return a
                  },
                  b = function(a, h, c) {
                      k.call(this, a, h, c), this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._dirty = !0, this.render = b.prototype.render
                  },
                  g = 1e-10,
                  w = k._internals,
                  f = w.isSelector,
                  m = w.isArray,
                  j = b.prototype = k.to({}, 0.1, {}),
                  x = [];
              b.version = "1.15.0", j.constructor = b, j.kill()._gc = !1, b.killTweensOf = b.killDelayedCallsTo = k.killTweensOf, b.getTweensOf = k.getTweensOf, b.lagSmoothing = k.lagSmoothing, b.ticker = k.ticker, b.render = k.render, j.invalidate = function() {
                  return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), k.prototype.invalidate.call(this)
              }, j.updateTo = function(E, C) {
                  var F, c = this.ratio,
                      p = this.vars.immediateRender || E.immediateRender;
                  C && this._startTime < this._timeline._time && (this._startTime = this._timeline._time, this._uncache(!1), this._gc ? this._enabled(!0, !1) : this._timeline.insert(this, this._startTime - this._delay));
                  for (F in E) {
                      this.vars[F] = E[F]
                  }
                  if (this._initted || p) {
                      if (C) {
                          this._initted = !1, p && this.render(0, !0, !0)
                      } else {
                          if (this._gc && this._enabled(!0, !1), this._notifyPluginsOfEnabled && this._firstPT && k._onPluginEvent("_onDisable", this), this._time / this._duration > 0.998) {
                              var D = this._time;
                              this.render(0, !0, !1), this._initted = !1, this.render(D, !0, !1)
                          } else {
                              if (this._time > 0 || p) {
                                  this._initted = !1, this._init();
                                  for (var i, B = 1 / (1 - c), u = this._firstPT; u;) {
                                      i = u.s + u.c, u.c *= B, u.s = i - u.c, u = u._next
                                  }
                              }
                          }
                      }
                  }
                  return this
              }, j.render = function(O, I, E) {
                  this._initted || 0 === this._duration && this.vars.repeat && this.invalidate();
                  var P, a, B, F, D, N, n, K, H = this._dirty ? this.totalDuration() : this._totalDuration,
                      C = this._time,
                      J = this._totalTime,
                      G = this._cycle,
                      M = this._duration,
                      L = this._rawPrevTime;
                  if (O >= H ? (this._totalTime = H, this._cycle = this._repeat, this._yoyo && 0 !== (1 & this._cycle) ? (this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0) : (this._time = M, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1), this._reversed || (P = !0, a = "onComplete"), 0 === M && (this._initted || !this.vars.lazy || E) && (this._startTime === this._timeline._duration && (O = 0), (0 === O || 0 > L || L === g) && L !== O && (E = !0, L > g && (a = "onReverseComplete")), this._rawPrevTime = K = !I || O || L === O ? O : g)) : 1e-7 > O ? (this._totalTime = this._time = this._cycle = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== J || 0 === M && L > 0 && L !== g) && (a = "onReverseComplete", P = this._reversed), 0 > O && (this._active = !1, 0 === M && (this._initted || !this.vars.lazy || E) && (L >= 0 && (E = !0), this._rawPrevTime = K = !I || O || L === O ? O : g)), this._initted || (E = !0)) : (this._totalTime = this._time = O, 0 !== this._repeat && (F = M + this._repeatDelay, this._cycle = this._totalTime / F >> 0, 0 !== this._cycle && this._cycle === this._totalTime / F && this._cycle--, this._time = this._totalTime - this._cycle * F, this._yoyo && 0 !== (1 & this._cycle) && (this._time = M - this._time), this._time > M ? this._time = M : 0 > this._time && (this._time = 0)), this._easeType ? (D = this._time / M, N = this._easeType, n = this._easePower, (1 === N || 3 === N && D >= 0.5) && (D = 1 - D), 3 === N && (D *= 2), 1 === n ? D *= D : 2 === n ? D *= D * D : 3 === n ? D *= D * D * D : 4 === n && (D *= D * D * D * D), this.ratio = 1 === N ? 1 - D : 2 === N ? D : 0.5 > this._time / M ? D / 2 : 1 - D / 2) : this.ratio = this._ease.getRatio(this._time / M)), C === this._time && !E && G === this._cycle) {
                      return J !== this._totalTime && this._onUpdate && (I || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || x)), void 0
                  }
                  if (!this._initted) {
                      if (this._init(), !this._initted || this._gc) {
                          return
                      }
                      if (!E && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) {
                          return this._time = C, this._totalTime = J, this._rawPrevTime = L, this._cycle = G, w.lazyTweens.push(this), this._lazy = [O, I], void 0
                      }
                      this._time && !P ? this.ratio = this._ease.getRatio(this._time / M) : P && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
                  }
                  for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== C && O >= 0 && (this._active = !0), 0 === J && (2 === this._initted && O > 0 && this._init(), this._startAt && (O >= 0 ? this._startAt.render(O, I, E) : a || (a = "_dummyGS")), this.vars.onStart && (0 !== this._totalTime || 0 === M) && (I || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || x))), B = this._firstPT; B;) {
                      B.f ? B.t[B.p](B.c * this.ratio + B.s) : B.t[B.p] = B.c * this.ratio + B.s, B = B._next
                  }
                  this._onUpdate && (0 > O && this._startAt && this._startTime && this._startAt.render(O, I, E), I || (this._totalTime !== J || P) && this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || x)), this._cycle !== G && (I || this._gc || this.vars.onRepeat && this.vars.onRepeat.apply(this.vars.onRepeatScope || this, this.vars.onRepeatParams || x)), a && (!this._gc || E) && (0 > O && this._startAt && !this._onUpdate && this._startTime && this._startAt.render(O, I, E), P && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !I && this.vars[a] && this.vars[a].apply(this.vars[a + "Scope"] || this, this.vars[a + "Params"] || x), 0 === M && this._rawPrevTime === g && K !== g && (this._rawPrevTime = 0))
              }, b.to = function(c, h, a) {
                  return new b(c, h, a)
              }, b.from = function(c, h, a) {
                  return a.runBackwards = !0, a.immediateRender = 0 != a.immediateRender, new b(c, h, a)
              }, b.fromTo = function(c, l, a, h) {
                  return h.startAt = a, h.immediateRender = 0 != h.immediateRender && 0 != a.immediateRender, new b(c, l, h)
              }, b.staggerTo = b.allTo = function(J, C, i, G, r, I, h) {
                  G = G || 0;
                  var E, B, o, D, s = i.delay || 0,
                      H = [],
                      F = function() {
                          i.onComplete && i.onComplete.apply(i.onCompleteScope || this, arguments), r.apply(h || this, I || x)
                      };
                  for (m(J) || ("string" == typeof J && (J = k.selector(J) || J), f(J) && (J = A(J))), J = J || [], 0 > G && (J = A(J), J.reverse(), G *= -1), E = J.length - 1, o = 0; E >= o; o++) {
                      B = {};
                      for (D in i) {
                          B[D] = i[D]
                      }
                      B.delay = s, o === E && r && (B.onComplete = F), H[o] = new b(J[o], C, B), s += G
                  }
                  return H
              }, b.staggerFrom = b.allFrom = function(l, r, h, p, B, c, u) {
                  return h.runBackwards = !0, h.immediateRender = 0 != h.immediateRender, b.staggerTo(l, r, h, p, B, c, u)
              }, b.staggerFromTo = b.allFromTo = function(p, B, l, u, D, c, C, r) {
                  return u.startAt = l, u.immediateRender = 0 != u.immediateRender && 0 != l.immediateRender, b.staggerTo(p, B, u, D, c, C, r)
              }, b.delayedCall = function(c, l, a, h, o) {
                  return new b(l, 0, {
                      delay: c,
                      onComplete: l,
                      onCompleteParams: a,
                      onCompleteScope: h,
                      onReverseComplete: l,
                      onReverseCompleteParams: a,
                      onReverseCompleteScope: h,
                      immediateRender: !1,
                      useFrames: o,
                      overwrite: 0
                  })
              }, b.set = function(a, c) {
                  return new b(a, 0, c)
              }, b.isTweening = function(a) {
                  return k.getTweensOf(a, !0).length > 0
              };
              var y = function(a, i) {
                      for (var c = [], h = 0, l = a._first; l;) {
                          l instanceof k ? c[h++] = l : (i && (c[h++] = l), c = c.concat(y(l, i)), h = c.length), l = l._next
                      }
                      return c
                  },
                  d = b.getAllTweens = function(a) {
                      return y(z._rootTimeline, a).concat(y(z._rootFramesTimeline, a))
                  };
              b.killAll = function(F, B, G, c) {
                  null == B && (B = !0), null == G && (G = !0);
                  var p, D, e, C = d(0 != c),
                      u = C.length,
                      E = B && G && c;
                  for (e = 0; u > e; e++) {
                      D = C[e], (E || D instanceof q || (p = D.target === D.vars.onComplete) && G || B && !p) && (F ? D.totalTime(D._reversed ? 0 : D.totalDuration()) : D._enabled(!1, !1))
                  }
              }, b.killChildTweensOf = function(o, s) {
                  if (null != o) {
                      var C, a, i, h, r, B = w.tweenLookup;
                      if ("string" == typeof o && (o = k.selector(o) || o), f(o) && (o = A(o)), m(o)) {
                          for (h = o.length; --h > -1;) {
                              b.killChildTweensOf(o[h], s)
                          }
                      } else {
                          C = [];
                          for (i in B) {
                              for (a = B[i].target.parentNode; a;) {
                                  a === o && (C = C.concat(B[i].tweens)), a = a.parentNode
                              }
                          }
                          for (r = C.length, h = 0; r > h; h++) {
                              s && C[h].totalTime(C[h].totalDuration()), C[h]._enabled(!1, !1)
                          }
                      }
                  }
              };
              var v = function(E, B, F, c) {
                  B = B !== !1, F = F !== !1, c = c !== !1;
                  for (var p, D, e = d(c), C = B && F && c, u = e.length; --u > -1;) {
                      D = e[u], (C || D instanceof q || (p = D.target === D.vars.onComplete) && F || B && !p) && D.paused(E)
                  }
              };
              return b.pauseAll = function(c, h, a) {
                  v(!0, c, h, a)
              }, b.resumeAll = function(c, h, a) {
                  v(!1, c, h, a)
              }, b.globalTimeScale = function(h) {
                  var a = z._rootTimeline,
                      c = k.ticker.time;
                  return arguments.length ? (h = h || g, a._startTime = c - (c - a._startTime) * a._timeScale / h, a = z._rootFramesTimeline, c = k.ticker.frame, a._startTime = c - (c - a._startTime) * a._timeScale / h, a._timeScale = z._rootTimeline._timeScale = h, h) : a._timeScale
              }, j.progress = function(a) {
                  return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), !1) : this._time / this.duration()
              }, j.totalProgress = function(a) {
                  return arguments.length ? this.totalTime(this.totalDuration() * a, !1) : this._totalTime / this.totalDuration()
              }, j.time = function(a, c) {
                  return arguments.length ? (this._dirty && this.totalDuration(), a > this._duration && (a = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? a = this._duration - a + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(a, c)) : this._time
              }, j.duration = function(a) {
                  return arguments.length ? z.prototype.duration.call(this, a) : this._duration
              }, j.totalDuration = function(a) {
                  return arguments.length ? -1 === this._repeat ? this : this.duration((a - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat, this._dirty = !1), this._totalDuration)
              }, j.repeat = function(a) {
                  return arguments.length ? (this._repeat = a, this._uncache(!0)) : this._repeat
              }, j.repeatDelay = function(a) {
                  return arguments.length ? (this._repeatDelay = a, this._uncache(!0)) : this._repeatDelay
              }, j.yoyo = function(a) {
                  return arguments.length ? (this._yoyo = a, this) : this._yoyo
              }, b
          }, !0), _gsScope._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function(D, y, v) {
              var E = function(c) {
                      y.call(this, c), this._labels = {}, this.autoRemoveChildren = this.vars.autoRemoveChildren === !0, this.smoothChildTiming = this.vars.smoothChildTiming === !0, this._sortChildren = !0, this._onUpdate = this.vars.onUpdate;
                      var a, e, f = this.vars;
                      for (e in f) {
                          a = f[e], g(a) && -1 !== a.join("").indexOf("{self}") && (f[e] = this._swapSelfInParams(a))
                      }
                      g(f.tweens) && this.add(f.tweens, 0, f.align, f.stagger)
                  },
                  b = 1e-10,
                  j = v._internals,
                  A = j.isSelector,
                  g = j.isArray,
                  w = j.lazyTweens,
                  q = j.lazyRender,
                  B = [],
                  C = _gsScope._gsDefine.globals,
                  d = function(c) {
                      var f, a = {};
                      for (f in c) {
                          a[f] = c[f]
                      }
                      return a
                  },
                  z = function(c, l, a, f) {
                      var h = c._timeline,
                          m = h._totalTime;
                      !l && this._forcingPlayhead || h._rawPrevTime === c._startTime || (h.pause(c._startTime), l && l.apply(f || h, a || B), this._forcingPlayhead && h.seek(m))
                  },
                  x = function(c) {
                      var h, a = [],
                          f = c.length;
                      for (h = 0; h !== f; a.push(c[h++])) {}
                      return a
                  },
                  k = E.prototype = new y;
              return E.version = "1.15.0", k.constructor = E, k.kill()._gc = k._forcingPlayhead = !1, k.to = function(a, h, c, f) {
                  var i = c.repeat && C.TweenMax || v;
                  return h ? this.add(new i(a, h, c), f) : this.set(a, c, f)
              }, k.from = function(a, h, c, f) {
                  return this.add((c.repeat && C.TweenMax || v).from(a, h, c), f)
              }, k.fromTo = function(f, l, h, i, m) {
                  var c = i.repeat && C.TweenMax || v;
                  return l ? this.add(c.fromTo(f, l, h, i), m) : this.set(f, i, m)
              }, k.staggerTo = function(I, s, a, i, f, p, m, G) {
                  var H, F = new E({
                      onComplete: p,
                      onCompleteParams: m,
                      onCompleteScope: G,
                      smoothChildTiming: this.smoothChildTiming
                  });
                  for ("string" == typeof I && (I = v.selector(I) || I), I = I || [], A(I) && (I = x(I)), i = i || 0, 0 > i && (I = x(I), I.reverse(), i *= -1), H = 0; I.length > H; H++) {
                      a.startAt && (a.startAt = d(a.startAt)), F.to(I[H], s, d(a), H * i)
                  }
                  return this.add(F, f)
              }, k.staggerFrom = function(h, p, f, l, m, F, c, u) {
                  return f.immediateRender = 0 != f.immediateRender, f.runBackwards = !0, this.staggerTo(h, p, f, l, m, F, c, u)
              }, k.staggerFromTo = function(G, u, m, H, c, l, F, f, p) {
                  return H.startAt = m, H.immediateRender = 0 != H.immediateRender && 0 != m.immediateRender, this.staggerTo(G, u, H, c, l, F, f, p)
              }, k.call = function(a, h, c, f) {
                  return this.add(v.delayedCall(0, a, h, c), f)
              }, k.set = function(a, f, c) {
                  return c = this._parseTimeOrLabel(c, 0, !0), null == f.immediateRender && (f.immediateRender = c === this._time && !this._paused), this.add(new v(a, 0, f), c)
              }, E.exportRoot = function(f, i) {
                  f = f || {}, null == f.smoothChildTiming && (f.smoothChildTiming = !0);
                  var h, m, c = new E(f),
                      l = c._timeline;
                  for (null == i && (i = !0), l._remove(c, !0), c._startTime = 0, c._rawPrevTime = c._time = c._totalTime = l._time, h = l._first; h;) {
                      m = h._next, i && h instanceof v && h.target === h.vars.onComplete || c.add(h, h._startTime - h._delay), h = m
                  }
                  return l.add(c, 0), c
              }, k.add = function(e, m, G, s) {
                  var o, H, I, i, F, t;
                  if ("number" != typeof m && (m = this._parseTimeOrLabel(m, 0, !0, e)), !(e instanceof D)) {
                      if (e instanceof Array || e && e.push && g(e)) {
                          for (G = G || "normal", s = s || 0, o = m, H = e.length, I = 0; H > I; I++) {
                              g(i = e[I]) && (i = new E({
                                  tweens: i
                              })), this.add(i, o), "string" != typeof i && "function" != typeof i && ("sequence" === G ? o = i._startTime + i.totalDuration() / i._timeScale : "start" === G && (i._startTime -= i.delay())), o += s
                          }
                          return this._uncache(!0)
                      }
                      if ("string" == typeof e) {
                          return this.addLabel(e, m)
                      }
                      if ("function" != typeof e) {
                          throw "Cannot add " + e + " into the timeline; it is not a tween, timeline, function, or string."
                      }
                      e = v.delayedCall(0, e)
                  }
                  if (y.prototype.add.call(this, e, m), (this._gc || this._time === this._duration) && !this._paused && this._duration < this.duration()) {
                      for (F = this, t = F.rawTime() > e._startTime; F._timeline;) {
                          t && F._timeline.smoothChildTiming ? F.totalTime(F._totalTime, !0) : F._gc && F._enabled(!0, !1), F = F._timeline
                      }
                  }
                  return this
              }, k.remove = function(c) {
                  if (c instanceof D) {
                      return this._remove(c, !1)
                  }
                  if (c instanceof Array || c && c.push && g(c)) {
                      for (var a = c.length; --a > -1;) {
                          this.remove(c[a])
                      }
                      return this
                  }
                  return "string" == typeof c ? this.removeLabel(c) : this.kill(null, c)
              }, k._remove = function(c, a) {
                  y.prototype._remove.call(this, c, a);
                  var e = this._last;
                  return e ? this._time > e._startTime + e._totalDuration / e._timeScale && (this._time = this.duration(), this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0, this
              }, k.append = function(a, c) {
                  return this.add(a, this._parseTimeOrLabel(null, c, !0, a))
              }, k.insert = k.insertMultiple = function(c, h, a, f) {
                  return this.add(c, h || 0, a, f)
              }, k.appendMultiple = function(c, h, a, f) {
                  return this.add(c, this._parseTimeOrLabel(null, h, !0, c), a, f)
              }, k.addLabel = function(a, c) {
                  return this._labels[a] = this._parseTimeOrLabel(c), this
              }, k.addPause = function(a, h, c, f) {
                  var i = v.delayedCall(0, z, ["{self}", h, c, f], this);
                  return i.data = "isPause", this.add(i, a)
              }, k.removeLabel = function(a) {
                  return delete this._labels[a], this
              }, k.getLabelTime = function(a) {
                  return null != this._labels[a] ? this._labels[a] : -1
              }, k._parseTimeOrLabel = function(h, a, c, f) {
                  var l;
                  if (f instanceof D && f.timeline === this) {
                      this.remove(f)
                  } else {
                      if (f && (f instanceof Array || f.push && g(f))) {
                          for (l = f.length; --l > -1;) {
                              f[l] instanceof D && f[l].timeline === this && this.remove(f[l])
                          }
                      }
                  }
                  if ("string" == typeof a) {
                      return this._parseTimeOrLabel(a, c && "number" == typeof h && null == this._labels[a] ? h - this.duration() : 0, c)
                  }
                  if (a = a || 0, "string" != typeof h || !isNaN(h) && null == this._labels[h]) {
                      null == h && (h = this.duration())
                  } else {
                      if (l = h.indexOf("="), -1 === l) {
                          return null == this._labels[h] ? c ? this._labels[h] = this.duration() + a : a : this._labels[h] + a
                      }
                      a = parseInt(h.charAt(l - 1) + "1", 10) * Number(h.substr(l + 1)), h = l > 1 ? this._parseTimeOrLabel(h.substr(0, l - 1), 0, c) : this.duration()
                  }
                  return Number(h) + a
              }, k.seek = function(a, c) {
                  return this.totalTime("number" == typeof a ? a : this._parseTimeOrLabel(a), c !== !1)
              }, k.stop = function() {
                  return this.paused(!0)
              }, k.gotoAndPlay = function(a, c) {
                  return this.play(a, c)
              }, k.gotoAndStop = function(a, c) {
                  return this.pause(a, c)
              }, k.render = function(N, I, G) {
                  this._gc && this._enabled(!0, !1);
                  var O, r, L, l, M, h = this._dirty ? this.totalDuration() : this._totalDuration,
                      K = this._time,
                      H = this._startTime,
                      F = this._timeScale,
                      J = this._paused;
                  if (N >= h ? (this._totalTime = this._time = h, this._reversed || this._hasPausedChild() || (r = !0, l = "onComplete", 0 === this._duration && (0 === N || 0 > this._rawPrevTime || this._rawPrevTime === b) && this._rawPrevTime !== N && this._first && (M = !0, this._rawPrevTime > b && (l = "onReverseComplete"))), this._rawPrevTime = this._duration || !I || N || this._rawPrevTime === N ? N : b, N = h + 0.0001) : 1e-7 > N ? (this._totalTime = this._time = 0, (0 !== K || 0 === this._duration && this._rawPrevTime !== b && (this._rawPrevTime > 0 || 0 > N && this._rawPrevTime >= 0)) && (l = "onReverseComplete", r = this._reversed), 0 > N ? (this._active = !1, this._rawPrevTime >= 0 && this._first && (M = !0), this._rawPrevTime = N) : (this._rawPrevTime = this._duration || !I || N || this._rawPrevTime === N ? N : b, N = 0, this._initted || (M = !0))) : this._totalTime = this._time = this._rawPrevTime = N, this._time !== K && this._first || G || M) {
                      if (this._initted || (this._initted = !0), this._active || !this._paused && this._time !== K && N > 0 && (this._active = !0), 0 === K && this.vars.onStart && 0 !== this._time && (I || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || B)), this._time >= K) {
                          for (O = this._first; O && (L = O._next, !this._paused || J);) {
                              (O._active || O._startTime <= this._time && !O._paused && !O._gc) && (O._reversed ? O.render((O._dirty ? O.totalDuration() : O._totalDuration) - (N - O._startTime) * O._timeScale, I, G) : O.render((N - O._startTime) * O._timeScale, I, G)), O = L
                          }
                      } else {
                          for (O = this._last; O && (L = O._prev, !this._paused || J);) {
                              (O._active || K >= O._startTime && !O._paused && !O._gc) && (O._reversed ? O.render((O._dirty ? O.totalDuration() : O._totalDuration) - (N - O._startTime) * O._timeScale, I, G) : O.render((N - O._startTime) * O._timeScale, I, G)), O = L
                          }
                      }
                      this._onUpdate && (I || (w.length && q(), this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || B))), l && (this._gc || (H === this._startTime || F !== this._timeScale) && (0 === this._time || h >= this.totalDuration()) && (r && (w.length && q(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !I && this.vars[l] && this.vars[l].apply(this.vars[l + "Scope"] || this, this.vars[l + "Params"] || B)))
                  }
              }, k._hasPausedChild = function() {
                  for (var a = this._first; a;) {
                      if (a._paused || a instanceof E && a._hasPausedChild()) {
                          return !0
                      }
                      a = a._next
                  }
                  return !1
              }, k.getChildren = function(f, l, h, i) {
                  i = i || -9999999999;
                  for (var p = [], c = this._first, m = 0; c;) {
                      i > c._startTime || (c instanceof v ? l !== !1 && (p[m++] = c) : (h !== !1 && (p[m++] = c), f !== !1 && (p = p.concat(c.getChildren(!0, l, h)), m = p.length))), c = c._next
                  }
                  return p
              }, k.getTweensOf = function(f, l) {
                  var h, i, p = this._gc,
                      c = [],
                      m = 0;
                  for (p && this._enabled(!0, !0), h = v.getTweensOf(f), i = h.length; --i > -1;) {
                      (h[i].timeline === this || l && this._contains(h[i])) && (c[m++] = h[i])
                  }
                  return p && this._enabled(!1, !0), c
              }, k.recent = function() {
                  return this._recent
              }, k._contains = function(a) {
                  for (var c = a.timeline; c;) {
                      if (c === this) {
                          return !0
                      }
                      c = c.timeline
                  }
                  return !1
              }, k.shiftChildren = function(c, l, a) {
                  a = a || 0;
                  for (var f, h = this._first, m = this._labels; h;) {
                      h._startTime >= a && (h._startTime += c), h = h._next
                  }
                  if (l) {
                      for (f in m) {
                          m[f] >= a && (m[f] += c)
                      }
                  }
                  return this._uncache(!0)
              }, k._kill = function(c, l) {
                  if (!c && !l) {
                      return this._enabled(!1, !1)
                  }
                  for (var a = l ? this.getTweensOf(l) : this.getChildren(!0, !0, !1), f = a.length, h = !1; --f > -1;) {
                      a[f]._kill(c, l) && (h = !0)
                  }
                  return h
              }, k.clear = function(c) {
                  var f = this.getChildren(!1, !0, !0),
                      a = f.length;
                  for (this._time = this._totalTime = 0; --a > -1;) {
                      f[a]._enabled(!1, !1)
                  }
                  return c !== !1 && (this._labels = {}), this._uncache(!0)
              }, k.invalidate = function() {
                  for (var a = this._first; a;) {
                      a.invalidate(), a = a._next
                  }
                  return D.prototype.invalidate.call(this)
              }, k._enabled = function(c, a) {
                  if (c === this._gc) {
                      for (var e = this._first; e;) {
                          e._enabled(c, !0), e = e._next
                      }
                  }
                  return y.prototype._enabled.call(this, c, a)
              }, k.totalTime = function() {
                  this._forcingPlayhead = !0;
                  var a = D.prototype.totalTime.apply(this, arguments);
                  return this._forcingPlayhead = !1, a
              }, k.duration = function(a) {
                  return arguments.length ? (0 !== this.duration() && 0 !== a && this.timeScale(this._duration / a), this) : (this._dirty && this.totalDuration(), this._duration)
              }, k.totalDuration = function(c) {
                  if (!arguments.length) {
                      if (this._dirty) {
                          for (var l, a, f = 0, h = this._last, m = 999999999999; h;) {
                              l = h._prev, h._dirty && h.totalDuration(), h._startTime > m && this._sortChildren && !h._paused ? this.add(h, h._startTime - h._delay) : m = h._startTime, 0 > h._startTime && !h._paused && (f -= h._startTime, this._timeline.smoothChildTiming && (this._startTime += h._startTime / this._timeScale), this.shiftChildren(-h._startTime, !1, -9999999999), m = 0), a = h._startTime + h._totalDuration / h._timeScale, a > f && (f = a), h = l
                          }
                          this._duration = this._totalDuration = f, this._dirty = !1
                      }
                      return this._totalDuration
                  }
                  return 0 !== this.totalDuration() && 0 !== c && this.timeScale(this._totalDuration / c), this
              }, k.usesFrames = function() {
                  for (var a = this._timeline; a._timeline;) {
                      a = a._timeline
                  }
                  return a === D._rootFramesTimeline
              }, k.rawTime = function() {
                  return this._paused ? this._totalTime : (this._timeline.rawTime() - this._startTime) * this._timeScale
              }, E
          }, !0), _gsScope._gsDefine("TimelineMax", ["TimelineLite", "TweenLite", "easing.Ease"], function(q, k, g) {
              var u = function(a) {
                      q.call(this, a), this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._cycle = 0, this._yoyo = this.vars.yoyo === !0, this._dirty = !0
                  },
                  b = 1e-10,
                  d = [],
                  m = k._internals,
                  c = m.lazyTweens,
                  j = m.lazyRender,
                  f = new g(null, null, 1, 0),
                  p = u.prototype = new q;
              return p.constructor = u, p.kill()._gc = !1, u.version = "1.15.0", p.invalidate = function() {
                  return this._yoyo = this.vars.yoyo === !0, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), q.prototype.invalidate.call(this)
              }, p.addCallback = function(e, a, h, l) {
                  return this.add(k.delayedCall(0, e, h, l), a)
              }, p.removeCallback = function(h, o) {
                  if (h) {
                      if (null == o) {
                          this._kill(null, h)
                      } else {
                          for (var a = this.getTweensOf(h, !1), l = a.length, n = this._parseTimeOrLabel(o); --l > -1;) {
                              a[l]._startTime === n && a[l]._enabled(!1, !1)
                          }
                      }
                  }
                  return this
              }, p.tweenTo = function(l, h) {
                  h = h || {};
                  var n, v, e, w = {
                      ease: f,
                      overwrite: h.delay ? 2 : 1,
                      useFrames: this.usesFrames(),
                      immediateRender: !1
                  };
                  for (v in h) {
                      w[v] = h[v]
                  }
                  return w.time = this._parseTimeOrLabel(l), n = Math.abs(Number(w.time) - this._time) / this._timeScale || 0.001, e = new k(this, n, w), w.onStart = function() {
                      e.target.paused(!0), e.vars.time !== e.target.time() && n === e.duration() && e.duration(Math.abs(e.vars.time - e.target.time()) / e.target._timeScale), h.onStart && h.onStart.apply(h.onStartScope || e, h.onStartParams || d)
                  }, e
              }, p.tweenFromTo = function(h, n, a) {
                  a = a || {}, h = this._parseTimeOrLabel(h), a.startAt = {
                      onComplete: this.seek,
                      onCompleteParams: [h],
                      onCompleteScope: this
                  }, a.immediateRender = a.immediateRender !== !1;
                  var l = this.tweenTo(n, a);
                  return l.duration(Math.abs(l.vars.time - h) / this._timeScale || 0.001)
              }, p.render = function(E, N, K) {
                  this._gc && this._enabled(!0, !1);
                  var F, V, I, W, D, G, Q = this._dirty ? this.totalDuration() : this._totalDuration,
                      M = this._duration,
                      H = this._time,
                      O = this._totalTime,
                      L = this._startTime,
                      C = this._timeScale,
                      z = this._rawPrevTime,
                      h = this._paused,
                      B = this._cycle;
                  if (E >= Q ? (this._locked || (this._totalTime = Q, this._cycle = this._repeat), this._reversed || this._hasPausedChild() || (V = !0, W = "onComplete", 0 === this._duration && (0 === E || 0 > z || z === b) && z !== E && this._first && (D = !0, z > b && (W = "onReverseComplete"))), this._rawPrevTime = this._duration || !N || E || this._rawPrevTime === E ? E : b, this._yoyo && 0 !== (1 & this._cycle) ? this._time = E = 0 : (this._time = M, E = M + 0.0001)) : 1e-7 > E ? (this._locked || (this._totalTime = this._cycle = 0), this._time = 0, (0 !== H || 0 === M && z !== b && (z > 0 || 0 > E && z >= 0) && !this._locked) && (W = "onReverseComplete", V = this._reversed), 0 > E ? (this._active = !1, z >= 0 && this._first && (D = !0), this._rawPrevTime = E) : (this._rawPrevTime = M || !N || E || this._rawPrevTime === E ? E : b, E = 0, this._initted || (D = !0))) : (0 === M && 0 > z && (D = !0), this._time = this._rawPrevTime = E, this._locked || (this._totalTime = E, 0 !== this._repeat && (G = M + this._repeatDelay, this._cycle = this._totalTime / G >> 0, 0 !== this._cycle && this._cycle === this._totalTime / G && this._cycle--, this._time = this._totalTime - this._cycle * G, this._yoyo && 0 !== (1 & this._cycle) && (this._time = M - this._time), this._time > M ? (this._time = M, E = M + 0.0001) : 0 > this._time ? this._time = E = 0 : E = this._time))), this._cycle !== B && !this._locked) {
                      var A = this._yoyo && 0 !== (1 & B),
                          U = A === (this._yoyo && 0 !== (1 & this._cycle)),
                          r = this._totalTime,
                          n = this._cycle,
                          J = this._rawPrevTime,
                          o = this._time;
                      if (this._totalTime = B * M, B > this._cycle ? A = !A : this._totalTime += M, this._time = H, this._rawPrevTime = 0 === M ? z - 0.0001 : z, this._cycle = B, this._locked = !0, H = A ? 0 : M, this.render(H, N, 0 === M), N || this._gc || this.vars.onRepeat && this.vars.onRepeat.apply(this.vars.onRepeatScope || this, this.vars.onRepeatParams || d), U && (H = A ? M + 0.0001 : -0.0001, this.render(H, !0, !1)), this._locked = !1, this._paused && !h) {
                          return
                      }
                      this._time = o, this._totalTime = r, this._cycle = n, this._rawPrevTime = J
                  }
                  if (!(this._time !== H && this._first || K || D)) {
                      return O !== this._totalTime && this._onUpdate && (N || this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || d)), void 0
                  }
                  if (this._initted || (this._initted = !0), this._active || !this._paused && this._totalTime !== O && E > 0 && (this._active = !0), 0 === O && this.vars.onStart && 0 !== this._totalTime && (N || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || d)), this._time >= H) {
                      for (F = this._first; F && (I = F._next, !this._paused || h);) {
                          (F._active || F._startTime <= this._time && !F._paused && !F._gc) && (F._reversed ? F.render((F._dirty ? F.totalDuration() : F._totalDuration) - (E - F._startTime) * F._timeScale, N, K) : F.render((E - F._startTime) * F._timeScale, N, K)), F = I
                      }
                  } else {
                      for (F = this._last; F && (I = F._prev, !this._paused || h);) {
                          (F._active || H >= F._startTime && !F._paused && !F._gc) && (F._reversed ? F.render((F._dirty ? F.totalDuration() : F._totalDuration) - (E - F._startTime) * F._timeScale, N, K) : F.render((E - F._startTime) * F._timeScale, N, K)), F = I
                      }
                  }
                  this._onUpdate && (N || (c.length && j(), this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || d))), W && (this._locked || this._gc || (L === this._startTime || C !== this._timeScale) && (0 === this._time || Q >= this.totalDuration()) && (V && (c.length && j(), this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !N && this.vars[W] && this.vars[W].apply(this.vars[W + "Scope"] || this, this.vars[W + "Params"] || d)))
              }, p.getActive = function(B, z, x) {
                  null == B && (B = !0), null == z && (z = !0), null == x && (x = !1);
                  var C, l, w = [],
                      A = this.getChildren(B, z, x),
                      v = 0,
                      y = A.length;
                  for (C = 0; y > C; C++) {
                      l = A[C], l.isActive() && (w[v++] = l)
                  }
                  return w
              }, p.getLabelAfter = function(h) {
                  h || 0 !== h && (h = this._time);
                  var n, a = this.getLabelsArray(),
                      l = a.length;
                  for (n = 0; l > n; n++) {
                      if (a[n].time > h) {
                          return a[n].name
                      }
                  }
                  return null
              }, p.getLabelBefore = function(h) {
                  null == h && (h = this._time);
                  for (var l = this.getLabelsArray(), a = l.length; --a > -1;) {
                      if (h > l[a].time) {
                          return l[a].name
                      }
                  }
                  return null
              }, p.getLabelsArray = function() {
                  var h, l = [],
                      a = 0;
                  for (h in this._labels) {
                      l[a++] = {
                          time: this._labels[h],
                          name: h
                      }
                  }
                  return l.sort(function(i, n) {
                      return i.time - n.time
                  }), l
              }, p.progress = function(a, h) {
                  return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), h) : this._time / this.duration()
              }, p.totalProgress = function(a, h) {
                  return arguments.length ? this.totalTime(this.totalDuration() * a, h) : this._totalTime / this.totalDuration()
              }, p.totalDuration = function(a) {
                  return arguments.length ? -1 === this._repeat ? this : this.duration((a - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (q.prototype.totalDuration.call(this), this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), this._totalDuration)
              }, p.time = function(a, h) {
                  return arguments.length ? (this._dirty && this.totalDuration(), a > this._duration && (a = this._duration), this._yoyo && 0 !== (1 & this._cycle) ? a = this._duration - a + this._cycle * (this._duration + this._repeatDelay) : 0 !== this._repeat && (a += this._cycle * (this._duration + this._repeatDelay)), this.totalTime(a, h)) : this._time
              }, p.repeat = function(a) {
                  return arguments.length ? (this._repeat = a, this._uncache(!0)) : this._repeat
              }, p.repeatDelay = function(a) {
                  return arguments.length ? (this._repeatDelay = a, this._uncache(!0)) : this._repeatDelay
              }, p.yoyo = function(a) {
                  return arguments.length ? (this._yoyo = a, this) : this._yoyo
              }, p.currentLabel = function(a) {
                  return arguments.length ? this.seek(a, !0) : this.getLabelBefore(this._time + 1e-8)
              }, u
          }, !0),
          function() {
              var F = 180 / Math.PI,
                  z = [],
                  w = [],
                  G = [],
                  b = {},
                  k = _gsScope._gsDefine.globals,
                  C = function(c, f, a, d) {
                      this.a = c, this.b = f, this.c = a, this.d = d, this.da = d - c, this.ca = a - c, this.ba = f - c
                  },
                  j = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
                  x = function(Q, L, J, R) {
                      var d = {
                              a: Q
                          },
                          H = {},
                          N = {},
                          m = {
                              c: R
                          },
                          K = (Q + L) / 2,
                          I = (L + J) / 2,
                          O = (J + R) / 2,
                          P = (K + I) / 2,
                          f = (I + O) / 2,
                          M = (f - P) / 8;
                      return d.b = K + (Q - K) / 4, H.b = P + M, d.c = H.a = (d.b + H.b) / 2, H.c = N.a = (P + f) / 2, N.b = f - M, m.b = O + (R - O) / 4, N.c = m.a = (N.b + m.b) / 2, [d, H, N, m]
                  },
                  v = function(K, L, O, Y, N) {
                      var R, Z, J, M, W, U, Q, V, S, I, i, e, H, s = K.length - 1,
                          X = 0,
                          h = K[0].a;
                      for (R = 0; s > R; R++) {
                          W = K[X], Z = W.a, J = W.d, M = K[X + 1].d, N ? (i = z[R], e = w[R], H = 0.25 * (e + i) * L / (Y ? 0.5 : G[R] || 0.5), U = J - (J - Z) * (Y ? 0.5 * L : 0 !== i ? H / i : 0), Q = J + (M - J) * (Y ? 0.5 * L : 0 !== e ? H / e : 0), V = J - (U + ((Q - U) * (3 * i / (i + e) + 0.5) / 4 || 0))) : (U = J - 0.5 * (J - Z) * L, Q = J + 0.5 * (M - J) * L, V = J - (U + Q) / 2), U += V, Q += V, W.c = S = U, W.b = 0 !== R ? h : h = W.a + 0.6 * (W.c - W.a), W.da = J - Z, W.ca = S - Z, W.ba = h - Z, O ? (I = x(Z, h, S, J), K.splice(X, 1, I[0], I[1], I[2], I[3]), X += 4) : X++, h = Q
                      }
                      W = K[X], W.b = h, W.c = h + 0.4 * (W.d - h), W.da = W.d - W.a, W.ca = W.c - W.a, W.ba = h - W.a, O && (I = x(W.a, h, W.c, W.d), K.splice(X, 1, I[0], I[1], I[2], I[3]))
                  },
                  D = function(K, L, a, f) {
                      var e, m, i, I, J, d, H = [];
                      if (f) {
                          for (K = [f].concat(K), m = K.length; --m > -1;) {
                              "string" == typeof(d = K[m][L]) && "=" === d.charAt(1) && (K[m][L] = f[L] + Number(d.charAt(0) + d.substr(2)))
                          }
                      }
                      if (e = K.length - 2, 0 > e) {
                          return H[0] = new C(K[0][L], 0, 0, K[-1 > e ? 0 : 1][L]), H
                      }
                      for (m = 0; e > m; m++) {
                          i = K[m][L], I = K[m + 1][L], H[m] = new C(i, 0, 0, I), a && (J = K[m + 2][L], z[m] = (z[m] || 0) + (I - i) * (I - i), w[m] = (w[m] || 0) + (J - I) * (J - I))
                      }
                      return H[m] = new C(K[m][L], 0, 0, K[m + 1][L]), H
                  },
                  E = function(R, i, N, r, Q, e) {
                      var J, H, l, I, s, P, L, o, O = {},
                          M = [],
                          K = e || R[0];
                      Q = "string" == typeof Q ? "," + Q + "," : j, null == i && (i = 1);
                      for (H in R[0]) {
                          M.push(H)
                      }
                      if (R.length > 1) {
                          for (o = R[R.length - 1], L = !0, J = M.length; --J > -1;) {
                              if (H = M[J], Math.abs(K[H] - o[H]) > 0.05) {
                                  L = !1;
                                  break
                              }
                          }
                          L && (R = R.concat(), e && R.unshift(e), R.push(R[1]), e = R[R.length - 3])
                      }
                      for (z.length = w.length = G.length = 0, J = M.length; --J > -1;) {
                          H = M[J], b[H] = -1 !== Q.indexOf("," + H + ","), O[H] = D(R, H, b[H], e)
                      }
                      for (J = z.length; --J > -1;) {
                          z[J] = Math.sqrt(z[J]), w[J] = Math.sqrt(w[J])
                      }
                      if (!r) {
                          for (J = M.length; --J > -1;) {
                              if (b[H]) {
                                  for (l = O[M[J]], P = l.length - 1, I = 0; P > I; I++) {
                                      s = l[I + 1].da / w[I] + l[I].da / z[I], G[I] = (G[I] || 0) + s * s
                                  }
                              }
                          }
                          for (J = G.length; --J > -1;) {
                              G[J] = Math.sqrt(G[J])
                          }
                      }
                      for (J = M.length, I = N ? 4 : 1; --J > -1;) {
                          H = M[J], l = O[H], v(l, i, N, r, b[H]), L && (l.splice(0, I), l.splice(l.length - I, I))
                      }
                      return O
                  },
                  g = function(I, U, Q) {
                      U = U || "soft";
                      var J, K, N, M, R, P, X, H, L, W, T, O = {},
                          V = "cubic" === U ? 3 : 2,
                          S = "soft" === U,
                          a = [];
                      if (S && Q && (I = [Q].concat(I)), null == I || V + 1 > I.length) {
                          throw "invalid Bezier data"
                      }
                      for (L in I[0]) {
                          a.push(L)
                      }
                      for (P = a.length; --P > -1;) {
                          for (L = a[P], O[L] = R = [], W = 0, H = I.length, X = 0; H > X; X++) {
                              J = null == Q ? I[X][L] : "string" == typeof(T = I[X][L]) && "=" === T.charAt(1) ? Q[L] + Number(T.charAt(0) + T.substr(2)) : Number(T), S && X > 1 && H - 1 > X && (R[W++] = (J + R[W - 2]) / 2), R[W++] = J
                          }
                          for (H = W - V + 1, W = 0, X = 0; H > X; X += V) {
                              J = R[X], K = R[X + 1], N = R[X + 2], M = 2 === V ? 0 : R[X + 3], R[W++] = T = 3 === V ? new C(J, K, N, M) : new C(J, (2 * K + J) / 3, (2 * K + N) / 3, N)
                          }
                          R.length = W
                      }
                      return O
                  },
                  B = function(U, P, M) {
                      for (var V, d, J, R, I, N, L, S, T, H, Q, O = 1 / M, K = U.length; --K > -1;) {
                          for (H = U[K], J = H.a, R = H.d - J, I = H.c - J, N = H.b - J, V = d = 0, S = 1; M >= S; S++) {
                              L = O * S, T = 1 - L, V = d - (d = (L * L * R + 3 * T * (L * I + T * N)) * L), Q = K * M + S - 1, P[Q] = (P[Q] || 0) + V * V
                          }
                      }
                  },
                  y = function(O, K) {
                      K = K >> 0 || 6;
                      var I, P, c, m, L = [],
                          f = [],
                          J = 0,
                          H = 0,
                          M = K - 1,
                          N = [],
                          d = [];
                      for (I in O) {
                          B(O[I], L, K)
                      }
                      for (c = L.length, P = 0; c > P; P++) {
                          J += Math.sqrt(L[P]), m = P % K, d[m] = J, m === M && (H += J, m = P / K >> 0, N[m] = d, f[m] = H, J = 0, d = [])
                      }
                      return {
                          length: H,
                          lengths: f,
                          segments: N
                      }
                  },
                  q = _gsScope._gsDefine.plugin({
                      propName: "bezier",
                      priority: -1,
                      version: "1.3.4",
                      API: 2,
                      global: !0,
                      init: function(O, K, I) {
                          this._target = O, K instanceof Array && (K = {
                              values: K
                          }), this._func = {}, this._round = {}, this._props = [], this._timeRes = null == K.timeResolution ? 6 : parseInt(K.timeResolution, 10);
                          var P, d, p, M, f, J = K.values || [],
                              H = {},
                              N = J[0],
                              L = K.autoRotate || I.vars.orientToBezier;
                          this._autoRotate = L ? L instanceof Array ? L : [
                              ["x", "y", "rotation", L === !0 ? 0 : Number(L) || 0]
                          ] : null;
                          for (P in N) {
                              this._props.push(P)
                          }
                          for (p = this._props.length; --p > -1;) {
                              P = this._props[p], this._overwriteProps.push(P), d = this._func[P] = "function" == typeof O[P], H[P] = d ? O[P.indexOf("set") || "function" != typeof O["get" + P.substr(3)] ? P : "get" + P.substr(3)]() : parseFloat(O[P]), f || H[P] !== J[0][P] && (f = H)
                          }
                          if (this._beziers = "cubic" !== K.type && "quadratic" !== K.type && "soft" !== K.type ? E(J, isNaN(K.curviness) ? 1 : K.curviness, !1, "thruBasic" === K.type, K.correlate, f) : g(J, K.type, H), this._segCount = this._beziers[P].length, this._timeRes) {
                              var u = y(this._beziers, this._timeRes);
                              this._length = u.length, this._lengths = u.lengths, this._segments = u.segments, this._l1 = this._li = this._s1 = this._si = 0, this._l2 = this._lengths[0], this._curSeg = this._segments[0], this._s2 = this._curSeg[0], this._prec = 1 / this._curSeg.length
                          }
                          if (L = this._autoRotate) {
                              for (this._initialRotations = [], L[0] instanceof Array || (this._autoRotate = L = [L]), p = L.length; --p > -1;) {
                                  for (M = 0; 3 > M; M++) {
                                      P = L[p][M], this._func[P] = "function" == typeof O[P] ? O[P.indexOf("set") || "function" != typeof O["get" + P.substr(3)] ? P : "get" + P.substr(3)] : !1
                                  }
                                  P = L[p][2], this._initialRotations[p] = this._func[P] ? this._func[P].call(this._target) : this._target[P]
                              }
                          }
                          return this._startRatio = I.vars.runBackwards ? 1 : 0, !0
                      },
                      set: function(Y) {
                          var U, M, N, Q, ac, P, V, S, ad, L, O = this._segCount,
                              aa = this._func,
                              X = this._target,
                              R = Y !== this._startRatio;
                          if (this._timeRes) {
                              if (ad = this._lengths, L = this._curSeg, Y *= this._length, N = this._li, Y > this._l2 && O - 1 > N) {
                                  for (S = O - 1; S > N && Y >= (this._l2 = ad[++N]);) {}
                                  this._l1 = ad[N - 1], this._li = N, this._curSeg = L = this._segments[N], this._s2 = L[this._s1 = this._si = 0]
                              } else {
                                  if (this._l1 > Y && N > 0) {
                                      for (; N > 0 && (this._l1 = ad[--N]) >= Y;) {}
                                      0 === N && this._l1 > Y ? this._l1 = 0 : N++, this._l2 = ad[N], this._li = N, this._curSeg = L = this._segments[N], this._s1 = L[(this._si = L.length - 1) - 1] || 0, this._s2 = L[this._si]
                                  }
                              }
                              if (U = N, Y -= this._l1, N = this._si, Y > this._s2 && L.length - 1 > N) {
                                  for (S = L.length - 1; S > N && Y >= (this._s2 = L[++N]);) {}
                                  this._s1 = L[N - 1], this._si = N
                              } else {
                                  if (this._s1 > Y && N > 0) {
                                      for (; N > 0 && (this._s1 = L[--N]) >= Y;) {}
                                      0 === N && this._s1 > Y ? this._s1 = 0 : N++, this._s2 = L[N], this._si = N
                                  }
                              }
                              P = (N + (Y - this._s1) / (this._s2 - this._s1)) * this._prec
                          } else {
                              U = 0 > Y ? 0 : Y >= 1 ? O - 1 : O * Y >> 0, P = (Y - U * (1 / O)) * O
                          }
                          for (M = 1 - P, N = this._props.length; --N > -1;) {
                              Q = this._props[N], ac = this._beziers[Q][U], V = (P * P * ac.da + 3 * M * (P * ac.ca + M * ac.ba)) * P + ac.a, this._round[Q] && (V = Math.round(V)), aa[Q] ? X[Q](V) : X[Q] = V
                          }
                          if (this._autoRotate) {
                              var Z, W, K, H, t, J, I, ab = this._autoRotate;
                              for (N = ab.length; --N > -1;) {
                                  Q = ab[N][2], J = ab[N][3] || 0, I = ab[N][4] === !0 ? 1 : F, ac = this._beziers[ab[N][0]], Z = this._beziers[ab[N][1]], ac && Z && (ac = ac[U], Z = Z[U], W = ac.a + (ac.b - ac.a) * P, H = ac.b + (ac.c - ac.b) * P, W += (H - W) * P, H += (ac.c + (ac.d - ac.c) * P - H) * P, K = Z.a + (Z.b - Z.a) * P, t = Z.b + (Z.c - Z.b) * P, K += (t - K) * P, t += (Z.c + (Z.d - Z.c) * P - t) * P, V = R ? Math.atan2(t - K, H - W) * I + J : this._initialRotations[N], aa[Q] ? X[Q](V) : X[Q] = V)
                              }
                          }
                      }
                  }),
                  A = q.prototype;
              q.bezierThrough = E, q.cubicToQuadratic = x, q._autoCSS = !0, q.quadraticToCubic = function(c, d, a) {
                  return new C(c, (2 * d + c) / 3, (2 * d + a) / 3, a)
              }, q._cssRegister = function() {
                  var c = k.CSSPlugin;
                  if (c) {
                      var h = c._internals,
                          a = h._parseToProxy,
                          d = h._setPluginRatio,
                          f = h.CSSPropTween;
                      h._registerComplexSpecialProp("bezier", {
                          parser: function(P, J, r, M, m, H) {
                              J instanceof Array && (J = {
                                  values: J
                              }), H = new q;
                              var s, N, O, i = J.values,
                                  L = i.length - 1,
                                  I = [],
                                  K = {};
                              if (0 > L) {
                                  return m
                              }
                              for (s = 0; L >= s; s++) {
                                  O = a(P, i[s], M, m, H, L !== s), I[s] = O.end
                              }
                              for (N in J) {
                                  K[N] = J[N]
                              }
                              return K.values = I, m = new f(P, "bezier", 0, 0, O.pt, 2), m.data = O, m.plugin = H, m.setRatio = d, 0 === K.autoRotate && (K.autoRotate = !0), !K.autoRotate || K.autoRotate instanceof Array || (s = K.autoRotate === !0 ? 0 : Number(K.autoRotate), K.autoRotate = null != O.end.left ? [
                                  ["left", "top", "rotation", s, !1]
                              ] : null != O.end.x ? [
                                  ["x", "y", "rotation", s, !1]
                              ] : !1), K.autoRotate && (M._transform || M._enableTransforms(!1), O.autoRotate = M._target._gsTransform), H._onInitTween(O.proxy, K, M._tween), m
                          }
                      })
                  }
              }, A._roundProps = function(c, f) {
                  for (var a = this._overwriteProps, d = a.length; --d > -1;) {
                      (c[a[d]] || c.bezier || c.bezierThrough) && (this._round[a[d]] = f)
                  }
              }, A._kill = function(c) {
                  var f, a, d = this._props;
                  for (f in this._beziers) {
                      if (f in c) {
                          for (delete this._beziers[f], delete this._func[f], a = d.length; --a > -1;) {
                              d[a] === f && d.splice(a, 1)
                          }
                      }
                  }
                  return this._super._kill.call(this, c)
              }
          }(), _gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function(av, aO) {
              var aJ, aw, ax, aC, aU = function() {
                      av.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = aU.prototype.setRatio
                  },
                  aB = _gsScope._gsDefine.globals,
                  aK = {},
                  aG = aU.prototype = new av("css");
              aG.constructor = aU, aU.version = "1.15.0", aU.API = 2, aU.defaultTransformPerspective = 0, aU.defaultSkewType = "compensated", aG = "px", aU.suffixMap = {
                  top: aG,
                  right: aG,
                  bottom: aG,
                  left: aG,
                  width: aG,
                  height: aG,
                  fontSize: aG,
                  padding: aG,
                  margin: aG,
                  perspective: aG,
                  lineHeight: ""
              };
              var aV, au, aA, aQ, aN, aD, aP = /(?:\d|\-\d|\.\d|\-\.\d)+/g,
                  aM = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
                  at = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
                  ap = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
                  a2 = /(?:\d|\-|\+|=|#|\.)*/g,
                  ar = /opacity *= *([^)]*)/i,
                  aq = /opacity:([^;]*)/i,
                  aT = /alpha\(opacity *=.+?\)/i,
                  a7 = /^(rgb|hsl)/,
                  a4 = /([A-Z])/g,
                  aH = /-([a-z])/gi,
                  a5 = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
                  bt = function(a, b) {
                      return b.toUpperCase()
                  },
                  br = /(?:Left|Right|Width)/i,
                  a8 = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
                  bo = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
                  bc = /,(?=[^\)]*(?:\(|$))/gi,
                  ao = Math.PI / 180,
                  bh = 180 / Math.PI,
                  bn = {},
                  bm = document,
                  ba = function(a) {
                      return bm.createElementNS ? bm.createElementNS("http://www.w3.org/1999/xhtml", a) : bm.createElement(a)
                  },
                  bd = ba("div"),
                  aY = ba("img"),
                  a1 = aU._internals = {
                      _specialProps: aK
                  },
                  aX = navigator.userAgent,
                  bs = function() {
                      var a = aX.indexOf("Android"),
                          b = ba("a");
                      return aA = -1 !== aX.indexOf("Safari") && -1 === aX.indexOf("Chrome") && (-1 === a || Number(aX.substr(a + 8, 1)) > 3), aN = aA && 6 > Number(aX.substr(aX.indexOf("Version/") + 8, 1)), aQ = -1 !== aX.indexOf("Firefox"), (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(aX) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(aX)) && (aD = parseFloat(RegExp.$1)), b ? (b.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(b.style.opacity)) : !1
                  }(),
                  aI = function(a) {
                      return ar.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1
                  },
                  az = function(a) {
                      window.console && console.log(a)
                  },
                  a0 = "",
                  bl = "",
                  aZ = function(b, f) {
                      f = f || bd;
                      var a, c, d = f.style;
                      if (void 0 !== d[b]) {
                          return b
                      }
                      for (b = b.charAt(0).toUpperCase() + b.substr(1), a = ["O", "Moz", "ms", "Ms", "Webkit"], c = 5; --c > -1 && void 0 === d[a[c] + b];) {}
                      return c >= 0 ? (bl = 3 === c ? "ms" : a[c], a0 = "-" + bl.toLowerCase() + "-", bl + b) : null
                  },
                  aW = bm.defaultView ? bm.defaultView.getComputedStyle : function() {},
                  a6 = aU.getStyle = function(b, f, a, c, d) {
                      var g;
                      return bs || "opacity" !== f ? (!c && b.style[f] ? g = b.style[f] : (a = a || aW(b)) ? g = a[f] || a.getPropertyValue(f) || a.getPropertyValue(f.replace(a4, "-$1").toLowerCase()) : b.currentStyle && (g = b.currentStyle[f]), null == d || g && "none" !== g && "auto" !== g && "auto auto" !== g ? g : d) : aI(b)
                  },
                  bB = a1.convertToPixels = function(v, g, w, a, e) {
                      if ("px" === a || !a) {
                          return w
                      }
                      if ("auto" === a || !w) {
                          return 0
                      }
                      var d, j, f, m = br.test(g),
                          q = v,
                          b = bd.style,
                          k = 0 > w;
                      if (k && (w = -w), "%" === a && -1 !== g.indexOf("border")) {
                          d = w / 100 * (m ? v.clientWidth : v.clientHeight)
                      } else {
                          if (b.cssText = "border:0 solid red;position:" + a6(v, "position") + ";line-height:0;", "%" !== a && q.appendChild) {
                              b[m ? "borderLeftWidth" : "borderTopWidth"] = w + a
                          } else {
                              if (q = v.parentNode || bm.body, j = q._gsCache, f = aO.ticker.frame, j && m && j.time === f) {
                                  return j.width * w / 100
                              }
                              b[m ? "width" : "height"] = w + a
                          }
                          q.appendChild(bd), d = parseFloat(bd[m ? "offsetWidth" : "offsetHeight"]), q.removeChild(bd), m && "%" === a && aU.cacheWidths !== !1 && (j = q._gsCache = q._gsCache || {}, j.time = f, j.width = 100 * (d / w)), 0 !== d || e || (d = bB(v, g, w, a, !0))
                      }
                      return k ? -d : d
                  },
                  bk = a1.calculateOffset = function(b, f, a) {
                      if ("absolute" !== a6(b, "position", a)) {
                          return 0
                      }
                      var c = "left" === f ? "Left" : "Top",
                          d = a6(b, "margin" + c, a);
                      return b["offset" + c] - (bB(b, f, parseFloat(d), d.replace(a2, "")) || 0)
                  },
                  bf = function(b, f) {
                      var a, c, d = {};
                      if (f = f || aW(b, null)) {
                          if (a = f.length) {
                              for (; --a > -1;) {
                                  d[f[a].replace(aH, bt)] = f.getPropertyValue(f[a])
                              }
                          } else {
                              for (a in f) {
                                  d[a] = f[a]
                              }
                          }
                      } else {
                          if (f = b.currentStyle || b.style) {
                              for (a in f) {
                                  "string" == typeof a && void 0 === d[a] && (d[a.replace(aH, bt)] = f[a])
                              }
                          }
                      }
                      return bs || (d.opacity = aI(b)), c = bI(b, f, !1), d.rotation = c.rotation, d.skewX = c.skewX, d.scaleX = c.scaleX, d.scaleY = c.scaleY, d.x = c.x, d.y = c.y, bK && (d.z = c.z, d.rotationX = c.rotationX, d.rotationY = c.rotationY, d.scaleZ = c.scaleZ), d.filters && delete d.filters, d
                  },
                  bg = function(p, k, g, q, b) {
                      var d, m, c, j = {},
                          f = p.style;
                      for (m in g) {
                          "cssText" !== m && "length" !== m && isNaN(m) && (k[m] !== (d = g[m]) || b && b[m]) && -1 === m.indexOf("Origin") && ("number" == typeof d || "string" == typeof d) && (j[m] = "auto" !== d || "left" !== m && "top" !== m ? "" !== d && "auto" !== d && "none" !== d || "string" != typeof k[m] || "" === k[m].replace(ap, "") ? d : 0 : bk(p, m), void 0 !== f[m] && (c = new ay(f, m, f[m], c)))
                      }
                      if (q) {
                          for (m in q) {
                              "className" !== m && (j[m] = q[m])
                          }
                      }
                      return {
                          difs: j,
                          firstMPT: c
                      }
                  },
                  bp = {
                      width: ["Left", "Right"],
                      height: ["Top", "Bottom"]
                  },
                  ac = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
                  aE = function(b, f, a) {
                      var c = parseFloat("width" === f ? b.offsetWidth : b.offsetHeight),
                          d = bp[f],
                          g = d.length;
                      for (a = a || aW(b, null); --g > -1;) {
                          c -= parseFloat(a6(b, "padding" + d[g], a, !0)) || 0, c -= parseFloat(a6(b, "border" + d[g] + "Width", a, !0)) || 0
                      }
                      return c
                  },
                  bz = function(b, f) {
                      (null == b || "" === b || "auto" === b || "auto auto" === b) && (b = "0 0");
                      var a = b.split(" "),
                          c = -1 !== b.indexOf("left") ? "0%" : -1 !== b.indexOf("right") ? "100%" : a[0],
                          d = -1 !== b.indexOf("top") ? "0%" : -1 !== b.indexOf("bottom") ? "100%" : a[1];
                      return null == d ? d = "0" : "center" === d && (d = "50%"), ("center" === c || isNaN(parseFloat(c)) && -1 === (c + "").indexOf("=")) && (c = "50%"), f && (f.oxp = -1 !== c.indexOf("%"), f.oyp = -1 !== d.indexOf("%"), f.oxr = "=" === c.charAt(1), f.oyr = "=" === d.charAt(1), f.ox = parseFloat(c.replace(ap, "")), f.oy = parseFloat(d.replace(ap, ""))), c + " " + d + (a.length > 2 ? " " + a[2] : "")
                  },
                  bH = function(a, b) {
                      return "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b)
                  },
                  bi = function(a, b) {
                      return null == a ? b : "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) + b : parseFloat(a)
                  },
                  bw = function(l, j, f, m) {
                      var b, d, k, c, g = 0.000001;
                      return null == l ? c = j : "number" == typeof l ? c = l : (b = 360, d = l.split("_"), k = Number(d[0].replace(ap, "")) * (-1 === l.indexOf("rad") ? 1 : bh) - ("=" === l.charAt(1) ? 0 : j), d.length && (m && (m[f] = j + k), -1 !== l.indexOf("short") && (k %= b, k !== k % (b / 2) && (k = 0 > k ? k + b : k - b)), -1 !== l.indexOf("_cw") && 0 > k ? k = (k + 9999999999 * b) % b - (0 | k / b) * b : -1 !== l.indexOf("ccw") && k > 0 && (k = (k - 9999999999 * b) % b - (0 | k / b) * b)), c = j + k), g > c && c > -g && (c = 0), c
                  },
                  aL = {
                      aqua: [0, 255, 255],
                      lime: [0, 255, 0],
                      silver: [192, 192, 192],
                      black: [0, 0, 0],
                      maroon: [128, 0, 0],
                      teal: [0, 128, 128],
                      blue: [0, 0, 255],
                      navy: [0, 0, 128],
                      white: [255, 255, 255],
                      fuchsia: [255, 0, 255],
                      olive: [128, 128, 0],
                      yellow: [255, 255, 0],
                      orange: [255, 165, 0],
                      gray: [128, 128, 128],
                      purple: [128, 0, 128],
                      green: [0, 128, 0],
                      red: [255, 0, 0],
                      pink: [255, 192, 203],
                      cyan: [0, 255, 255],
                      transparent: [255, 255, 255, 0]
                  },
                  a9 = function(b, c, a) {
                      return b = 0 > b ? b + 1 : b > 1 ? b - 1 : b, 0 | 255 * (1 > 6 * b ? c + 6 * (a - c) * b : 0.5 > b ? a : 2 > 3 * b ? c + 6 * (a - c) * (2 / 3 - b) : c) + 0.5
                  },
                  bG = aU.parseColor = function(d) {
                      var h, c, f, g, j, b;
                      return d && "" !== d ? "number" == typeof d ? [d >> 16, 255 & d >> 8, 255 & d] : ("," === d.charAt(d.length - 1) && (d = d.substr(0, d.length - 1)), aL[d] ? aL[d] : "#" === d.charAt(0) ? (4 === d.length && (h = d.charAt(1), c = d.charAt(2), f = d.charAt(3), d = "#" + h + h + c + c + f + f), d = parseInt(d.substr(1), 16), [d >> 16, 255 & d >> 8, 255 & d]) : "hsl" === d.substr(0, 3) ? (d = d.match(aP), g = Number(d[0]) % 360 / 360, j = Number(d[1]) / 100, b = Number(d[2]) / 100, c = 0.5 >= b ? b * (j + 1) : b + j - b * j, h = 2 * b - c, d.length > 3 && (d[3] = Number(d[3])), d[0] = a9(g + 1 / 3, h, c), d[1] = a9(g, h, c), d[2] = a9(g - 1 / 3, h, c), d) : (d = d.match(aP) || aL.transparent, d[0] = Number(d[0]), d[1] = Number(d[1]), d[2] = Number(d[2]), d.length > 3 && (d[3] = Number(d[3])), d)) : aL.black
                  },
                  ab = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#.+?\\b";
              for (aG in aL) {
                  ab += "|" + aG + "\\b"
              }
              ab = RegExp(ab + ")", "gi");
              var aR = function(v, k, g, w) {
                      if (null == v) {
                          return function(a) {
                              return a
                          }
                      }
                      var b, d = k ? (v.match(ab) || [""])[0] : "",
                          m = v.split(d).join("").match(at) || [],
                          c = v.substr(0, v.indexOf(m[0])),
                          j = ")" === v.charAt(v.length - 1) ? ")" : "",
                          f = -1 !== v.indexOf(" ") ? " " : ",",
                          p = m.length,
                          q = p > 0 ? m[0].replace(aP, "") : "";
                      return p ? b = k ? function(a) {
                          var l, i, n, h;
                          if ("number" == typeof a) {
                              a += q
                          } else {
                              if (w && bc.test(a)) {
                                  for (h = a.replace(bc, "|").split("|"), n = 0; h.length > n; n++) {
                                      h[n] = b(h[n])
                                  }
                                  return h.join(",")
                              }
                          }
                          if (l = (a.match(ab) || [d])[0], i = a.split(l).join("").match(at) || [], n = i.length, p > n--) {
                              for (; p > ++n;) {
                                  i[n] = g ? i[0 | (n - 1) / 2] : m[n]
                              }
                          }
                          return c + i.join(f) + f + l + j + (-1 !== a.indexOf("inset") ? " inset" : "")
                      } : function(a) {
                          var i, l, h;
                          if ("number" == typeof a) {
                              a += q
                          } else {
                              if (w && bc.test(a)) {
                                  for (l = a.replace(bc, "|").split("|"), h = 0; l.length > h; h++) {
                                      l[h] = b(l[h])
                                  }
                                  return l.join(",")
                              }
                          }
                          if (i = a.match(at) || [], h = i.length, p > h--) {
                              for (; p > ++h;) {
                                  i[h] = g ? i[0 | (h - 1) / 2] : m[h]
                              }
                          }
                          return c + i.join(f) + j
                      } : function(a) {
                          return a
                      }
                  },
                  am = function(a) {
                      return a = a.split(","),
                          function(k, g, p, b, d, m, c) {
                              var j, f = (g + "").split(" ");
                              for (c = {}, j = 0; 4 > j; j++) {
                                  c[a[j]] = f[j] = f[j] || f[(j - 1) / 2 >> 0]
                              }
                              return b.parse(k, c, d, m)
                          }
                  },
                  ay = (a1._setPluginRatio = function(l) {
                      this.plugin.setRatio(l);
                      for (var j, f, m, b, d = this.data, k = d.proxy, c = d.firstMPT, g = 0.000001; c;) {
                          j = k[c.v], c.r ? j = Math.round(j) : g > j && j > -g && (j = 0), c.t[c.p] = j, c = c._next
                      }
                      if (d.autoRotate && (d.autoRotate.rotation = k.rotation), 1 === l) {
                          for (c = d.firstMPT; c;) {
                              if (f = c.t, f.type) {
                                  if (1 === f.type) {
                                      for (b = f.xs0 + f.s + f.xs1, m = 1; f.l > m; m++) {
                                          b += f["xn" + m] + f["xs" + (m + 1)]
                                      }
                                      f.e = b
                                  }
                              } else {
                                  f.e = f.s + f.xs0
                              }
                              c = c._next
                          }
                      }
                  }, function(b, f, a, c, d) {
                      this.t = b, this.p = f, this.v = a, this.r = d, c && (c._prev = this, this._next = c)
                  }),
                  bE = (a1._parseToProxy = function(D, y, v, E, b, j) {
                      var A, g, w, q, B, C = E,
                          d = {},
                          z = {},
                          x = v._transform,
                          k = bn;
                      for (v._transform = null, bn = y, E = B = v.parse(D, y, E, b), bn = k, j && (v._transform = x, C && (C._prev = null, C._prev && (C._prev._next = null))); E && E !== C;) {
                          if (1 >= E.type && (g = E.p, z[g] = E.s + E.c, d[g] = E.s, j || (q = new ay(E, "s", g, q, E.r), E.c = 0), 1 === E.type)) {
                              for (A = E.l; --A > 0;) {
                                  w = "xn" + A, g = E.p + "_" + w, z[g] = E.data[w], d[g] = E[w], j || (q = new ay(E, w, g, q, E.rxp[w]))
                              }
                          }
                          E = E._next
                      }
                      return {
                          proxy: d,
                          end: z,
                          firstMPT: q,
                          pt: B
                      }
                  }, a1.CSSPropTween = function(n, i, q, b, j, d, g, f, k, m, c) {
                      this.t = n, this.p = i, this.s = q, this.c = b, this.n = g || i, n instanceof bE || aC.push(this.n), this.r = f, this.type = d || 0, k && (this.pr = k, aJ = !0), this.b = void 0 === m ? q : m, this.e = void 0 === c ? q + b : c, j && (this._next = j, j._prev = this)
                  }),
                  by = aU.parseComplex = function(F, W, Q, G, I, M, Z, L, U, O) {
                      Q = Q || M || "", Z = new bE(F, W, 0, 0, Z, O ? 2 : 1, null, !1, L, Q, G), G += "";
                      var E, K, X, V, N, D, q, d, B, z, Y, g, P = Q.split(", ").join(",").split(" "),
                          j = G.split(", ").join(",").split(" "),
                          J = P.length,
                          H = aV !== !1;
                      for ((-1 !== G.indexOf(",") || -1 !== Q.indexOf(",")) && (P = P.join(" ").replace(bc, ", ").split(" "), j = j.join(" ").replace(bc, ", ").split(" "), J = P.length), J !== j.length && (P = (M || "").split(" "), J = P.length), Z.plugin = U, Z.setRatio = O, E = 0; J > E; E++) {
                          if (V = P[E], N = j[E], d = parseFloat(V), d || 0 === d) {
                              Z.appendXtra("", d, bH(N, d), N.replace(aM, ""), H && -1 !== N.indexOf("px"), !0)
                          } else {
                              if (I && ("#" === V.charAt(0) || aL[V] || a7.test(V))) {
                                  g = "," === N.charAt(N.length - 1) ? ")," : ")", V = bG(V), N = bG(N), B = V.length + N.length > 6, B && !bs && 0 === N[3] ? (Z["xs" + Z.l] += Z.l ? " transparent" : "transparent", Z.e = Z.e.split(j[E]).join("transparent")) : (bs || (B = !1), Z.appendXtra(B ? "rgba(" : "rgb(", V[0], N[0] - V[0], ",", !0, !0).appendXtra("", V[1], N[1] - V[1], ",", !0).appendXtra("", V[2], N[2] - V[2], B ? "," : g, !0), B && (V = 4 > V.length ? 1 : V[3], Z.appendXtra("", V, (4 > N.length ? 1 : N[3]) - V, g, !1)))
                              } else {
                                  if (D = V.match(aP)) {
                                      if (q = N.match(aM), !q || q.length !== D.length) {
                                          return Z
                                      }
                                      for (X = 0, K = 0; D.length > K; K++) {
                                          Y = D[K], z = V.indexOf(Y, X), Z.appendXtra(V.substr(X, z - X), Number(Y), bH(q[K], Y), "", H && "px" === V.substr(z + Y.length, 2), 0 === K), X = z + Y.length
                                      }
                                      Z["xs" + Z.l] += V.substr(X)
                                  } else {
                                      Z["xs" + Z.l] += Z.l ? " " + V : V
                                  }
                              }
                          }
                      }
                      if (-1 !== G.indexOf("=") && Z.data) {
                          for (g = Z.xs0 + Z.data.s, E = 1; Z.l > E; E++) {
                              g += Z["xs" + E] + Z.data["xn" + E]
                          }
                          Z.e = g + Z["xs" + E]
                      }
                      return Z.l || (Z.type = -1, Z.xs0 = Z.e), Z.xfirst || Z
                  },
                  ak = 9;
              for (aG = bE.prototype, aG.l = aG.pr = 0; --ak > 0;) {
                  aG["xn" + ak] = 0, aG["xs" + ak] = ""
              }
              aG.xs0 = "", aG._next = aG._prev = aG.xfirst = aG.data = aG.plugin = aG.setRatio = aG.rxp = null, aG.appendXtra = function(d, h, c, f, g, k) {
                  var b = this,
                      j = b.l;
                  return b["xs" + j] += k && j ? " " + d : d || "", c || 0 === j || b.plugin ? (b.l++, b.type = b.setRatio ? 2 : 1, b["xs" + b.l] = f || "", j > 0 ? (b.data["xn" + j] = h + c, b.rxp["xn" + j] = g, b["xn" + j] = h, b.plugin || (b.xfirst = new bE(b, "xn" + j, h, c, b.xfirst || b, 0, b.n, g, b.pr), b.xfirst.xs0 = 0), b) : (b.data = {
                      s: h + c
                  }, b.rxp = {}, b.s = h, b.c = c, b.r = g, b)) : (b["xs" + j] += h + (f || ""), b)
              };
              var bx = function(a, b) {
                      b = b || {}, this.p = b.prefix ? aZ(a) || a : a, aK[a] = aK[this.p] = this, this.format = b.formatter || aR(b.defaultValue, b.color, b.collapsible, b.multi), b.parser && (this.parse = b.parser), this.clrs = b.color, this.multi = b.multi, this.keyword = b.keyword, this.dflt = b.defaultValue, this.pr = b.priority || 0
                  },
                  an = a1._registerComplexSpecialProp = function(d, h, c) {
                      "object" != typeof h && (h = {
                          parser: c
                      });
                      var f, g, j = d.split(","),
                          b = h.defaultValue;
                      for (c = c || [b], f = 0; j.length > f; f++) {
                          h.prefix = 0 === f && h.prefix, h.defaultValue = c[f] || b, g = new bx(j[f], h)
                      }
                  },
                  bC = function(a) {
                      if (!aK[a]) {
                          var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
                          an(a, {
                              parser: function(g, f, h, j, k, d, c) {
                                  var e = aB.com.greensock.plugins[b];
                                  return e ? (e._cssRegister(), aK[h].parse(g, f, h, j, k, d, c)) : (az("Error: " + b + " js file not loaded."), k)
                              }
                          })
                      }
                  };
              aG = bx.prototype, aG.parseComplex = function(x, m, j, y, b, f) {
                  var q, d, k, g, v, w, c = this.keyword;
                  if (this.multi && (bc.test(j) || bc.test(m) ? (d = m.replace(bc, "|").split("|"), k = j.replace(bc, "|").split("|")) : c && (d = [m], k = [j])), k) {
                      for (g = k.length > d.length ? k.length : d.length, q = 0; g > q; q++) {
                          m = d[q] = d[q] || this.dflt, j = k[q] = k[q] || this.dflt, c && (v = m.indexOf(c), w = j.indexOf(c), v !== w && (j = -1 === w ? k : d, j[q] += " " + c))
                      }
                      m = d.join(", "), j = k.join(", ")
                  }
                  return by(x, this.p, m, j, this.clrs, this.dflt, y, this.pr, b, f)
              }, aG.parse = function(d, g, c, f, h, b) {
                  return this.parseComplex(d.style, this.format(a6(d, this.p, ax, !1, this.dflt)), this.format(g), h, b)
              }, aU.registerSpecialProp = function(b, c, a) {
                  an(b, {
                      parser: function(e, g, i, k, d, j) {
                          var f = new bE(e, i, 0, 0, d, 2, i, !1, a);
                          return f.plugin = j, f.setRatio = c(e, g, k._tween, i), f
                      },
                      priority: a
                  })
              };
              var bD, ah = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
                  bJ = aZ("transform"),
                  a3 = a0 + "transform",
                  aS = aZ("transformOrigin"),
                  bK = null !== aZ("perspective"),
                  ad = a1.Transform = function() {
                      this.perspective = parseFloat(aU.defaultTransformPerspective) || 0, this.force3D = aU.defaultForce3D !== !1 && bK ? aU.defaultForce3D || "auto" : !1
                  },
                  ai = window.SVGElement,
                  bF = function(b, f, a) {
                      var c, d = bm.createElementNS("http://www.w3.org/2000/svg", b),
                          g = /([a-z])([A-Z])/g;
                      for (c in a) {
                          d.setAttributeNS(null, c.replace(g, "$1-$2").toLowerCase(), a[c])
                      }
                      return f.appendChild(d), d
                  },
                  bb = document.documentElement,
                  bq = function() {
                      var b, d, a, c = aD || /Android/i.test(aX) && !window.chrome;
                      return bm.createElementNS && !c && (b = bF("svg", bb), d = bF("rect", b, {
                          width: 100,
                          height: 50,
                          x: 100
                      }), a = d.getBoundingClientRect().width, d.style[aS] = "50% 50%", d.style[bJ] = "scaleX(0.5)", c = a === d.getBoundingClientRect().width, bb.removeChild(b)), c
                  }(),
                  aF = function(b, d, a) {
                      var c = b.getBBox();
                      d = bz(d).split(" "), a.xOrigin = (-1 !== d[0].indexOf("%") ? parseFloat(d[0]) / 100 * c.width : parseFloat(d[0])) + c.x, a.yOrigin = (-1 !== d[1].indexOf("%") ? parseFloat(d[1]) / 100 * c.height : parseFloat(d[1])) + c.y
                  },
                  bI = a1.getTransform = function(b2, cg, cc, b3) {
                      if (b2._gsTransform && cc && !b3) {
                          return b2._gsTransform
                      }
                      var b7, b6, cd, b9, ck, b1, b5, ci, cf, b8, ch = cc ? b2._gsTransform || new ad : new ad,
                          ce = 0 > ch.scaleX,
                          b0 = 0.00002,
                          bX = 100000,
                          O = bK ? parseFloat(a6(b2, aS, cg, !1, "0 0 0").split(" ")[2]) || ch.zOrigin || 0 : 0,
                          bZ = parseFloat(aU.defaultTransformPerspective) || 0;
                      if (bJ ? b6 = a6(b2, a3, cg, !0) : b2.currentStyle && (b6 = b2.currentStyle.filter.match(a8), b6 = b6 && 4 === b6.length ? [b6[0].substr(4), Number(b6[2].substr(4)), Number(b6[1].substr(4)), b6[3].substr(4), ch.x || 0, ch.y || 0].join(",") : ""), b7 = !b6 || "none" === b6 || "matrix(1, 0, 0, 1, 0, 0)" === b6, ch.svg = !!(ai && "function" == typeof b2.getBBox && b2.getCTM && (!b2.parentNode || b2.parentNode.getBBox && b2.parentNode.getCTM)), ch.svg && (aF(b2, a6(b2, aS, ax, !1, "50% 50%") + "", ch), bD = aU.useSVGTransformAttr || bq, cd = b2.getAttribute("transform"), b7 && cd && -1 !== cd.indexOf("matrix") && (b6 = cd, b7 = 0)), !b7) {
                          for (cd = (b6 || "").match(/(?:\-|\b)[\d\-\.e]+\b/gi) || [], b9 = cd.length; --b9 > -1;) {
                              ck = Number(cd[b9]), cd[b9] = (b1 = ck - (ck |= 0)) ? (0 | b1 * bX + (0 > b1 ? -0.5 : 0.5)) / bX + ck : ck
                          }
                          if (16 === cd.length) {
                              var bY = cd[8],
                                  cj = cd[9],
                                  be = cd[10],
                                  Q = cd[12],
                                  ca = cd[13],
                                  ae = cd[14];
                              ch.zOrigin && (ae = -ch.zOrigin, Q = bY * ae - cd[12], ca = cj * ae - cd[13], ae = be * ae + ch.zOrigin - cd[14]);
                              var bU, bS, bR, bM, bW, bQ = cd[0],
                                  bP = cd[1],
                                  bL = cd[2],
                                  bN = cd[3],
                                  H = cd[4],
                                  K = cd[5],
                                  r = cd[6],
                                  bT = cd[7],
                                  cb = cd[11],
                                  b4 = Math.atan2(bP, K);
                              ch.rotation = b4 * bh, b4 && (bM = Math.cos(-b4), bW = Math.sin(-b4), bQ = bQ * bM + H * bW, bS = bP * bM + K * bW, K = bP * -bW + K * bM, r = bL * -bW + r * bM, bP = bS), b4 = Math.atan2(bY, bQ), ch.rotationY = b4 * bh, b4 && (bM = Math.cos(-b4), bW = Math.sin(-b4), bU = bQ * bM - bY * bW, bS = bP * bM - cj * bW, bR = bL * bM - be * bW, cj = bP * bW + cj * bM, be = bL * bW + be * bM, cb = bN * bW + cb * bM, bQ = bU, bP = bS, bL = bR), b4 = Math.atan2(r, be), ch.rotationX = b4 * bh, b4 && (bM = Math.cos(-b4), bW = Math.sin(-b4), bU = H * bM + bY * bW, bS = K * bM + cj * bW, bR = r * bM + be * bW, bY = H * -bW + bY * bM, cj = K * -bW + cj * bM, be = r * -bW + be * bM, cb = bT * -bW + cb * bM, H = bU, K = bS, r = bR), ch.scaleX = (0 | Math.sqrt(bQ * bQ + bP * bP) * bX + 0.5) / bX, ch.scaleY = (0 | Math.sqrt(K * K + cj * cj) * bX + 0.5) / bX, ch.scaleZ = (0 | Math.sqrt(r * r + be * be) * bX + 0.5) / bX, ch.skewX = 0, ch.perspective = cb ? 1 / (0 > cb ? -cb : cb) : 0, ch.x = Q, ch.y = ca, ch.z = ae
                          } else {
                              if (!(bK && !b3 && cd.length && ch.x === cd[4] && ch.y === cd[5] && (ch.rotationX || ch.rotationY) || void 0 !== ch.x && "none" === a6(b2, "display", cg))) {
                                  var J = cd.length >= 6,
                                      bO = J ? cd[0] : 1,
                                      I = cd[1] || 0,
                                      a = cd[2] || 0,
                                      bV = J ? cd[3] : 1;
                                  ch.x = cd[4] || 0, ch.y = cd[5] || 0, b5 = Math.sqrt(bO * bO + I * I), ci = Math.sqrt(bV * bV + a * a), cf = bO || I ? Math.atan2(I, bO) * bh : ch.rotation || 0, b8 = a || bV ? Math.atan2(a, bV) * bh + cf : ch.skewX || 0, Math.abs(b8) > 90 && 270 > Math.abs(b8) && (ce ? (b5 *= -1, b8 += 0 >= cf ? 180 : -180, cf += 0 >= cf ? 180 : -180) : (ci *= -1, b8 += 0 >= b8 ? 180 : -180)), ch.scaleX = b5, ch.scaleY = ci, ch.rotation = cf, ch.skewX = b8, bK && (ch.rotationX = ch.rotationY = ch.z = 0, ch.perspective = bZ, ch.scaleZ = 1)
                              }
                          }
                          ch.zOrigin = O;
                          for (b9 in ch) {
                              b0 > ch[b9] && ch[b9] > -b0 && (ch[b9] = 0)
                          }
                      }
                      return cc && (b2._gsTransform = ch), ch
                  },
                  bu = function(C) {
                      var O, K, D = this.data,
                          E = -D.rotation * ao,
                          H = E + D.skewX * ao,
                          V = 100000,
                          G = (0 | Math.cos(E) * D.scaleX * V) / V,
                          L = (0 | Math.sin(E) * D.scaleX * V) / V,
                          I = (0 | Math.sin(H) * -D.scaleY * V) / V,
                          W = (0 | Math.cos(H) * D.scaleY * V) / V,
                          B = this.t.style,
                          F = this.t.currentStyle;
                      if (F) {
                          K = L, L = -I, I = -K, O = F.filter, B.filter = "";
                          var T, N, Q = this.t.offsetWidth,
                              M = this.t.offsetHeight,
                              A = "absolute" !== F.position,
                              w = "progid:DXImageTransform.Microsoft.Matrix(M11=" + G + ", M12=" + L + ", M21=" + I + ", M22=" + W,
                              z = D.x + Q * D.xPercent / 100,
                              U = D.y + M * D.yPercent / 100;
                          if (null != D.ox && (T = (D.oxp ? 0.01 * Q * D.ox : D.ox) - Q / 2, N = (D.oyp ? 0.01 * M * D.oy : D.oy) - M / 2, z += T - (T * G + N * L), U += N - (T * I + N * W)), A ? (T = Q / 2, N = M / 2, w += ", Dx=" + (T - (T * G + N * L) + z) + ", Dy=" + (N - (T * I + N * W) + U) + ")") : w += ", sizingMethod='auto expand')", B.filter = -1 !== O.indexOf("DXImageTransform.Microsoft.Matrix(") ? O.replace(bo, w) : w + " " + O, (0 === C || 1 === C) && 1 === G && 0 === L && 0 === I && 1 === W && (A && -1 === w.indexOf("Dx=0, Dy=0") || ar.test(O) && 100 !== parseFloat(RegExp.$1) || -1 === O.indexOf("gradient(" && O.indexOf("Alpha")) && B.removeAttribute("filter")), !A) {
                              var q, j, J, m = 8 > aD ? 1 : -1;
                              for (T = D.ieOffsetX || 0, N = D.ieOffsetY || 0, D.ieOffsetX = Math.round((Q - ((0 > G ? -G : G) * Q + (0 > L ? -L : L) * M)) / 2 + z), D.ieOffsetY = Math.round((M - ((0 > W ? -W : W) * M + (0 > I ? -I : I) * Q)) / 2 + U), ak = 0; 4 > ak; ak++) {
                                  j = ac[ak], q = F[j], K = -1 !== q.indexOf("px") ? parseFloat(q) : bB(this.t, j, parseFloat(q), q.replace(a2, "")) || 0, J = K !== D[j] ? 2 > ak ? -D.ieOffsetX : -D.ieOffsetY : 2 > ak ? T - D.ieOffsetX : N - D.ieOffsetY, B[j] = (D[j] = Math.round(K - J * (0 === ak || 2 === ak ? 1 : m))) + "px"
                              }
                          }
                      }
                  },
                  bj = a1.set3DTransformRatio = function(bM) {
                      var bZ, bV, bN, bO, bR, b2, bQ, bW, bT, b3, bL, bP, bY, bS, b0, bX, be, Y, c, ae, Z, b1, z, j, bU, q = this.data,
                          X = this.t.style,
                          W = q.rotation * ao,
                          B = q.scaleX,
                          V = q.scaleY,
                          H = q.scaleZ,
                          K = q.x,
                          U = q.y,
                          Q = q.z,
                          G = q.perspective;
                      if (!(1 !== bM && 0 !== bM || "auto" !== q.force3D || q.rotationY || q.rotationX || 1 !== H || G || Q)) {
                          return al.call(this, bM), void 0
                      }
                      if (aQ) {
                          var J = 0.0001;
                          J > B && B > -J && (B = H = 0.00002), J > V && V > -J && (V = H = 0.00002), !G || q.z || q.rotationX || q.rotationY || (G = 0)
                      }
                      if (W || q.skewX) {
                          Y = Math.cos(W), c = Math.sin(W), bZ = Y, bR = c, q.skewX && (W -= q.skewX * ao, Y = Math.cos(W), c = Math.sin(W), "simple" === q.skewType && (ae = Math.tan(q.skewX * ao), ae = Math.sqrt(1 + ae * ae), Y *= ae, c *= ae)), bV = -c, b2 = Y
                      } else {
                          if (!(q.rotationY || q.rotationX || 1 !== H || G || q.svg)) {
                              return X[bJ] = (q.xPercent || q.yPercent ? "translate(" + q.xPercent + "%," + q.yPercent + "%) translate3d(" : "translate3d(") + K + "px," + U + "px," + Q + "px)" + (1 !== B || 1 !== V ? " scale(" + B + "," + V + ")" : ""), void 0
                          }
                          bZ = b2 = 1, bV = bR = 0
                      }
                      bL = 1, bN = bO = bQ = bW = bT = b3 = bP = bY = bS = 0, b0 = G ? -1 / G : 0, bX = q.zOrigin, be = 100000, bU = ",", W = q.rotationY * ao, W && (Y = Math.cos(W), c = Math.sin(W), bT = bL * -c, bY = b0 * -c, bN = bZ * c, bQ = bR * c, bL *= Y, b0 *= Y, bZ *= Y, bR *= Y), W = q.rotationX * ao, W && (Y = Math.cos(W), c = Math.sin(W), ae = bV * Y + bN * c, Z = b2 * Y + bQ * c, b1 = b3 * Y + bL * c, z = bS * Y + b0 * c, bN = bV * -c + bN * Y, bQ = b2 * -c + bQ * Y, bL = b3 * -c + bL * Y, b0 = bS * -c + b0 * Y, bV = ae, b2 = Z, b3 = b1, bS = z), 1 !== H && (bN *= H, bQ *= H, bL *= H, b0 *= H), 1 !== V && (bV *= V, b2 *= V, b3 *= V, bS *= V), 1 !== B && (bZ *= B, bR *= B, bT *= B, bY *= B), bX && (bP -= bX, bO = bN * bP, bW = bQ * bP, bP = bL * bP + bX), q.svg && (bO += q.xOrigin - (q.xOrigin * bZ + q.yOrigin * bV), bW += q.yOrigin - (q.xOrigin * bR + q.yOrigin * b2)), bO = (ae = (bO += K) - (bO |= 0)) ? (0 | ae * be + (0 > ae ? -0.5 : 0.5)) / be + bO : bO, bW = (ae = (bW += U) - (bW |= 0)) ? (0 | ae * be + (0 > ae ? -0.5 : 0.5)) / be + bW : bW, bP = (ae = (bP += Q) - (bP |= 0)) ? (0 | ae * be + (0 > ae ? -0.5 : 0.5)) / be + bP : bP, j = q.xPercent || q.yPercent ? "translate(" + q.xPercent + "%," + q.yPercent + "%) matrix3d(" : "matrix3d(", j += (0 | bZ * be) / be + bU + (0 | bR * be) / be + bU + (0 | bT * be) / be, j += bU + (0 | bY * be) / be + bU + (0 | bV * be) / be + bU + (0 | b2 * be) / be, j += bU + (0 | b3 * be) / be + bU + (0 | bS * be) / be + bU + (0 | bN * be) / be, j += bU + (0 | bQ * be) / be + bU + (0 | bL * be) / be + bU + (0 | b0 * be) / be, j += bU + bO + bU + bW + bU + bP + bU + (G ? 1 + -bP / G : 1) + ")", X[bJ] = j
                  },
                  al = a1.set2DTransformRatio = function(F) {
                      var z, w, G, b, k, C, j, x, v, D, E, g = this.data,
                          B = this.t,
                          y = B.style,
                          q = g.x,
                          A = g.y;
                      return !(g.rotationX || g.rotationY || g.z || g.force3D === !0 || "auto" === g.force3D && 1 !== F && 0 !== F) || g.svg && bD || !bK ? (b = g.scaleX, k = g.scaleY, g.rotation || g.skewX || g.svg ? (z = g.rotation * ao, w = z - g.skewX * ao, G = 100000, C = Math.cos(z) * b, j = Math.sin(z) * b, x = Math.sin(w) * -k, v = Math.cos(w) * k, g.svg && (q += g.xOrigin - (g.xOrigin * C + g.yOrigin * x), A += g.yOrigin - (g.xOrigin * j + g.yOrigin * v), E = 0.000001, E > q && q > -E && (q = 0), E > A && A > -E && (A = 0)), D = (0 | C * G) / G + "," + (0 | j * G) / G + "," + (0 | x * G) / G + "," + (0 | v * G) / G + "," + q + "," + A + ")", g.svg && bD ? B.setAttribute("transform", "matrix(" + D) : y[bJ] = (g.xPercent || g.yPercent ? "translate(" + g.xPercent + "%," + g.yPercent + "%) matrix(" : "matrix(") + D) : y[bJ] = (g.xPercent || g.yPercent ? "translate(" + g.xPercent + "%," + g.yPercent + "%) matrix(" : "matrix(") + b + ",0,0," + k + "," + q + "," + A + ")", void 0) : (this.setRatio = bj, bj.call(this, F), void 0)
                  };
              aG = ad.prototype, aG.x = aG.y = aG.z = aG.skewX = aG.skewY = aG.rotation = aG.rotationX = aG.rotationY = aG.zOrigin = aG.xPercent = aG.yPercent = 0, aG.scaleX = aG.scaleY = aG.scaleZ = 1, an("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent", {
                  parser: function(r, I, E, x, B, A, F) {
                      if (x._lastParsedTransform === F) {
                          return B
                      }
                      x._lastParsedTransform = F;
                      var D, L, q, z, K, H, C, J = x._transform = bI(r, ax, !0, F.parseTransform),
                          G = r.style,
                          k = 0.000001,
                          b = ah.length,
                          a = F,
                          j = {};
                      if ("string" == typeof a.transform && bJ) {
                          q = bd.style, q[bJ] = a.transform, q.display = "block", q.position = "absolute", bm.body.appendChild(bd), D = bI(bd, null, !1), bm.body.removeChild(bd)
                      } else {
                          if ("object" == typeof a) {
                              if (D = {
                                      scaleX: bi(null != a.scaleX ? a.scaleX : a.scale, J.scaleX),
                                      scaleY: bi(null != a.scaleY ? a.scaleY : a.scale, J.scaleY),
                                      scaleZ: bi(a.scaleZ, J.scaleZ),
                                      x: bi(a.x, J.x),
                                      y: bi(a.y, J.y),
                                      z: bi(a.z, J.z),
                                      xPercent: bi(a.xPercent, J.xPercent),
                                      yPercent: bi(a.yPercent, J.yPercent),
                                      perspective: bi(a.transformPerspective, J.perspective)
                                  }, C = a.directionalRotation, null != C) {
                                  if ("object" == typeof C) {
                                      for (q in C) {
                                          a[q] = C[q]
                                      }
                                  } else {
                                      a.rotation = C
                                  }
                              }
                              "string" == typeof a.x && -1 !== a.x.indexOf("%") && (D.x = 0, D.xPercent = bi(a.x, J.xPercent)), "string" == typeof a.y && -1 !== a.y.indexOf("%") && (D.y = 0, D.yPercent = bi(a.y, J.yPercent)), D.rotation = bw("rotation" in a ? a.rotation : "shortRotation" in a ? a.shortRotation + "_short" : "rotationZ" in a ? a.rotationZ : J.rotation, J.rotation, "rotation", j), bK && (D.rotationX = bw("rotationX" in a ? a.rotationX : "shortRotationX" in a ? a.shortRotationX + "_short" : J.rotationX || 0, J.rotationX, "rotationX", j), D.rotationY = bw("rotationY" in a ? a.rotationY : "shortRotationY" in a ? a.shortRotationY + "_short" : J.rotationY || 0, J.rotationY, "rotationY", j)), D.skewX = null == a.skewX ? J.skewX : bw(a.skewX, J.skewX), D.skewY = null == a.skewY ? J.skewY : bw(a.skewY, J.skewY), (L = D.skewY - J.skewY) && (D.skewX += L, D.rotation += L)
                          }
                      }
                      for (bK && null != a.force3D && (J.force3D = a.force3D, H = !0), J.skewType = a.skewType || J.skewType || aU.defaultSkewType, K = J.force3D || J.z || J.rotationX || J.rotationY || D.z || D.rotationX || D.rotationY || D.perspective, K || null == a.scale || (D.scaleZ = 1); --b > -1;) {
                          E = ah[b], z = D[E] - J[E], (z > k || -k > z || null != a[E] || null != bn[E]) && (H = !0, B = new bE(J, E, J[E], z, B), E in j && (B.e = j[E]), B.xs0 = 0, B.plugin = A, x._overwriteProps.push(B.n))
                      }
                      return z = a.transformOrigin, z && J.svg && (aF(r, z, D), B = new bE(J, "xOrigin", J.xOrigin, D.xOrigin - J.xOrigin, B, -1, "transformOrigin"), B.b = J.xOrigin, B.e = B.xs0 = D.xOrigin, B = new bE(J, "yOrigin", J.yOrigin, D.yOrigin - J.yOrigin, B, -1, "transformOrigin"), B.b = J.yOrigin, B.e = B.xs0 = D.yOrigin, z = "0px 0px"), (z || bK && K && J.zOrigin) && (bJ ? (H = !0, E = aS, z = (z || a6(r, E, ax, !1, "50% 50%")) + "", B = new bE(G, E, 0, 0, B, -1, "transformOrigin"), B.b = G[E], B.plugin = A, bK ? (q = J.zOrigin, z = z.split(" "), J.zOrigin = (z.length > 2 && (0 === q || "0px" !== z[2]) ? parseFloat(z[2]) : q) || 0, B.xs0 = B.e = z[0] + " " + (z[1] || "50%") + " 0px", B = new bE(J, "zOrigin", 0, 0, B, -1, B.n), B.b = q, B.xs0 = B.e = J.zOrigin) : B.xs0 = B.e = z) : bz(z + "", J)), H && (x._transformType = J.svg && bD || !K && 3 !== this._transformType ? 2 : 3), B
                  },
                  prefix: !0
              }), an("boxShadow", {
                  defaultValue: "0px 0px 0px 0px #999",
                  prefix: !0,
                  color: !0,
                  multi: !0,
                  keyword: "inset"
              }), an("borderRadius", {
                  defaultValue: "0px",
                  parser: function(B, L, H, E, Q) {
                      L = this.format(L);
                      var D, I, G, R, A, C, N, K, F, M, J, z, q, j, s, r, O = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
                          k = B.style;
                      for (F = parseFloat(B.offsetWidth), M = parseFloat(B.offsetHeight), D = L.split(" "), I = 0; O.length > I; I++) {
                          this.p.indexOf("border") && (O[I] = aZ(O[I])), A = R = a6(B, O[I], ax, !1, "0px"), -1 !== A.indexOf(" ") && (R = A.split(" "), A = R[0], R = R[1]), C = G = D[I], N = parseFloat(A), z = A.substr((N + "").length), q = "=" === C.charAt(1), q ? (K = parseInt(C.charAt(0) + "1", 10), C = C.substr(2), K *= parseFloat(C), J = C.substr((K + "").length - (0 > K ? 1 : 0)) || "") : (K = parseFloat(C), J = C.substr((K + "").length)), "" === J && (J = aw[H] || z), J !== z && (j = bB(B, "borderLeft", N, z), s = bB(B, "borderTop", N, z), "%" === J ? (A = 100 * (j / F) + "%", R = 100 * (s / M) + "%") : "em" === J ? (r = bB(B, "borderLeft", 1, "em"), A = j / r + "em", R = s / r + "em") : (A = j + "px", R = s + "px"), q && (C = parseFloat(A) + K + J, G = parseFloat(R) + K + J)), Q = by(k, O[I], A + " " + R, C + " " + G, !1, "0px", Q)
                      }
                      return Q
                  },
                  prefix: !0,
                  formatter: aR("0px 0px 0px 0px", !1, !0)
              }), an("backgroundPosition", {
                  defaultValue: "0 0",
                  parser: function(D, x, q, E, k, A) {
                      var j, r, m, B, C, b, z = "background-position",
                          w = ax || aW(D, null),
                          y = this.format((w ? aD ? w.getPropertyValue(z + "-x") + " " + w.getPropertyValue(z + "-y") : w.getPropertyValue(z) : D.currentStyle.backgroundPositionX + " " + D.currentStyle.backgroundPositionY) || "0 0"),
                          v = this.format(x);
                      if (-1 !== y.indexOf("%") != (-1 !== v.indexOf("%")) && (b = a6(D, "backgroundImage").replace(a5, ""), b && "none" !== b)) {
                          for (j = y.split(" "), r = v.split(" "), aY.setAttribute("src", b), m = 2; --m > -1;) {
                              y = j[m], B = -1 !== y.indexOf("%"), B !== (-1 !== r[m].indexOf("%")) && (C = 0 === m ? D.offsetWidth - aY.width : D.offsetHeight - aY.height, j[m] = B ? parseFloat(y) / 100 * C + "px" : 100 * (parseFloat(y) / C) + "%")
                          }
                          y = j.join(" ")
                      }
                      return this.parseComplex(D.style, y, v, k, A)
                  },
                  formatter: bz
              }), an("backgroundSize", {
                  defaultValue: "0 0",
                  formatter: bz
              }), an("perspective", {
                  defaultValue: "0px",
                  prefix: !0
              }), an("perspectiveOrigin", {
                  defaultValue: "50% 50%",
                  prefix: !0
              }), an("transformStyle", {
                  prefix: !0
              }), an("backfaceVisibility", {
                  prefix: !0
              }), an("userSelect", {
                  prefix: !0
              }), an("margin", {
                  parser: am("marginTop,marginRight,marginBottom,marginLeft")
              }), an("padding", {
                  parser: am("paddingTop,paddingRight,paddingBottom,paddingLeft")
              }), an("clip", {
                  defaultValue: "rect(0px,0px,0px,0px)",
                  parser: function(m, j, f, p, c, k) {
                      var b, g, d;
                      return 9 > aD ? (g = m.currentStyle, d = 8 > aD ? " " : ",", b = "rect(" + g.clipTop + d + g.clipRight + d + g.clipBottom + d + g.clipLeft + ")", j = this.format(j).split(",").join(d)) : (b = this.format(a6(m, this.p, ax, !1, this.dflt)), j = this.format(j)), this.parseComplex(m.style, b, j, c, k)
                  }
              }), an("textShadow", {
                  defaultValue: "0px 0px 0px #999",
                  color: !0,
                  multi: !0
              }), an("autoRound,strictUnits", {
                  parser: function(b, f, a, c, d) {
                      return d
                  }
              }), an("border", {
                  defaultValue: "0px solid #000",
                  parser: function(d, g, c, f, h, b) {
                      return this.parseComplex(d.style, this.format(a6(d, "borderTopWidth", ax, !1, "0px") + " " + a6(d, "borderTopStyle", ax, !1, "solid") + " " + a6(d, "borderTopColor", ax, !1, "#000")), this.format(g), h, b)
                  },
                  color: !0,
                  formatter: function(a) {
                      var b = a.split(" ");
                      return b[0] + " " + (b[1] || "solid") + " " + (a.match(ab) || ["#000"])[0]
                  }
              }), an("borderWidth", {
                  parser: am("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
              }), an("float,cssFloat,styleFloat", {
                  parser: function(d, h, c, f, g) {
                      var j = d.style,
                          b = "cssFloat" in j ? "cssFloat" : "styleFloat";
                      return new bE(j, b, 0, 0, g, -1, c, !1, 0, j[b], h)
                  }
              });
              var af = function(b) {
                  var f, a = this.t,
                      c = a.filter || a6(this.data, "filter") || "",
                      d = 0 | this.s + this.c * b;
                  100 === d && (-1 === c.indexOf("atrix(") && -1 === c.indexOf("radient(") && -1 === c.indexOf("oader(") ? (a.removeAttribute("filter"), f = !a6(this.data, "filter")) : (a.filter = c.replace(aT, ""), f = !0)), f || (this.xn1 && (a.filter = c = c || "alpha(opacity=" + d + ")"), -1 === c.indexOf("pacity") ? 0 === d && this.xn1 || (a.filter = c + " alpha(opacity=" + d + ")") : a.filter = c.replace(ar, "opacity=" + d))
              };
              an("opacity,alpha,autoAlpha", {
                  defaultValue: "1",
                  parser: function(m, j, f, p, c, k) {
                      var b = parseFloat(a6(m, "opacity", ax, !1, "1")),
                          g = m.style,
                          d = "autoAlpha" === f;
                      return "string" == typeof j && "=" === j.charAt(1) && (j = ("-" === j.charAt(0) ? -1 : 1) * parseFloat(j.substr(2)) + b), d && 1 === b && "hidden" === a6(m, "visibility", ax) && 0 !== j && (b = 0), bs ? c = new bE(g, "opacity", b, j - b, c) : (c = new bE(g, "opacity", 100 * b, 100 * (j - b), c), c.xn1 = d ? 1 : 0, g.zoom = 1, c.type = 2, c.b = "alpha(opacity=" + c.s + ")", c.e = "alpha(opacity=" + (c.s + c.c) + ")", c.data = m, c.plugin = k, c.setRatio = af), d && (c = new bE(g, "visibility", 0, 0, c, -1, null, !1, 0, 0 !== b ? "inherit" : "hidden", 0 === j ? "hidden" : "inherit"), c.xs0 = "inherit", p._overwriteProps.push(c.n), p._overwriteProps.push(f)), c
                  }
              });
              var bA = function(a, b) {
                      b && (a.removeProperty ? ("ms" === b.substr(0, 2) && (b = "M" + b.substr(1)), a.removeProperty(b.replace(a4, "-$1").toLowerCase())) : a.removeAttribute(b))
                  },
                  ag = function(b) {
                      if (this.t._gsClassPT = this, 1 === b || 0 === b) {
                          this.t.setAttribute("class", 0 === b ? this.b : this.e);
                          for (var c = this.data, a = this.t.style; c;) {
                              c.v ? a[c.p] = c.v : bA(a, c.p), c = c._next
                          }
                          1 === b && this.t._gsClassPT === this && (this.t._gsClassPT = null)
                      } else {
                          this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e)
                      }
                  };
              an("className", {
                  parser: function(z, r, A, g, w, d, k) {
                      var j, x, y, b, v, q = z.getAttribute("class") || "",
                          i = z.style.cssText;
                      if (w = g._classNamePT = new bE(z, A, 0, 0, w, 2), w.setRatio = ag, w.pr = -11, aJ = !0, w.b = q, x = bf(z, ax), y = z._gsClassPT) {
                          for (b = {}, v = y.data; v;) {
                              b[v.p] = 1, v = v._next
                          }
                          y.setRatio(1)
                      }
                      return z._gsClassPT = w, w.e = "=" !== r.charAt(1) ? r : q.replace(RegExp("\\s*\\b" + r.substr(2) + "\\b"), "") + ("+" === r.charAt(0) ? " " + r.substr(2) : ""), g._tween._duration && (z.setAttribute("class", w.e), j = bg(z, x, bf(z), k, b), z.setAttribute("class", q), w.data = j.firstMPT, z.style.cssText = i, w = w.xfirst = g.parse(z, j.difs, w, d)), w
                  }
              });
              var aj = function(d) {
                  if ((1 === d || 0 === d) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
                      var h, c, f, g, j = this.t.style,
                          b = aK.transform.parse;
                      if ("all" === this.e) {
                          j.cssText = "", g = !0
                      } else {
                          for (h = this.e.split(" ").join("").split(","), f = h.length; --f > -1;) {
                              c = h[f], aK[c] && (aK[c].parse === b ? g = !0 : c = "transformOrigin" === c ? aS : aK[c].p), bA(j, c)
                          }
                      }
                      g && (bA(j, bJ), this.t._gsTransform && delete this.t._gsTransform)
                  }
              };
              for (an("clearProps", {
                      parser: function(a, d, b, c, f) {
                          return f = new bE(a, b, 0, 0, f, 2), f.setRatio = aj, f.e = d, f.pr = -10, f.data = c._tween, aJ = !0, f
                      }
                  }), aG = "bezier,throwProps,physicsProps,physics2D".split(","), ak = aG.length; ak--;) {
                  bC(aG[ak])
              }
              aG = aU.prototype, aG._firstPT = aG._lastParsedTransform = aG._transform = null, aG._onInitTween = function(x, n, a) {
                  if (!x.nodeType) {
                      return !1
                  }
                  this._target = x, this._tween = a, this._vars = n, aV = n.autoRound, aJ = !1, aw = n.suffixMap || aU.suffixMap, ax = aW(x, ""), aC = this._overwriteProps;
                  var j, f, q, b, p, k, u, r, i, s = x.style;
                  if (au && "" === s.zIndex && (j = a6(x, "zIndex", ax), ("auto" === j || "" === j) && this._addLazySet(s, "zIndex", 0)), "string" == typeof n && (b = s.cssText, j = bf(x, ax), s.cssText = b + ";" + n, j = bg(x, j, bf(x)).difs, !bs && aq.test(n) && (j.opacity = parseFloat(RegExp.$1)), n = j, s.cssText = b), this._firstPT = f = this.parse(x, n, null), this._transformType) {
                      for (i = 3 === this._transformType, bJ ? aA && (au = !0, "" === s.zIndex && (u = a6(x, "zIndex", ax), ("auto" === u || "" === u) && this._addLazySet(s, "zIndex", 0)), aN && this._addLazySet(s, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (i ? "visible" : "hidden"))) : s.zoom = 1, q = f; q && q._next;) {
                          q = q._next
                      }
                      r = new bE(x, "transform", 0, 0, null, 2), this._linkCSSP(r, null, q), r.setRatio = i && bK ? bj : bJ ? al : bu, r.data = this._transform || bI(x, ax, !0), aC.pop()
                  }
                  if (aJ) {
                      for (; f;) {
                          for (k = f._next, q = b; q && q.pr > f.pr;) {
                              q = q._next
                          }(f._prev = q ? q._prev : p) ? f._prev._next = f: b = f, (f._next = q) ? q._prev = f : p = f, f = k
                      }
                      this._firstPT = b
                  }
                  return !0
              }, aG.parse = function(D, x, r, j) {
                  var A, h, q, C, b, z, w, k, y, s, B = D.style;
                  for (A in x) {
                      z = x[A], h = aK[A], h ? r = h.parse(D, z, A, this, r, j, x) : (b = a6(D, A, ax) + "", y = "string" == typeof z, "color" === A || "fill" === A || "stroke" === A || -1 !== A.indexOf("Color") || y && a7.test(z) ? (y || (z = bG(z), z = (z.length > 3 ? "rgba(" : "rgb(") + z.join(",") + ")"), r = by(B, A, b, z, !0, "transparent", r, 0, j)) : !y || -1 === z.indexOf(" ") && -1 === z.indexOf(",") ? (q = parseFloat(b), w = q || 0 === q ? b.substr((q + "").length) : "", ("" === b || "auto" === b) && ("width" === A || "height" === A ? (q = aE(D, A, ax), w = "px") : "left" === A || "top" === A ? (q = bk(D, A, ax), w = "px") : (q = "opacity" !== A ? 0 : 1, w = "")), s = y && "=" === z.charAt(1), s ? (C = parseInt(z.charAt(0) + "1", 10), z = z.substr(2), C *= parseFloat(z), k = z.replace(a2, "")) : (C = parseFloat(z), k = y ? z.substr((C + "").length) || "" : ""), "" === k && (k = A in aw ? aw[A] : w), z = C || 0 === C ? (s ? C + q : C) + k : x[A], w !== k && "" !== k && (C || 0 === C) && q && (q = bB(D, A, q, w), "%" === k ? (q /= bB(D, A, 100, "%") / 100, x.strictUnits !== !0 && (b = q + "%")) : "em" === k ? q /= bB(D, A, 1, "em") : "px" !== k && (C = bB(D, A, C, k), k = "px"), s && (C || 0 === C) && (z = C + q + k)), s && (C += q), !q && 0 !== q || !C && 0 !== C ? void 0 !== B[A] && (z || "NaN" != z + "" && null != z) ? (r = new bE(B, A, C || q || 0, 0, r, -1, A, !1, 0, b, z), r.xs0 = "none" !== z || "display" !== A && -1 === A.indexOf("Style") ? z : b) : az("invalid " + A + " tween value: " + x[A]) : (r = new bE(B, A, q, C - q, r, 0, A, aV !== !1 && ("px" === k || "zIndex" === A), 0, b, z), r.xs0 = k)) : r = by(B, A, b, z, !0, null, r, 0, j)), j && r && !r.plugin && (r.plugin = j)
                  }
                  return r
              }, aG.setRatio = function(b) {
                  var f, a, c, d = this._firstPT,
                      g = 0.000001;
                  if (1 !== b || this._tween._time !== this._tween._duration && 0 !== this._tween._time) {
                      if (b || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -0.000001) {
                          for (; d;) {
                              if (f = d.c * b + d.s, d.r ? f = Math.round(f) : g > f && f > -g && (f = 0), d.type) {
                                  if (1 === d.type) {
                                      if (c = d.l, 2 === c) {
                                          d.t[d.p] = d.xs0 + f + d.xs1 + d.xn1 + d.xs2
                                      } else {
                                          if (3 === c) {
                                              d.t[d.p] = d.xs0 + f + d.xs1 + d.xn1 + d.xs2 + d.xn2 + d.xs3
                                          } else {
                                              if (4 === c) {
                                                  d.t[d.p] = d.xs0 + f + d.xs1 + d.xn1 + d.xs2 + d.xn2 + d.xs3 + d.xn3 + d.xs4
                                              } else {
                                                  if (5 === c) {
                                                      d.t[d.p] = d.xs0 + f + d.xs1 + d.xn1 + d.xs2 + d.xn2 + d.xs3 + d.xn3 + d.xs4 + d.xn4 + d.xs5
                                                  } else {
                                                      for (a = d.xs0 + f + d.xs1, c = 1; d.l > c; c++) {
                                                          a += d["xn" + c] + d["xs" + (c + 1)]
                                                      }
                                                      d.t[d.p] = a
                                                  }
                                              }
                                          }
                                      }
                                  } else {
                                      -1 === d.type ? d.t[d.p] = d.xs0 : d.setRatio && d.setRatio(b)
                                  }
                              } else {
                                  d.t[d.p] = f + d.xs0
                              }
                              d = d._next
                          }
                      } else {
                          for (; d;) {
                              2 !== d.type ? d.t[d.p] = d.b : d.setRatio(b), d = d._next
                          }
                      }
                  } else {
                      for (; d;) {
                          2 !== d.type ? d.t[d.p] = d.e : d.setRatio(b), d = d._next
                      }
                  }
              }, aG._enableTransforms = function(a) {
                  this._transform = this._transform || bI(this._target, ax, !0), this._transformType = this._transform.svg && bD || !a && 3 !== this._transformType ? 2 : 3
              };
              var bv = function() {
                  this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0)
              };
              aG._addLazySet = function(b, d, a) {
                  var c = this._firstPT = new bE(b, d, 0, 0, this._firstPT, 2);
                  c.e = a, c.setRatio = bv, c.data = this
              }, aG._linkCSSP = function(b, d, a, c) {
                  return b && (d && (d._prev = b), b._next && (b._next._prev = b._prev), b._prev ? b._prev._next = b._next : this._firstPT === b && (this._firstPT = b._next, c = !0), a ? a._next = b : c || null !== this._firstPT || (this._firstPT = b), b._next = d, b._prev = a), b
              }, aG._kill = function(d) {
                  var a, b, c, f = d;
                  if (d.autoAlpha || d.alpha) {
                      f = {};
                      for (b in d) {
                          f[b] = d[b]
                      }
                      f.opacity = 1, f.autoAlpha && (f.visibility = 1)
                  }
                  return d.className && (a = this._classNamePT) && (c = a.xfirst, c && c._prev ? this._linkCSSP(c._prev, a._next, c._prev._prev) : c === this._firstPT && (this._firstPT = a._next), a._next && this._linkCSSP(a._next, a._next._next, c._prev), this._classNamePT = null), av.prototype._kill.call(this, f)
              };
              var aa = function(d, h, c) {
                  var f, g, j, b;
                  if (d.slice) {
                      for (g = d.length; --g > -1;) {
                          aa(d[g], h, c)
                      }
                  } else {
                      for (f = d.childNodes, g = f.length; --g > -1;) {
                          j = f[g], b = j.type, j.style && (h.push(bf(j)), c && c.push(j)), 1 !== b && 9 !== b && 11 !== b || !j.childNodes.length || aa(j, h, c)
                      }
                  }
              };
              return aU.cascadeTo = function(v, g, w) {
                  var b, e, k, d = aO.to(v, g, w),
                      j = [d],
                      f = [],
                      m = [],
                      q = [],
                      c = aO._internals.reservedProps;
                  for (v = d._targets || d.target, aa(v, f, q), d.render(g, !0), aa(v, m), d.render(0, !0), d._enabled(!0), b = q.length; --b > -1;) {
                      if (e = bg(q[b], f[b], m[b]), e.firstMPT) {
                          e = e.difs;
                          for (k in w) {
                              c[k] && (e[k] = w[k])
                          }
                          j.push(aO.to(q[b], g, e))
                      }
                  }
                  return j
              }, av.activate([aU]), aU
          }, !0),
          function() {
              var a = _gsScope._gsDefine.plugin({
                      propName: "roundProps",
                      priority: -1,
                      API: 2,
                      init: function(d, f, c) {
                          return this._tween = c, !0
                      }
                  }),
                  b = a.prototype;
              b._onInitAllProps = function() {
                  for (var f, j, d, g = this._tween, h = g.vars.roundProps instanceof Array ? g.vars.roundProps : g.vars.roundProps.split(","), l = h.length, c = {}, k = g._propLookup.roundProps; --l > -1;) {
                      c[h[l]] = 1
                  }
                  for (l = h.length; --l > -1;) {
                      for (f = h[l], j = g._firstPT; j;) {
                          d = j._next, j.pg ? j.t._roundProps(c, !0) : j.n === f && (this._add(j.t, f, j.s, j.c), d && (d._prev = j._prev), j._prev ? j._prev._next = d : g._firstPT === j && (g._firstPT = d), j._next = j._prev = null, g._propLookup[f] = k), j = d
                      }
                  }
                  return !1
              }, b._add = function(d, g, c, f) {
                  this._addTween(d, g, c, c + f, g, !0), this._overwriteProps.push(g)
              }
          }(), _gsScope._gsDefine.plugin({
              propName: "attr",
              API: 2,
              version: "0.3.3",
              init: function(b, f) {
                  var a, c, d;
                  if ("function" != typeof b.setAttribute) {
                      return !1
                  }
                  this._target = b, this._proxy = {}, this._start = {}, this._end = {};
                  for (a in f) {
                      this._start[a] = this._proxy[a] = c = b.getAttribute(a), d = this._addTween(this._proxy, a, parseFloat(c), f[a], a), this._end[a] = d ? d.s + d.c : f[a], this._overwriteProps.push(a)
                  }
                  return !0
              },
              set: function(b) {
                  this._super.setRatio.call(this, b);
                  for (var f, a = this._overwriteProps, c = a.length, d = 1 === b ? this._end : b ? this._proxy : this._start; --c > -1;) {
                      f = a[c], this._target.setAttribute(f, d[f] + "")
                  }
              }
          }), _gsScope._gsDefine.plugin({
              propName: "directionalRotation",
              version: "0.2.1",
              API: 2,
              init: function(p, k) {
                  "object" != typeof k && (k = {
                      rotation: k
                  }), this.finals = {};
                  var g, q, b, d, m, c, j = k.useRadians === !0 ? 2 * Math.PI : 360,
                      f = 0.000001;
                  for (g in k) {
                      "useRadians" !== g && (c = (k[g] + "").split("_"), q = c[0], b = parseFloat("function" != typeof p[g] ? p[g] : p[g.indexOf("set") || "function" != typeof p["get" + g.substr(3)] ? g : "get" + g.substr(3)]()), d = this.finals[g] = "string" == typeof q && "=" === q.charAt(1) ? b + parseInt(q.charAt(0) + "1", 10) * Number(q.substr(2)) : Number(q) || 0, m = d - b, c.length && (q = c.join("_"), -1 !== q.indexOf("short") && (m %= j, m !== m % (j / 2) && (m = 0 > m ? m + j : m - j)), -1 !== q.indexOf("_cw") && 0 > m ? m = (m + 9999999999 * j) % j - (0 | m / j) * j : -1 !== q.indexOf("ccw") && m > 0 && (m = (m - 9999999999 * j) % j - (0 | m / j) * j)), (m > f || -f > m) && (this._addTween(p, g, b, b + m, g), this._overwriteProps.push(g)))
                  }
                  return !0
              },
              set: function(a) {
                  var b;
                  if (1 !== a) {
                      this._super.setRatio.call(this, a)
                  } else {
                      for (b = this._firstPT; b;) {
                          b.f ? b.t[b.p](this.finals[b.p]) : b.t[b.p] = this.finals[b.p], b = b._next
                      }
                  }
              }
          })._autoCSS = !0, _gsScope._gsDefine("easing.Back", ["easing.Ease"], function(F) {
              var z, w, G, b = _gsScope.GreenSockGlobals || _gsScope,
                  k = b.com.greensock,
                  C = 2 * Math.PI,
                  j = Math.PI / 2,
                  x = k._class,
                  v = function(f, a) {
                      var c = x("easing." + f, function() {}, !0),
                          d = c.prototype = new F;
                      return d.constructor = c, d.getRatio = a, c
                  },
                  D = F.register || function() {},
                  E = function(c, h, a, d) {
                      var f = x("easing." + c, {
                          easeOut: new h,
                          easeIn: new a,
                          easeInOut: new d
                      }, !0);
                      return D(f, c), f
                  },
                  g = function(c, d, a) {
                      this.t = c, this.v = d, a && (this.next = a, a.prev = this, this.c = a.v - d, this.gap = a.t - c)
                  },
                  B = function(f, a) {
                      var c = x("easing." + f, function(e) {
                              this._p1 = e || 0 === e ? e : 1.70158, this._p2 = 1.525 * this._p1
                          }, !0),
                          d = c.prototype = new F;
                      return d.constructor = c, d.getRatio = a, d.config = function(e) {
                          return new c(e)
                      }, c
                  },
                  y = E("Back", B("BackOut", function(a) {
                      return (a -= 1) * a * ((this._p1 + 1) * a + this._p1) + 1
                  }), B("BackIn", function(a) {
                      return a * a * ((this._p1 + 1) * a - this._p1)
                  }), B("BackInOut", function(a) {
                      return 1 > (a *= 2) ? 0.5 * a * a * ((this._p2 + 1) * a - this._p2) : 0.5 * ((a -= 2) * a * ((this._p2 + 1) * a + this._p2) + 2)
                  })),
                  q = x("easing.SlowMo", function(c, d, a) {
                      d = d || 0 === d ? d : 0.7, null == c ? c = 0.7 : c > 1 && (c = 1), this._p = 1 !== c ? d : 0, this._p1 = (1 - c) / 2, this._p2 = c, this._p3 = this._p1 + this._p2, this._calcEnd = a === !0
                  }, !0),
                  A = q.prototype = new F;
              return A.constructor = q, A.getRatio = function(a) {
                  var c = a + (0.5 - a) * this._p;
                  return this._p1 > a ? this._calcEnd ? 1 - (a = 1 - a / this._p1) * a : c - (a = 1 - a / this._p1) * a * a * a * c : a > this._p3 ? this._calcEnd ? 1 - (a = (a - this._p3) / this._p1) * a : c + (a - c) * (a = (a - this._p3) / this._p1) * a * a * a : this._calcEnd ? 1 : c
              }, q.ease = new q(0.7, 0.7), A.config = q.config = function(c, d, a) {
                  return new q(c, d, a)
              }, z = x("easing.SteppedEase", function(a) {
                  a = a || 1, this._p1 = 1 / a, this._p2 = a + 1
              }, !0), A = z.prototype = new F, A.constructor = z, A.getRatio = function(a) {
                  return 0 > a ? a = 0 : a >= 1 && (a = 0.999999999), (this._p2 * a >> 0) * this._p1
              }, A.config = z.config = function(a) {
                  return new z(a)
              }, w = x("easing.RoughEase", function(O) {
                  O = O || {};
                  for (var K, U, p, H, R, t, L = O.taper || "none", J = [], S = 0, T = 0 | (O.points || 20), Q = T, N = O.randomize !== !1, I = O.clamp === !0, P = O.template instanceof F ? O.template : null, M = "number" == typeof O.strength ? 0.4 * O.strength : 0.4; --Q > -1;) {
                      K = N ? Math.random() : 1 / T * Q, U = P ? P.getRatio(K) : K, "none" === L ? p = M : "out" === L ? (H = 1 - K, p = H * H * M) : "in" === L ? p = K * K * M : 0.5 > K ? (H = 2 * K, p = 0.5 * H * H * M) : (H = 2 * (1 - K), p = 0.5 * H * H * M), N ? U += Math.random() * p - 0.5 * p : Q % 2 ? U += 0.5 * p : U -= 0.5 * p, I && (U > 1 ? U = 1 : 0 > U && (U = 0)), J[S++] = {
                          x: K,
                          y: U
                      }
                  }
                  for (J.sort(function(a, c) {
                          return a.x - c.x
                      }), t = new g(1, 1, null), Q = T; --Q > -1;) {
                      R = J[Q], t = new g(R.x, R.y, t)
                  }
                  this._prev = new g(0, 0, 0 !== t.t ? t : t.next)
              }, !0), A = w.prototype = new F, A.constructor = w, A.getRatio = function(a) {
                  var c = this._prev;
                  if (a > c.t) {
                      for (; c.next && a >= c.t;) {
                          c = c.next
                      }
                      c = c.prev
                  } else {
                      for (; c.prev && c.t >= a;) {
                          c = c.prev
                      }
                  }
                  return this._prev = c, c.v + (a - c.t) / c.gap * c.c
              }, A.config = function(a) {
                  return new w(a)
              }, w.ease = new w, E("Bounce", v("BounceOut", function(a) {
                  return 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + 0.75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + 0.9375 : 7.5625 * (a -= 2.625 / 2.75) * a + 0.984375
              }), v("BounceIn", function(a) {
                  return 1 / 2.75 > (a = 1 - a) ? 1 - 7.5625 * a * a : 2 / 2.75 > a ? 1 - (7.5625 * (a -= 1.5 / 2.75) * a + 0.75) : 2.5 / 2.75 > a ? 1 - (7.5625 * (a -= 2.25 / 2.75) * a + 0.9375) : 1 - (7.5625 * (a -= 2.625 / 2.75) * a + 0.984375)
              }), v("BounceInOut", function(a) {
                  var c = 0.5 > a;
                  return a = c ? 1 - 2 * a : 2 * a - 1, a = 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + 0.75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + 0.9375 : 7.5625 * (a -= 2.625 / 2.75) * a + 0.984375, c ? 0.5 * (1 - a) : 0.5 * a + 0.5
              })), E("Circ", v("CircOut", function(a) {
                  return Math.sqrt(1 - (a -= 1) * a)
              }), v("CircIn", function(a) {
                  return -(Math.sqrt(1 - a * a) - 1)
              }), v("CircInOut", function(a) {
                  return 1 > (a *= 2) ? -0.5 * (Math.sqrt(1 - a * a) - 1) : 0.5 * (Math.sqrt(1 - (a -= 2) * a) + 1)
              })), G = function(f, a, c) {
                  var d = x("easing." + f, function(i, l) {
                          this._p1 = i || 1, this._p2 = l || c, this._p3 = this._p2 / C * (Math.asin(1 / this._p1) || 0)
                      }, !0),
                      h = d.prototype = new F;
                  return h.constructor = d, h.getRatio = a, h.config = function(i, l) {
                      return new d(i, l)
                  }, d
              }, E("Elastic", G("ElasticOut", function(a) {
                  return this._p1 * Math.pow(2, -10 * a) * Math.sin((a - this._p3) * C / this._p2) + 1
              }, 0.3), G("ElasticIn", function(a) {
                  return -(this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * C / this._p2))
              }, 0.3), G("ElasticInOut", function(a) {
                  return 1 > (a *= 2) ? -0.5 * this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * C / this._p2) : 0.5 * this._p1 * Math.pow(2, -10 * (a -= 1)) * Math.sin((a - this._p3) * C / this._p2) + 1
              }, 0.45)), E("Expo", v("ExpoOut", function(a) {
                  return 1 - Math.pow(2, -10 * a)
              }), v("ExpoIn", function(a) {
                  return Math.pow(2, 10 * (a - 1)) - 0.001
              }), v("ExpoInOut", function(a) {
                  return 1 > (a *= 2) ? 0.5 * Math.pow(2, 10 * (a - 1)) : 0.5 * (2 - Math.pow(2, -10 * (a - 1)))
              })), E("Sine", v("SineOut", function(a) {
                  return Math.sin(a * j)
              }), v("SineIn", function(a) {
                  return -Math.cos(a * j) + 1
              }), v("SineInOut", function(a) {
                  return -0.5 * (Math.cos(Math.PI * a) - 1)
              })), x("easing.EaseLookup", {
                  find: function(a) {
                      return F.map[a]
                  }
              }, !0), D(b.SlowMo, "SlowMo", "ease,"), D(w, "RoughEase", "ease,"), D(z, "SteppedEase", "ease,"), y
          }, !0)
  }), _gsScope._gsDefine && _gsScope._gsQueue.pop()(),
  function(aB, aQ) {
      var aM = aB.GreenSockGlobals = aB.GreenSockGlobals || aB;
      if (!aM.TweenLite) {
          var aC, aD, aH, aU, aG, aN = function(a) {
                  var d, b = a.split("."),
                      c = aM;
                  for (d = 0; b.length > d; d++) {
                      c[b[d]] = c = c[b[d]] || {}
                  }
                  return c
              },
              aJ = aN("com.greensock"),
              aV = 1e-10,
              aA = function(b) {
                  var d, a = [],
                      c = b.length;
                  for (d = 0; d !== c; a.push(b[d++])) {}
                  return a
              },
              aF = function() {},
              aS = function() {
                  var a = Object.prototype.toString,
                      b = a.call([]);
                  return function(c) {
                      return null != c && (c instanceof Array || "object" == typeof c && !!c.push && a.call(c) === b)
                  }
              }(),
              aP = {},
              aI = function(c, d, f, b) {
                  this.sc = aP[c] ? aP[c].sc : [], aP[c] = this, this.gsClass = null, this.func = f;
                  var e = [];
                  this.check = function(a) {
                      for (var i, h, k, n, m = d.length, j = m; --m > -1;) {
                          (i = aP[d[m]] || new aI(d[m], [])).gsClass ? (e[m] = i.gsClass, j--) : a && i.sc.push(this)
                      }
                      if (0 === j && f) {
                          for (h = ("com.greensock." + c).split("."), k = h.pop(), n = aN(h.join("."))[k] = this.gsClass = f.apply(f, e), b && (aM[k] = n, "function" == typeof define && define.amd ? define((aB.GreenSockAMDPath ? aB.GreenSockAMDPath + "/" : "") + c.split(".").pop(), [], function() {
                                  return n
                              }) : c === aQ && "undefined" != typeof module && module.exports && (module.exports = n)), m = 0; this.sc.length > m; m++) {
                              this.sc[m].check()
                          }
                      }
                  }, this.check(!0)
              },
              aR = aB._gsDefine = function(b, d, a, c) {
                  return new aI(b, d, a, c)
              },
              aO = aJ._class = function(b, c, a) {
                  return c = c || function() {}, aR(b, [], function() {
                      return c
                  }, a), c
              };
          aR.globals = aM;
          var az = [0, 0, 1, 1],
              aw = [],
              ad = aO("easing.Ease", function(b, d, a, c) {
                  this._func = b, this._type = a || 0, this._power = c || 0, this._params = d ? az.concat(d) : az
              }, !0),
              ay = ad.map = {},
              ax = ad.register = function(p, j, f, q) {
                  for (var b, d, k, c, g = j.split(","), l = g.length, m = (f || "easeIn,easeOut,easeInOut").split(","); --l > -1;) {
                      for (d = g[l], b = q ? aO("easing." + d, null, !0) : aJ.easing[d] || {}, k = m.length; --k > -1;) {
                          c = m[k], ay[d + "." + c] = ay[c + d] = b[c] = p.getRatio ? p : p[c] || new p
                      }
                  }
              };
          for (aH = ad.prototype, aH._calcEnd = !1, aH.getRatio = function(b) {
                  if (this._func) {
                      return this._params[0] = b, this._func.apply(null, this._params)
                  }
                  var d = this._type,
                      a = this._power,
                      c = 1 === d ? 1 - b : 2 === d ? b : 0.5 > b ? 2 * b : 2 * (1 - b);
                  return 1 === a ? c *= c : 2 === a ? c *= c * c : 3 === a ? c *= c * c * c : 4 === a && (c *= c * c * c * c), 1 === d ? 1 - c : 2 === d ? c : 0.5 > b ? c / 2 : 1 - c / 2
              }, aC = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"], aD = aC.length; --aD > -1;) {
              aH = aC[aD] + ",Power" + aD, ax(new ad(null, null, 1, aD), aH, "easeOut", !0), ax(new ad(null, null, 2, aD), aH, "easeIn" + (0 === aD ? ",easeNone" : "")), ax(new ad(null, null, 3, aD), aH, "easeInOut")
          }
          ay.linear = aJ.easing.Linear.easeIn, ay.swing = aJ.easing.Quad.easeInOut;
          var aT = aO("events.EventDispatcher", function(a) {
              this._listeners = {}, this._eventTarget = a || this
          });
          aH = aT.prototype, aH.addEventListener = function(k, g, d, m, a) {
              a = a || 0;
              var b, f, c = this._listeners[k],
                  j = 0;
              for (null == c && (this._listeners[k] = c = []), f = c.length; --f > -1;) {
                  b = c[f], b.c === g && b.s === d ? c.splice(f, 1) : 0 === j && a > b.pr && (j = f + 1)
              }
              c.splice(j, 0, {
                  c: g,
                  s: d,
                  up: m,
                  pr: a
              }), this !== aU || aG || aU.wake()
          }, aH.removeEventListener = function(b, d) {
              var a, c = this._listeners[b];
              if (c) {
                  for (a = c.length; --a > -1;) {
                      if (c[a].c === d) {
                          return c.splice(a, 1), void 0
                      }
                  }
              }
          }, aH.dispatchEvent = function(b) {
              var f, a, c, d = this._listeners[b];
              if (d) {
                  for (f = d.length, a = this._eventTarget; --f > -1;) {
                      c = d[f], c && (c.up ? c.c.call(c.s || a, {
                          type: b,
                          target: a
                      }) : c.c.call(c.s || a))
                  }
              }
          };
          var ah = aB.requestAnimationFrame,
              ae = aB.cancelAnimationFrame,
              aK = Date.now || function() {
                  return (new Date).getTime()
              },
              af = aK();
          for (aC = ["ms", "moz", "webkit", "o"], aD = aC.length; --aD > -1 && !ah;) {
              ah = aB[aC[aD] + "RequestAnimationFrame"], ae = aB[aC[aD] + "CancelAnimationFrame"] || aB[aC[aD] + "CancelRequestAnimationFrame"]
          }
          aO("Ticker", function(A, w) {
              var o, B, a, b, p, k = this,
                  z = aK(),
                  y = w !== !1 && ah,
                  v = 500,
                  j = 33,
                  x = "tick",
                  q = function(d) {
                      var f, c, g = aK() - af;
                      g > v && (z += g - j), af += g, k.time = (af - z) / 1000, f = k.time - p, (!o || f > 0 || d === !0) && (k.frame++, p += f + (f >= b ? 0.004 : b - f), c = !0), d !== !0 && (a = B(q)), c && k.dispatchEvent(x)
                  };
              aT.call(k), k.time = k.frame = 0, k.tick = function() {
                  q(!0)
              }, k.lagSmoothing = function(c, d) {
                  v = c || 1 / aV, j = Math.min(d, v, 0)
              }, k.sleep = function() {
                  null != a && (y && ae ? ae(a) : clearTimeout(a), B = aF, a = null, k === aU && (aG = !1))
              }, k.wake = function() {
                  null !== a ? k.sleep() : k.frame > 10 && (af = aK() - v + 5), B = 0 === o ? aF : y && ah ? ah : function(c) {
                      return setTimeout(c, 0 | 1000 * (p - k.time) + 1)
                  }, k === aU && (aG = !0), q(2)
              }, k.fps = function(c) {
                  return arguments.length ? (o = c, b = 1 / (o || 60), p = this.time + b, k.wake(), void 0) : o
              }, k.useRAF = function(c) {
                  return arguments.length ? (k.sleep(), y = c, k.fps(o), void 0) : y
              }, k.fps(A), setTimeout(function() {
                  y && (!a || 5 > k.frame) && k.useRAF(!1)
              }, 1500)
          }), aH = aJ.Ticker.prototype = new aJ.events.EventDispatcher, aH.constructor = aJ.Ticker;
          var au = aO("core.Animation", function(b, c) {
              if (this.vars = c = c || {}, this._duration = this._totalDuration = b || 0, this._delay = Number(c.delay) || 0, this._timeScale = 1, this._active = c.immediateRender === !0, this.data = c.data, this._reversed = c.reversed === !0, aL) {
                  aG || aU.wake();
                  var a = this.vars.useFrames ? at : aL;
                  a.add(this, a._time), this.vars.paused && this.paused(!0)
              }
          });
          aU = au.ticker = new aJ.Ticker, aH = au.prototype, aH._dirty = aH._gc = aH._initted = aH._paused = !1, aH._totalTime = aH._time = 0, aH._rawPrevTime = -1, aH._next = aH._last = aH._onUpdate = aH._timeline = aH.timeline = null, aH._paused = !1;
          var ar = function() {
              aG && aK() - af > 2000 && aU.wake(), setTimeout(ar, 2000)
          };
          ar(), aH.play = function(a, b) {
              return null != a && this.seek(a, b), this.reversed(!1).paused(!1)
          }, aH.pause = function(a, b) {
              return null != a && this.seek(a, b), this.paused(!0)
          }, aH.resume = function(a, b) {
              return null != a && this.seek(a, b), this.paused(!1)
          }, aH.seek = function(a, b) {
              return this.totalTime(Number(a), b !== !1)
          }, aH.restart = function(a, b) {
              return this.reversed(!1).paused(!1).totalTime(a ? -this._delay : 0, b !== !1, !0)
          }, aH.reverse = function(a, b) {
              return null != a && this.seek(a || this.totalDuration(), b), this.reversed(!0).paused(!1)
          }, aH.render = function() {}, aH.invalidate = function() {
              return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, (this._gc || !this.timeline) && this._enabled(!0), this
          }, aH.isActive = function() {
              var b, c = this._timeline,
                  a = this._startTime;
              return !c || !this._gc && !this._paused && c.isActive() && (b = c.rawTime()) >= a && a + this.totalDuration() / this._timeScale > b
          }, aH._enabled = function(a, b) {
              return aG || aU.wake(), this._gc = !a, this._active = this.isActive(), b !== !0 && (a && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !a && this.timeline && this._timeline._remove(this, !0)), !1
          }, aH._kill = function() {
              return this._enabled(!1, !1)
          }, aH.kill = function(a, b) {
              return this._kill(a, b), this
          }, aH._uncache = function(a) {
              for (var b = a ? this : this.timeline; b;) {
                  b._dirty = !0, b = b.timeline
              }
              return this
          }, aH._swapSelfInParams = function(b) {
              for (var c = b.length, a = b.concat(); --c > -1;) {
                  "{self}" === b[c] && (a[c] = this)
              }
              return a
          }, aH.eventCallback = function(b, f, a, c) {
              if ("on" === (b || "").substr(0, 2)) {
                  var d = this.vars;
                  if (1 === arguments.length) {
                      return d[b]
                  }
                  null == f ? delete d[b] : (d[b] = f, d[b + "Params"] = aS(a) && -1 !== a.join("").indexOf("{self}") ? this._swapSelfInParams(a) : a, d[b + "Scope"] = c), "onUpdate" === b && (this._onUpdate = f)
              }
              return this
          }, aH.delay = function(a) {
              return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + a - this._delay), this._delay = a, this) : this._delay
          }, aH.duration = function(a) {
              return arguments.length ? (this._duration = this._totalDuration = a, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== a && this.totalTime(this._totalTime * (a / this._duration), !0), this) : (this._dirty = !1, this._duration)
          }, aH.totalDuration = function(a) {
              return this._dirty = !1, arguments.length ? this.duration(a) : this._totalDuration
          }, aH.time = function(a, b) {
              return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(a > this._duration ? this._duration : a, b)) : this._time
          }, aH.totalTime = function(b, f, a) {
              if (aG || aU.wake(), !arguments.length) {
                  return this._totalTime
              }
              if (this._timeline) {
                  if (0 > b && !a && (b += this.totalDuration()), this._timeline.smoothChildTiming) {
                      this._dirty && this.totalDuration();
                      var c = this._totalDuration,
                          d = this._timeline;
                      if (b > c && !a && (b = c), this._startTime = (this._paused ? this._pauseTime : d._time) - (this._reversed ? c - b : b) / this._timeScale, d._dirty || this._uncache(!1), d._timeline) {
                          for (; d._timeline;) {
                              d._timeline._time !== (d._startTime + d._totalTime) / d._timeScale && d.totalTime(d._totalTime, !0), d = d._timeline
                          }
                      }
                  }
                  this._gc && this._enabled(!0, !1), (this._totalTime !== b || 0 === this._duration) && (this.render(b, f, !1), am.length && aE())
              }
              return this
          }, aH.progress = aH.totalProgress = function(a, b) {
              return arguments.length ? this.totalTime(this.duration() * a, b) : this._time / this.duration()
          }, aH.startTime = function(a) {
              return arguments.length ? (a !== this._startTime && (this._startTime = a, this.timeline && this.timeline._sortChildren && this.timeline.add(this, a - this._delay)), this) : this._startTime
          }, aH.endTime = function(a) {
              return this._startTime + (0 != a ? this.totalDuration() : this.duration()) / this._timeScale
          }, aH.timeScale = function(b) {
              if (!arguments.length) {
                  return this._timeScale
              }
              if (b = b || aV, this._timeline && this._timeline.smoothChildTiming) {
                  var c = this._pauseTime,
                      a = c || 0 === c ? c : this._timeline.totalTime();
                  this._startTime = a - (a - this._startTime) * this._timeScale / b
              }
              return this._timeScale = b, this._uncache(!1)
          }, aH.reversed = function(a) {
              return arguments.length ? (a != this._reversed && (this._reversed = a, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed
          }, aH.paused = function(b) {
              if (!arguments.length) {
                  return this._paused
              }
              if (b != this._paused && this._timeline) {
                  aG || b || aU.wake();
                  var d = this._timeline,
                      a = d.rawTime(),
                      c = a - this._pauseTime;
                  !b && d.smoothChildTiming && (this._startTime += c, this._uncache(!1)), this._pauseTime = b ? a : null, this._paused = b, this._active = this.isActive(), !b && 0 !== c && this._initted && this.duration() && this.render(d.smoothChildTiming ? this._totalTime : (a - this._startTime) / this._timeScale, !0, !0)
              }
              return this._gc && !b && this._enabled(!0, !1), this
          };
          var ai = aO("core.SimpleTimeline", function(a) {
              au.call(this, 0, a), this.autoRemoveChildren = this.smoothChildTiming = !0
          });
          aH = ai.prototype = new au, aH.constructor = ai, aH.kill()._gc = !1, aH._first = aH._last = aH._recent = null, aH._sortChildren = !1, aH.add = aH.insert = function(b, d) {
              var a, c;
              if (b._startTime = Number(d || 0) + b._delay, b._paused && this !== b._timeline && (b._pauseTime = b._startTime + (this.rawTime() - b._startTime) / b._timeScale), b.timeline && b.timeline._remove(b, !0), b.timeline = b._timeline = this, b._gc && b._enabled(!0, !0), a = this._last, this._sortChildren) {
                  for (c = b._startTime; a && a._startTime > c;) {
                      a = a._prev
                  }
              }
              return a ? (b._next = a._next, a._next = b) : (b._next = this._first, this._first = b), b._next ? b._next._prev = b : this._last = b, b._prev = a, this._recent = b, this._timeline && this._uncache(!0), this
          }, aH._remove = function(a, b) {
              return a.timeline === this && (b || a._enabled(!1, !0), a._prev ? a._prev._next = a._next : this._first === a && (this._first = a._next), a._next ? a._next._prev = a._prev : this._last === a && (this._last = a._prev), a._next = a._prev = a.timeline = null, a === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this
          }, aH.render = function(b, f, a) {
              var c, d = this._first;
              for (this._totalTime = this._time = this._rawPrevTime = b; d;) {
                  c = d._next, (d._active || b >= d._startTime && !d._paused) && (d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (b - d._startTime) * d._timeScale, f, a) : d.render((b - d._startTime) * d._timeScale, f, a)), d = c
              }
          }, aH.rawTime = function() {
              return aG || aU.wake(), this._totalTime
          };
          var aq = aO("TweenLite", function(j, c, f) {
                  if (au.call(this, c, f), this.render = aq.prototype.render, null == j) {
                      throw "Cannot tween a null target."
                  }
                  this.target = j = "string" != typeof j ? j : aq.selector(j) || j;
                  var g, l, b, k = j.jquery || j.length && j !== aB && j[0] && (j[0] === aB || j[0].nodeType && j[0].style && !j.nodeType),
                      d = this.vars.overwrite;
                  if (this._overwrite = d = null == d ? J[aq.defaultOverwrite] : "number" == typeof d ? d >> 0 : J[d], (k || j instanceof Array || j.push && aS(j)) && "number" != typeof j[0]) {
                      for (this._targets = b = aA(j), this._propLookup = [], this._siblings = [], g = 0; b.length > g; g++) {
                          l = b[g], l ? "string" != typeof l ? l.length && l !== aB && l[0] && (l[0] === aB || l[0].nodeType && l[0].style && !l.nodeType) ? (b.splice(g--, 1), this._targets = b = b.concat(aA(l))) : (this._siblings[g] = ab(l, this, !1), 1 === d && this._siblings[g].length > 1 && aa(l, this, null, 1, this._siblings[g])) : (l = b[g--] = aq.selector(l), "string" == typeof l && b.splice(g + 1, 1)) : b.splice(g--, 1)
                      }
                  } else {
                      this._propLookup = {}, this._siblings = ab(j, this, !1), 1 === d && this._siblings.length > 1 && aa(j, this, null, 1, this._siblings)
                  }(this.vars.immediateRender || 0 === c && 0 === this._delay && this.vars.immediateRender !== !1) && (this._time = -aV, this.render(-this._delay))
              }, !0),
              ak = function(a) {
                  return a && a.length && a !== aB && a[0] && (a[0] === aB || a[0].nodeType && a[0].style && !a.nodeType)
              },
              av = function(b, d) {
                  var a, c = {};
                  for (a in b) {
                      ac[a] || a in d && "transform" !== a && "x" !== a && "y" !== a && "width" !== a && "height" !== a && "className" !== a && "border" !== a || !(!aj[a] || aj[a] && aj[a]._autoCSS) || (c[a] = b[a], delete b[a])
                  }
                  b.css = c
              };
          aH = aq.prototype = new au, aH.constructor = aq, aH.kill()._gc = !1, aH.ratio = 0, aH._firstPT = aH._targets = aH._overwrittenProps = aH._startAt = null, aH._notifyPluginsOfEnabled = aH._lazy = !1, aq.version = "1.15.0", aq.defaultEase = aH._ease = new ad(null, null, 1, 1), aq.defaultOverwrite = "auto", aq.ticker = aU, aq.autoSleep = !0, aq.lagSmoothing = function(a, b) {
              aU.lagSmoothing(a, b)
          }, aq.selector = aB.$ || aB.jQuery || function(b) {
              var a = aB.$ || aB.jQuery;
              return a ? (aq.selector = a, a(b)) : "undefined" == typeof document ? b : document.querySelectorAll ? document.querySelectorAll(b) : document.getElementById("#" === b.charAt(0) ? b.substr(1) : b)
          };
          var am = [],
              ap = {},
              ao = aq._internals = {
                  isArray: aS,
                  isSelector: ak,
                  lazyTweens: am
              },
              aj = aq._plugins = {},
              al = ao.tweenLookup = {},
              K = 0,
              ac = ao.reservedProps = {
                  ease: 1,
                  delay: 1,
                  overwrite: 1,
                  onComplete: 1,
                  onCompleteParams: 1,
                  onCompleteScope: 1,
                  useFrames: 1,
                  runBackwards: 1,
                  startAt: 1,
                  onUpdate: 1,
                  onUpdateParams: 1,
                  onUpdateScope: 1,
                  onStart: 1,
                  onStartParams: 1,
                  onStartScope: 1,
                  onReverseComplete: 1,
                  onReverseCompleteParams: 1,
                  onReverseCompleteScope: 1,
                  onRepeat: 1,
                  onRepeatParams: 1,
                  onRepeatScope: 1,
                  easeParams: 1,
                  yoyo: 1,
                  immediateRender: 1,
                  repeat: 1,
                  repeatDelay: 1,
                  data: 1,
                  paused: 1,
                  reversed: 1,
                  autoCSS: 1,
                  lazy: 1,
                  onOverwrite: 1
              },
              J = {
                  none: 0,
                  all: 1,
                  auto: 2,
                  concurrent: 3,
                  allOnStart: 4,
                  preexisting: 5,
                  "true": 1,
                  "false": 0
              },
              at = au._rootFramesTimeline = new ai,
              aL = au._rootTimeline = new ai,
              aE = ao.lazyRender = function() {
                  var a, b = am.length;
                  for (ap = {}; --b > -1;) {
                      a = am[b], a && a._lazy !== !1 && (a.render(a._lazy[0], a._lazy[1], !0), a._lazy = !1)
                  }
                  am.length = 0
              };
          aL._startTime = aU.time, at._startTime = aU.frame, aL._active = at._active = !0, setTimeout(aE, 1), au._updateRoot = aq.render = function() {
              var b, c, a;
              if (am.length && aE(), aL.render((aU.time - aL._startTime) * aL._timeScale, !1, !1), at.render((aU.frame - at._startTime) * at._timeScale, !1, !1), am.length && aE(), !(aU.frame % 120)) {
                  for (a in al) {
                      for (c = al[a].tweens, b = c.length; --b > -1;) {
                          c[b]._gc && c.splice(b, 1)
                      }
                      0 === c.length && delete al[a]
                  }
                  if (a = aL._first, (!a || a._paused) && aq.autoSleep && !at._first && 1 === aU._listeners.tick.length) {
                      for (; a && a._paused;) {
                          a = a._next
                      }
                      a || aU.sleep()
                  }
              }
          }, aU.addEventListener("tick", au._updateRoot);
          var ab = function(b, f, a) {
                  var c, d, g = b._gsTweenID;
                  if (al[g || (b._gsTweenID = g = "t" + K++)] || (al[g] = {
                          target: b,
                          tweens: []
                      }), f && (c = al[g].tweens, c[d = c.length] = f, a)) {
                      for (; --d > -1;) {
                          c[d] === f && c.splice(d, 1)
                      }
                  }
                  return al[g].tweens
              },
              an = function(d, h, c, f) {
                  var g, j, b = d.vars.onOverwrite;
                  return b && (g = b(d, h, c, f)), b = aq.onOverwrite, b && (j = b(d, h, c, f)), g !== !1 && j !== !1
              },
              aa = function(A, w, m, B, b) {
                  var j, y, g, q;
                  if (1 === B || B >= 4) {
                      for (q = b.length, j = 0; q > j; j++) {
                          if ((g = b[j]) !== w) {
                              g._gc || an(g, w) && g._enabled(!1, !1) && (y = !0)
                          } else {
                              if (5 === B) {
                                  break
                              }
                          }
                      }
                      return y
                  }
                  var k, z = w._startTime + aV,
                      d = [],
                      x = 0,
                      v = 0 === w._duration;
                  for (j = b.length; --j > -1;) {
                      (g = b[j]) === w || g._gc || g._paused || (g._timeline !== w._timeline ? (k = k || H(w, 0, v), 0 === H(g, k, v) && (d[x++] = g)) : z >= g._startTime && g._startTime + g.totalDuration() / g._timeScale > z && ((v || !g._initted) && 2e-10 >= z - g._startTime || (d[x++] = g)))
                  }
                  for (j = x; --j > -1;) {
                      if (g = d[j], 2 === B && g._kill(m, A, w) && (y = !0), 2 !== B || !g._firstPT && g._initted) {
                          if (2 !== B && !an(g, w)) {
                              continue
                          }
                          g._enabled(!1, !1) && (y = !0)
                      }
                  }
                  return y
              },
              H = function(b, f, a) {
                  for (var c = b._timeline, d = c._timeScale, g = b._startTime; c._timeline;) {
                      if (g += c._startTime, d *= c._timeScale, c._paused) {
                          return -100
                      }
                      c = c._timeline
                  }
                  return g /= d, g > f ? g - f : a && g === f || !b._initted && 2 * aV > g - f ? aV : (g += b.totalDuration() / b._timeScale / d) > f + aV ? 0 : g - f - aV
              };
          aH._init = function() {
              var p, k, g, q, b, d = this.vars,
                  m = this._overwrittenProps,
                  c = this._duration,
                  j = !!d.immediateRender,
                  f = d.ease;
              if (d.startAt) {
                  this._startAt && (this._startAt.render(-1, !0), this._startAt.kill()), b = {};
                  for (q in d.startAt) {
                      b[q] = d.startAt[q]
                  }
                  if (b.overwrite = !1, b.immediateRender = !0, b.lazy = j && d.lazy !== !1, b.startAt = b.delay = null, this._startAt = aq.to(this.target, 0, b), j) {
                      if (this._time > 0) {
                          this._startAt = null
                      } else {
                          if (0 !== c) {
                              return
                          }
                      }
                  }
              } else {
                  if (d.runBackwards && 0 !== c) {
                      if (this._startAt) {
                          this._startAt.render(-1, !0), this._startAt.kill(), this._startAt = null
                      } else {
                          0 !== this._time && (j = !1), g = {};
                          for (q in d) {
                              ac[q] && "autoCSS" !== q || (g[q] = d[q])
                          }
                          if (g.overwrite = 0, g.data = "isFromStart", g.lazy = j && d.lazy !== !1, g.immediateRender = j, this._startAt = aq.to(this.target, 0, g), j) {
                              if (0 === this._time) {
                                  return
                              }
                          } else {
                              this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null)
                          }
                      }
                  }
              }
              if (this._ease = f = f ? f instanceof ad ? f : "function" == typeof f ? new ad(f, d.easeParams) : ay[f] || aq.defaultEase : aq.defaultEase, d.easeParams instanceof Array && f.config && (this._ease = f.config.apply(f, d.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets) {
                  for (p = this._targets.length; --p > -1;) {
                      this._initProps(this._targets[p], this._propLookup[p] = {}, this._siblings[p], m ? m[p] : null) && (k = !0)
                  }
              } else {
                  k = this._initProps(this.target, this._propLookup, this._siblings, m)
              }
              if (k && aq._onPluginEvent("_onInitAllProps", this), m && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), d.runBackwards) {
                  for (g = this._firstPT; g;) {
                      g.s += g.c, g.c = -g.c, g = g._next
                  }
              }
              this._onUpdate = d.onUpdate, this._initted = !0
          }, aH._initProps = function(k, g, q, b) {
              var d, m, c, j, f, p;
              if (null == k) {
                  return !1
              }
              ap[k._gsTweenID] && aE(), this.vars.css || k.style && k !== aB && k.nodeType && aj.css && this.vars.autoCSS !== !1 && av(this.vars, k);
              for (d in this.vars) {
                  if (p = this.vars[d], ac[d]) {
                      p && (p instanceof Array || p.push && aS(p)) && -1 !== p.join("").indexOf("{self}") && (this.vars[d] = p = this._swapSelfInParams(p, this))
                  } else {
                      if (aj[d] && (j = new aj[d])._onInitTween(k, this.vars[d], this)) {
                          for (this._firstPT = f = {
                                  _next: this._firstPT,
                                  t: j,
                                  p: "setRatio",
                                  s: 0,
                                  c: 1,
                                  f: !0,
                                  n: d,
                                  pg: !0,
                                  pr: j._priority
                              }, m = j._overwriteProps.length; --m > -1;) {
                              g[j._overwriteProps[m]] = this._firstPT
                          }(j._priority || j._onInitAllProps) && (c = !0), (j._onDisable || j._onEnable) && (this._notifyPluginsOfEnabled = !0)
                      } else {
                          this._firstPT = g[d] = f = {
                              _next: this._firstPT,
                              t: k,
                              p: d,
                              f: "function" == typeof k[d],
                              n: d,
                              pg: !1,
                              pr: 0
                          }, f.s = f.f ? k[d.indexOf("set") || "function" != typeof k["get" + d.substr(3)] ? d : "get" + d.substr(3)]() : parseFloat(k[d]), f.c = "string" == typeof p && "=" === p.charAt(1) ? parseInt(p.charAt(0) + "1", 10) * Number(p.substr(2)) : Number(p) - f.s || 0
                      }
                  }
                  f && f._next && (f._next._prev = f)
              }
              return b && this._kill(b, k) ? this._initProps(k, g, q, b) : this._overwrite > 1 && this._firstPT && q.length > 1 && aa(k, this, g, this._overwrite, q) ? (this._kill(g, k), this._initProps(k, g, q, b)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (ap[k._gsTweenID] = !0), c)
          }, aH.render = function(y, q, k) {
              var z, b, g, w, f = this._time,
                  m = this._duration,
                  j = this._rawPrevTime;
              if (y >= m) {
                  this._totalTime = this._time = m, this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1, this._reversed || (z = !0, b = "onComplete"), 0 === m && (this._initted || !this.vars.lazy || k) && (this._startTime === this._timeline._duration && (y = 0), (0 === y || 0 > j || j === aV && "isPause" !== this.data) && j !== y && (k = !0, j > aV && (b = "onReverseComplete")), this._rawPrevTime = w = !q || y || j === y ? y : aV)
              } else {
                  if (1e-7 > y) {
                      this._totalTime = this._time = 0, this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0, (0 !== f || 0 === m && j > 0 && j !== aV) && (b = "onReverseComplete", z = this._reversed), 0 > y && (this._active = !1, 0 === m && (this._initted || !this.vars.lazy || k) && (j >= 0 && (j !== aV || "isPause" !== this.data) && (k = !0), this._rawPrevTime = w = !q || y || j === y ? y : aV)), this._initted || (k = !0)
                  } else {
                      if (this._totalTime = this._time = y, this._easeType) {
                          var x = y / m,
                              d = this._easeType,
                              v = this._easePower;
                          (1 === d || 3 === d && x >= 0.5) && (x = 1 - x), 3 === d && (x *= 2), 1 === v ? x *= x : 2 === v ? x *= x * x : 3 === v ? x *= x * x * x : 4 === v && (x *= x * x * x * x), this.ratio = 1 === d ? 1 - x : 2 === d ? x : 0.5 > y / m ? x / 2 : 1 - x / 2
                      } else {
                          this.ratio = this._ease.getRatio(y / m)
                      }
                  }
              }
              if (this._time !== f || k) {
                  if (!this._initted) {
                      if (this._init(), !this._initted || this._gc) {
                          return
                      }
                      if (!k && this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration)) {
                          return this._time = this._totalTime = f, this._rawPrevTime = j, am.push(this), this._lazy = [y, q], void 0
                      }
                      this._time && !z ? this.ratio = this._ease.getRatio(this._time / m) : z && this._ease._calcEnd && (this.ratio = this._ease.getRatio(0 === this._time ? 0 : 1))
                  }
                  for (this._lazy !== !1 && (this._lazy = !1), this._active || !this._paused && this._time !== f && y >= 0 && (this._active = !0), 0 === f && (this._startAt && (y >= 0 ? this._startAt.render(y, q, k) : b || (b = "_dummyGS")), this.vars.onStart && (0 !== this._time || 0 === m) && (q || this.vars.onStart.apply(this.vars.onStartScope || this, this.vars.onStartParams || aw))), g = this._firstPT; g;) {
                      g.f ? g.t[g.p](g.c * this.ratio + g.s) : g.t[g.p] = g.c * this.ratio + g.s, g = g._next
                  }
                  this._onUpdate && (0 > y && this._startAt && y !== -0.0001 && this._startAt.render(y, q, k), q || (this._time !== f || z) && this._onUpdate.apply(this.vars.onUpdateScope || this, this.vars.onUpdateParams || aw)), b && (!this._gc || k) && (0 > y && this._startAt && !this._onUpdate && y !== -0.0001 && this._startAt.render(y, q, k), z && (this._timeline.autoRemoveChildren && this._enabled(!1, !1), this._active = !1), !q && this.vars[b] && this.vars[b].apply(this.vars[b + "Scope"] || this, this.vars[b + "Params"] || aw), 0 === m && this._rawPrevTime === aV && w !== aV && (this._rawPrevTime = 0))
              }
          }, aH._kill = function(v, k, g) {
              if ("all" === v && (v = null), null == v && (null == k || k === this.target)) {
                  return this._lazy = !1, this._enabled(!1, !1)
              }
              k = "string" != typeof k ? k || this._targets || this.target : aq.selector(k) || k;
              var w, b, d, m, c, j, f, p, q;
              if ((aS(k) || ak(k)) && "number" != typeof k[0]) {
                  for (w = k.length; --w > -1;) {
                      this._kill(v, k[w]) && (j = !0)
                  }
              } else {
                  if (this._targets) {
                      for (w = this._targets.length; --w > -1;) {
                          if (k === this._targets[w]) {
                              c = this._propLookup[w] || {}, this._overwrittenProps = this._overwrittenProps || [], b = this._overwrittenProps[w] = v ? this._overwrittenProps[w] || {} : "all";
                              break
                          }
                      }
                  } else {
                      if (k !== this.target) {
                          return !1
                      }
                      c = this._propLookup, b = this._overwrittenProps = v ? this._overwrittenProps || {} : "all"
                  }
                  if (c) {
                      if (f = v || c, p = v !== b && "all" !== b && v !== c && ("object" != typeof v || !v._tempKill), g && (aq.onOverwrite || this.vars.onOverwrite)) {
                          for (d in f) {
                              c[d] && (q || (q = []), q.push(d))
                          }
                          if (!an(this, g, k, q)) {
                              return !1
                          }
                      }
                      for (d in f) {
                          (m = c[d]) && (m.pg && m.t._kill(f) && (j = !0), m.pg && 0 !== m.t._overwriteProps.length || (m._prev ? m._prev._next = m._next : m === this._firstPT && (this._firstPT = m._next), m._next && (m._next._prev = m._prev), m._next = m._prev = null), delete c[d]), p && (b[d] = 1)
                      }!this._firstPT && this._initted && this._enabled(!1, !1)
                  }
              }
              return j
          }, aH.invalidate = function() {
              return this._notifyPluginsOfEnabled && aq._onPluginEvent("_onDisable", this), this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], au.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -aV, this.render(-this._delay)), this
          }, aH._enabled = function(b, d) {
              if (aG || aU.wake(), b && this._gc) {
                  var a, c = this._targets;
                  if (c) {
                      for (a = c.length; --a > -1;) {
                          this._siblings[a] = ab(c[a], this, !0)
                      }
                  } else {
                      this._siblings = ab(this.target, this, !0)
                  }
              }
              return au.prototype._enabled.call(this, b, d), this._notifyPluginsOfEnabled && this._firstPT ? aq._onPluginEvent(b ? "_onEnable" : "_onDisable", this) : !1
          }, aq.to = function(b, c, a) {
              return new aq(b, c, a)
          }, aq.from = function(b, c, a) {
              return a.runBackwards = !0, a.immediateRender = 0 != a.immediateRender, new aq(b, c, a)
          }, aq.fromTo = function(b, d, a, c) {
              return c.startAt = a, c.immediateRender = 0 != c.immediateRender && 0 != a.immediateRender, new aq(b, d, c)
          }, aq.delayedCall = function(b, f, a, c, d) {
              return new aq(f, 0, {
                  delay: b,
                  onComplete: f,
                  onCompleteParams: a,
                  onCompleteScope: c,
                  onReverseComplete: f,
                  onReverseCompleteParams: a,
                  onReverseCompleteScope: c,
                  immediateRender: !1,
                  lazy: !1,
                  useFrames: d,
                  overwrite: 0
              })
          }, aq.set = function(a, b) {
              return new aq(a, 0, b)
          }, aq.getTweensOf = function(b, f) {
              if (null == b) {
                  return []
              }
              b = "string" != typeof b ? b : aq.selector(b) || b;
              var a, c, d, g;
              if ((aS(b) || ak(b)) && "number" != typeof b[0]) {
                  for (a = b.length, c = []; --a > -1;) {
                      c = c.concat(aq.getTweensOf(b[a], f))
                  }
                  for (a = c.length; --a > -1;) {
                      for (g = c[a], d = a; --d > -1;) {
                          g === c[d] && c.splice(a, 1)
                      }
                  }
              } else {
                  for (c = ab(b).concat(), a = c.length; --a > -1;) {
                      (c[a]._gc || f && !c[a].isActive()) && c.splice(a, 1)
                  }
              }
              return c
          }, aq.killTweensOf = aq.killDelayedCallsTo = function(b, f, a) {
              "object" == typeof f && (a = f, f = !1);
              for (var c = aq.getTweensOf(b, f), d = c.length; --d > -1;) {
                  c[d]._kill(a, b)
              }
          };
          var ag = aO("plugins.TweenPlugin", function(a, b) {
              this._overwriteProps = (a || "").split(","), this._propName = this._overwriteProps[0], this._priority = b || 0, this._super = ag.prototype
          }, !0);
          if (aH = ag.prototype, ag.version = "1.10.1", ag.API = 2, aH._firstPT = null, aH._addTween = function(d, h, c, f, g, k) {
                  var b, j;
                  return null != f && (b = "number" == typeof f || "=" !== f.charAt(1) ? Number(f) - c : parseInt(f.charAt(0) + "1", 10) * Number(f.substr(2))) ? (this._firstPT = j = {
                      _next: this._firstPT,
                      t: d,
                      p: h,
                      s: c,
                      c: b,
                      f: "function" == typeof d[h],
                      n: g || h,
                      r: k
                  }, j._next && (j._next._prev = j), j) : void 0
              }, aH.setRatio = function(b) {
                  for (var d, a = this._firstPT, c = 0.000001; a;) {
                      d = a.c * b + a.s, a.r ? d = Math.round(d) : c > d && d > -c && (d = 0), a.f ? a.t[a.p](d) : a.t[a.p] = d, a = a._next
                  }
              }, aH._kill = function(b) {
                  var d, a = this._overwriteProps,
                      c = this._firstPT;
                  if (null != b[this._propName]) {
                      this._overwriteProps = []
                  } else {
                      for (d = a.length; --d > -1;) {
                          null != b[a[d]] && a.splice(d, 1)
                      }
                  }
                  for (; c;) {
                      null != b[c.n] && (c._next && (c._next._prev = c._prev), c._prev ? (c._prev._next = c._next, c._prev = null) : this._firstPT === c && (this._firstPT = c._next)), c = c._next
                  }
                  return !1
              }, aH._roundProps = function(b, c) {
                  for (var a = this._firstPT; a;) {
                      (b[this._propName] || null != a.n && b[a.n.split(this._propName + "_").join("")]) && (a.r = c), a = a._next
                  }
              }, aq._onPluginEvent = function(d, h) {
                  var c, f, g, k, b, j = h._firstPT;
                  if ("_onInitAllProps" === d) {
                      for (; j;) {
                          for (b = j._next, f = g; f && f.pr > j.pr;) {
                              f = f._next
                          }(j._prev = f ? f._prev : k) ? j._prev._next = j: g = j, (j._next = f) ? f._prev = j : k = j, j = b
                      }
                      j = h._firstPT = g
                  }
                  for (; j;) {
                      j.pg && "function" == typeof j.t[d] && j.t[d]() && (c = !0), j = j._next
                  }
                  return c
              }, ag.activate = function(a) {
                  for (var b = a.length; --b > -1;) {
                      a[b].API === ag.API && (aj[(new a[b])._propName] = a[b])
                  }
                  return !0
              }, aR.plugin = function(d) {
                  if (!(d && d.propName && d.init && d.API)) {
                      throw "illegal plugin definition."
                  }
                  var h, c = d.propName,
                      f = d.priority || 0,
                      g = d.overwriteProps,
                      k = {
                          init: "_onInitTween",
                          set: "setRatio",
                          kill: "_kill",
                          round: "_roundProps",
                          initAll: "_onInitAllProps"
                      },
                      b = aO("plugins." + c.charAt(0).toUpperCase() + c.substr(1) + "Plugin", function() {
                          ag.call(this, c, f), this._overwriteProps = g || []
                      }, d.global === !0),
                      j = b.prototype = new ag(c);
                  j.constructor = b, b.API = d.API;
                  for (h in k) {
                      "function" == typeof d[h] && (j[k[h]] = d[h])
                  }
                  return b.version = d.version, ag.activate([b]), b
              }, aC = aB._gsQueue) {
              for (aD = 0; aC.length > aD; aD++) {
                  aC[aD]()
              }
              for (aH in aP) {
                  aP[aH].func || aB.console.log("GSAP encountered missing dependency: com.greensock." + aH)
              }
          }
          aG = !1
      }
  }("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenMax");
/*!
* VERSION: 0.1.9
* DATE: 2014-07-22
* UPDATES AND DOCS AT: http://www.greensock.com/jquery-gsap-plugin/
*
* Requires TweenLite version 1.8.0 or higher and CSSPlugin.
*
* @license Copyright (c) 2014, GreenSock. All rights reserved.
* This work is subject to the terms at http://www.greensock.com/terms_of_use.html or for
* Club GreenSock members, the software agreement that was issued with your membership.
*
* @author: Jack Doyle, jack@greensock.com
*/
(function(x) {
  var m, j, y, b = x.fn.animate,
      f = x.fn.stop,
      q = !0,
      d = function(c) {
          var h, a = {};
          for (h in c) {
              a[h] = c[h]
          }
          return a
      },
      k = {
          overwrite: 1,
          delay: 1,
          useFrames: 1,
          runBackwards: 1,
          easeParams: 1,
          yoyo: 1,
          immediateRender: 1,
          repeat: 1,
          repeatDelay: 1,
          autoCSS: 1
      },
      g = function(c, h) {
          for (var a in k) {
              k[a] && void 0 !== c[a] && (h[a] = c[a])
          }
      },
      v = function(a) {
          return function(c) {
              return a.getRatio(c)
          }
      },
      w = {},
      p = function() {
          var e, i, c, h = window.GreenSockGlobals || window;
          if (m = h.TweenMax || h.TweenLite, m && (e = (m.version + ".0.0").split("."), i = !(Number(e[0]) > 0 && Number(e[1]) > 7), h = h.com.greensock, j = h.plugins.CSSPlugin, w = h.easing.Ease.map || {}), !m || !j || i) {
              return m = null, !y && window.console && (window.console.log("The jquery.gsap.js plugin requires the TweenMax (or at least TweenLite and CSSPlugin) JavaScript file(s)." + (i ? " Version " + e.join(".") + " is too old." : "")), y = !0), void 0
          }
          if (x.easing) {
              for (c in w) {
                  x.easing[c] = v(w[c])
              }
              p = !1
          }
      };
  x.fn.animate = function(B, c, l, A) {
      if (B = B || {}, p && (p(), !m || !j)) {
          return b.call(this, B, c, l, A)
      }
      if (!q || B.skipGSAP === !0 || "object" == typeof c && "function" == typeof c.step || null != B.scrollTop || null != B.scrollLeft) {
          return b.call(this, B, c, l, A)
      }
      var r, a, e, t, o = x.speed(c, l, A),
          z = {
              ease: w[o.easing] || (o.easing === !1 ? w.linear : w.swing)
          },
          u = this,
          i = "object" == typeof c ? c.specialEasing : null;
      for (a in B) {
          if (r = B[a], r instanceof Array && w[r[1]] && (i = i || {}, i[a] = r[1], r = r[0]), "toggle" === r || "hide" === r || "show" === r) {
              return b.call(this, B, c, l, A)
          }
          z[-1 === a.indexOf("-") ? a : x.camelCase(a)] = r
      }
      if (i) {
          z = d(z), t = [];
          for (a in i) {
              r = t[t.length] = {}, g(z, r), r.ease = w[i[a]] || z.ease, -1 !== a.indexOf("-") && (a = x.camelCase(a)), r[a] = z[a], delete z[a]
          }
          0 === t.length && (t = null)
      }
      return e = function(h) {
          var n, C = d(z);
          if (t) {
              for (n = t.length; --n > -1;) {
                  m.to(this, x.fx.off ? 0 : o.duration / 1000, t[n])
              }
          }
          C.onComplete = function() {
              h ? h() : o.old && x(this).each(o.old)
          }, m.to(this, x.fx.off ? 0 : o.duration / 1000, C)
      }, o.queue !== !1 ? (u.queue(o.queue, e), "function" == typeof o.old && u.queue(o.queue, function(h) {
          o.old.call(this), h()
      })) : e.call(u), u
  }, x.fn.stop = function(h, e) {
      if (f.call(this, h, e), m) {
          if (e) {
              for (var l, n = m.getTweensOf(this), c = n.length; --c > -1;) {
                  l = n[c].totalTime() / n[c].totalDuration(), l > 0 && 1 > l && n[c].seek(n[c].totalDuration())
              }
          }
          m.killTweensOf(this)
      }
      return this
  }, x.gsap = {
      enabled: function(a) {
          q = a
      },
      version: "0.1.9"
  }
})(jQuery);
var SWS = window.SWS || {};
var isSupportMatchMedia = window.isSupportMatchMedia || (window.matchMedia !== undefined) ? true : false;
if (!SWS.DEV) {
SWS.DEV = false
}
$(function() {
SWS.scrolling = false;
SWS.scrollTop = 0;
SWS.$win = $(window);
SWS.$html = $("html");
SWS.$body = $("body");
SWS.$header = $(".custom-header-group");
SWS.$footer = $(".wrapper-footer");
SWS.$win.scroll(function() {
    SWS.scrolling = true
});
SWS.adNormalClose = {
    search : false,
    sideNav : false
}
SWS.schClickEvent = false;
SWS.languageCloseClickEvent = false;
var MacOs = navigator.userAgent;
if (MacOs.indexOf("Mac") !== -1) SWS.$html.addClass("Mac");
});
window.log = function f() {
    log.history = log.history || [];
    log.history.push(arguments);
    if (this.console) {
        var a = arguments,
            b;
        a.callee = a.callee.caller;
        b = [].slice.call(a);
        if (typeof console.log === "object") {
            log.apply.call(console.log, console, b)
        } else {
            console.log.apply(console, b)
        }
    }
};
(function(b) {
    var a = {};
    var c = {
        videoWidth: "100%",
        videoHeight: "auto",
        videoIdBase: "ytplayer",
        color: "white",
        autoplay: 0,
        theme: "dark",
        controls: 1,
        targetId: "",
        onReady: undefined
    };
    b.fn.ytiframe = function(e) {
        if (this.length == 0) {
            return this
        }
        if (this.length > 1) {
            this.each(function() {
                b(this).ytiframe(e)
            });
            return this
        }
        var d = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
        var g = {},
            h = this,
            j = {};
        a.el = this;
        var i = function() {
            b.extend(j, c, e);
            g.url = h.attr("href");
            g.videoId = "";
            g.ytId = "";
            g.ytId = g.url.match(d)[2];
            g.videoId = j.videoIdBase + g.ytId;
            if (j.targetId == "") {
                if (h.parents(".flexible-obj").length > 0) {
                    g.container = h.wrap('<div class="video-player" />').parent()
                } else {
                    g.container = h.wrap('<div class="video-player flexible-obj" />').parent()
                }
                g.embed = b('<iframe src="https://www.youtube.com/embed/' + g.ytId + "?autoplay=1&loop=1&rel=0&wmode=transparent&showinfo=0&color=" + j.color + "&theme=" + j.theme + "&enablejsapi=1&rel=0&controls=" + j.controls + '" frameborder="0" title="유튜브 영상" allow="autoplay; encrypted-media" allowfullscreen></iframe>').attr("id", g.videoId).addClass("video-iframe").appendTo(g.container)
            } else {
                b("#" + j.targetId).html("");
                g.embed = b('<iframe src="https://www.youtube.com/embed/' + g.ytId + "?autoplay=1&loop=1&rel=0&wmode=transparent&showinfo=0&color=" + j.color + "&theme=" + j.theme + "&enablejsapi=1&rel=0&controls=" + j.controls + '" frameborder="0" title="유튜브 영상" allow="autoplay; encrypted-media" allowfullscreen></iframe>').attr("id", g.videoId).appendTo(b("#" + j.targetId))
            }
            if (typeof j.onReady === "function") {
                j.onReady(g.embed)
            }
            if (j.targetId == "") {
                h.hide()
            }
        };
        i();
        h.pause = function() {
            console.log(h + " pause")
        };
        h.destroyPlayer = function() {
            if (g.embed) {
                g.embed.remove();
                h.css("display", "");
                h.unwrap()
            }
        };
        return this
    }
})(jQuery);
var swfobject = function() {
    var aq = "undefined",
        aD = "object",
        ab = "Shockwave Flash",
        X = "ShockwaveFlash.ShockwaveFlash",
        aE = "application/x-shockwave-flash",
        ac = "SWFObjectExprInst",
        ax = "onreadystatechange",
        af = window,
        aL = document,
        aB = navigator,
        aa = false,
        Z = [aN],
        aG = [],
        ag = [],
        al = [],
        aJ, ad, ap, at, ak = false,
        aU = false,
        aH, an, aI = true,
        ah = function() {
            var a = typeof aL.getElementById != aq && typeof aL.getElementsByTagName != aq && typeof aL.createElement != aq,
                e = aB.userAgent.toLowerCase(),
                c = aB.platform.toLowerCase(),
                i = c ? /win/.test(c) : /win/.test(e),
                k = c ? /mac/.test(c) : /mac/.test(e),
                h = /webkit/.test(e) ? parseFloat(e.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false,
                d = !+"\v1",
                g = [0, 0, 0],
                l = null;
            if (typeof aB.plugins != aq && typeof aB.plugins[ab] == aD) {
                l = aB.plugins[ab].description;
                if (l && !(typeof aB.mimeTypes != aq && aB.mimeTypes[aE] && !aB.mimeTypes[aE].enabledPlugin)) {
                    aa = true;
                    d = false;
                    l = l.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
                    g[0] = parseInt(l.replace(/^(.*)\..*$/, "$1"), 10);
                    g[1] = parseInt(l.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
                    g[2] = /[a-zA-Z]/.test(l) ? parseInt(l.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0
                }
            } else {
                if (typeof af.ActiveXObject != aq) {
                    try {
                        var j = new ActiveXObject(X);
                        if (j) {
                            l = j.GetVariable("$version");
                            if (l) {
                                d = true;
                                l = l.split(" ")[1].split(",");
                                g = [parseInt(l[0], 10), parseInt(l[1], 10), parseInt(l[2], 10)]
                            }
                        }
                    } catch (b) {}
                }
            }
            return {
                w3: a,
                pv: g,
                wk: h,
                ie: d,
                win: i,
                mac: k
            }
        }(),
        aK = function() {
            if (!ah.w3) {
                return
            }
            if ((typeof aL.readyState != aq && aL.readyState == "complete") || (typeof aL.readyState == aq && (aL.getElementsByTagName("body")[0] || aL.body))) {
                aP()
            }
            if (!ak) {
                if (typeof aL.addEventListener != aq) {
                    aL.addEventListener("DOMContentLoaded", aP, false)
                }
                if (ah.ie && ah.win) {
                    aL.attachEvent(ax, function() {
                        if (aL.readyState == "complete") {
                            aL.detachEvent(ax, arguments.callee);
                            aP()
                        }
                    });
                    if (af == top) {
                        (function() {
                            if (ak) {
                                return
                            }
                            try {
                                aL.documentElement.doScroll("left")
                            } catch (a) {
                                setTimeout(arguments.callee, 0);
                                return
                            }
                            aP()
                        })()
                    }
                }
                if (ah.wk) {
                    (function() {
                        if (ak) {
                            return
                        }
                        if (!/loaded|complete/.test(aL.readyState)) {
                            setTimeout(arguments.callee, 0);
                            return
                        }
                        aP()
                    })()
                }
                aC(aP)
            }
        }();
  
    function aP() {
        if (ak) {
            return
        }
        try {
            var b = aL.getElementsByTagName("body")[0].appendChild(ar("span"));
            b.parentNode.removeChild(b)
        } catch (a) {
            return
        }
        ak = true;
        var d = Z.length;
        for (var c = 0; c < d; c++) {
            Z[c]()
        }
    }
  
    function aj(a) {
        if (ak) {
            a()
        } else {
            Z[Z.length] = a
        }
    }
  
    function aC(a) {
        if (typeof af.addEventListener != aq) {
            af.addEventListener("load", a, false)
        } else {
            if (typeof aL.addEventListener != aq) {
                aL.addEventListener("load", a, false)
            } else {
                if (typeof af.attachEvent != aq) {
                    aM(af, "onload", a)
                } else {
                    if (typeof af.onload == "function") {
                        var b = af.onload;
                        af.onload = function() {
                            b();
                            a()
                        }
                    } else {
                        af.onload = a
                    }
                }
            }
        }
    }
  
    function aN() {
        if (aa) {
            Y()
        } else {
            am()
        }
    }
  
    function Y() {
        var d = aL.getElementsByTagName("body")[0];
        var b = ar(aD);
        b.setAttribute("type", aE);
        var a = d.appendChild(b);
        if (a) {
            var c = 0;
            (function() {
                if (typeof a.GetVariable != aq) {
                    var e = a.GetVariable("$version");
                    if (e) {
                        e = e.split(" ")[1].split(",");
                        ah.pv = [parseInt(e[0], 10), parseInt(e[1], 10), parseInt(e[2], 10)]
                    }
                } else {
                    if (c < 10) {
                        c++;
                        setTimeout(arguments.callee, 10);
                        return
                    }
                }
                d.removeChild(b);
                a = null;
                am()
            })()
        } else {
            am()
        }
    }
  
    function am() {
        var h = aG.length;
        if (h > 0) {
            for (var i = 0; i < h; i++) {
                var c = aG[i].id;
                var m = aG[i].callbackFn;
                var a = {
                    success: false,
                    id: c
                };
                if (ah.pv[0] > 0) {
                    var j = aS(c);
                    if (j) {
                        if (ao(aG[i].swfVersion) && !(ah.wk && ah.wk < 312)) {
                            ay(c, true);
                            if (m) {
                                a.success = true;
                                a.ref = av(c);
                                m(a)
                            }
                        } else {
                            if (aG[i].expressInstall && au()) {
                                var e = {};
                                e.data = aG[i].expressInstall;
                                e.width = j.getAttribute("width") || "0";
                                e.height = j.getAttribute("height") || "0";
                                if (j.getAttribute("class")) {
                                    e.styleclass = j.getAttribute("class")
                                }
                                if (j.getAttribute("align")) {
                                    e.align = j.getAttribute("align")
                                }
                                var g = {};
                                var d = j.getElementsByTagName("param");
                                var l = d.length;
                                for (var k = 0; k < l; k++) {
                                    if (d[k].getAttribute("name").toLowerCase() != "movie") {
                                        g[d[k].getAttribute("name")] = d[k].getAttribute("value")
                                    }
                                }
                                ae(e, g, c, m)
                            } else {
                                aF(j);
                                if (m) {
                                    m(a)
                                }
                            }
                        }
                    }
                } else {
                    ay(c, true);
                    if (m) {
                        var b = av(c);
                        if (b && typeof b.SetVariable != aq) {
                            a.success = true;
                            a.ref = b
                        }
                        m(a)
                    }
                }
            }
        }
    }
  
    function av(b) {
        var d = null;
        var c = aS(b);
        if (c && c.nodeName == "OBJECT") {
            if (typeof c.SetVariable != aq) {
                d = c
            } else {
                var a = c.getElementsByTagName(aD)[0];
                if (a) {
                    d = a
                }
            }
        }
        return d
    }
  
    function au() {
        return !aU && ao("6.0.65") && (ah.win || ah.mac) && !(ah.wk && ah.wk < 312)
    }
  
    function ae(g, d, i, e) {
        aU = true;
        ap = e || null;
        at = {
            success: false,
            id: i
        };
        var a = aS(i);
        if (a) {
            if (a.nodeName == "OBJECT") {
                aJ = aO(a);
                ad = null
            } else {
                aJ = a;
                ad = i
            }
            g.id = ac;
            if (typeof g.width == aq || (!/%$/.test(g.width) && parseInt(g.width, 10) < 310)) {
                g.width = "310"
            }
            if (typeof g.height == aq || (!/%$/.test(g.height) && parseInt(g.height, 10) < 137)) {
                g.height = "137"
            }
            aL.title = aL.title.slice(0, 47) + " - Flash Player Installation";
            var b = ah.ie && ah.win ? "ActiveX" : "PlugIn",
                c = "MMredirectURL=" + af.location.toString().replace(/&/g, "%26") + "&MMplayerType=" + b + "&MMdoctitle=" + aL.title;
            if (typeof d.flashvars != aq) {
                d.flashvars += "&" + c
            } else {
                d.flashvars = c
            }
            if (ah.ie && ah.win && a.readyState != 4) {
                var h = ar("div");
                i += "SWFObjectNew";
                h.setAttribute("id", i);
                a.parentNode.insertBefore(h, a);
                a.style.display = "none";
                (function() {
                    if (a.readyState == 4) {
                        a.parentNode.removeChild(a)
                    } else {
                        setTimeout(arguments.callee, 10)
                    }
                })()
            }
            aA(g, d, i)
        }
    }
  
    function aF(a) {
        if (ah.ie && ah.win && a.readyState != 4) {
            var b = ar("div");
            a.parentNode.insertBefore(b, a);
            b.parentNode.replaceChild(aO(a), b);
            a.style.display = "none";
            (function() {
                if (a.readyState == 4) {
                    a.parentNode.removeChild(a)
                } else {
                    setTimeout(arguments.callee, 10)
                }
            })()
        } else {
            a.parentNode.replaceChild(aO(a), a)
        }
    }
  
    function aO(b) {
        var d = ar("div");
        if (ah.win && ah.ie) {
            d.innerHTML = b.innerHTML
        } else {
            var e = b.getElementsByTagName(aD)[0];
            if (e) {
                var a = e.childNodes;
                if (a) {
                    var g = a.length;
                    for (var c = 0; c < g; c++) {
                        if (!(a[c].nodeType == 1 && a[c].nodeName == "PARAM") && !(a[c].nodeType == 8)) {
                            d.appendChild(a[c].cloneNode(true))
                        }
                    }
                }
            }
        }
        return d
    }
  
    function aA(e, h, c) {
        var d, a = aS(c);
        if (ah.wk && ah.wk < 312) {
            return d
        }
        if (a) {
            if (typeof e.id == aq) {
                e.id = c
            }
            if (ah.ie && ah.win) {
                var g = "";
                for (var j in e) {
                    if (e[j] != Object.prototype[j]) {
                        if (j.toLowerCase() == "data") {
                            h.movie = e[j]
                        } else {
                            if (j.toLowerCase() == "styleclass") {
                                g += ' class="' + e[j] + '"'
                            } else {
                                if (j.toLowerCase() != "classid") {
                                    g += " " + j + '="' + e[j] + '"'
                                }
                            }
                        }
                    }
                }
                var i = "";
                for (var k in h) {
                    if (h[k] != Object.prototype[k]) {
                        i += '<param name="' + k + '" value="' + h[k] + '" />'
                    }
                }
                a.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + g + ">" + i + "</object>";
                ag[ag.length] = e.id;
                d = aS(e.id)
            } else {
                var b = ar(aD);
                b.setAttribute("type", aE);
                for (var l in e) {
                    if (e[l] != Object.prototype[l]) {
                        if (l.toLowerCase() == "styleclass") {
                            b.setAttribute("class", e[l])
                        } else {
                            if (l.toLowerCase() != "classid") {
                                b.setAttribute(l, e[l])
                            }
                        }
                    }
                }
                for (var m in h) {
                    if (h[m] != Object.prototype[m] && m.toLowerCase() != "movie") {
                        aQ(b, m, h[m])
                    }
                }
                a.parentNode.replaceChild(b, a);
                d = b
            }
        }
        return d
    }
  
    function aQ(b, d, c) {
        var a = ar("param");
        a.setAttribute("name", d);
        a.setAttribute("value", c);
        b.appendChild(a)
    }
  
    function aw(a) {
        var b = aS(a);
        if (b && b.nodeName == "OBJECT") {
            if (ah.ie && ah.win) {
                b.style.display = "none";
                (function() {
                    if (b.readyState == 4) {
                        aT(a)
                    } else {
                        setTimeout(arguments.callee, 10)
                    }
                })()
            } else {
                b.parentNode.removeChild(b)
            }
        }
    }
  
    function aT(a) {
        var b = aS(a);
        if (b) {
            for (var c in b) {
                if (typeof b[c] == "function") {
                    b[c] = null
                }
            }
            b.parentNode.removeChild(b)
        }
    }
  
    function aS(a) {
        var c = null;
        try {
            c = aL.getElementById(a)
        } catch (b) {}
        return c
    }
  
    function ar(a) {
        return aL.createElement(a)
    }
  
    function aM(a, c, b) {
        a.attachEvent(c, b);
        al[al.length] = [a, c, b]
    }
  
    function ao(a) {
        var b = ah.pv,
            c = a.split(".");
        c[0] = parseInt(c[0], 10);
        c[1] = parseInt(c[1], 10) || 0;
        c[2] = parseInt(c[2], 10) || 0;
        return (b[0] > c[0] || (b[0] == c[0] && b[1] > c[1]) || (b[0] == c[0] && b[1] == c[1] && b[2] >= c[2])) ? true : false
    }
  
    function az(b, g, a, c) {
        if (ah.ie && ah.mac) {
            return
        }
        var e = aL.getElementsByTagName("head")[0];
        if (!e) {
            return
        }
        var h = (a && typeof a == "string") ? a : "screen";
        if (c) {
            aH = null;
            an = null
        }
        if (!aH || an != h) {
            var d = ar("style");
            d.setAttribute("type", "text/css");
            d.setAttribute("media", h);
            aH = e.appendChild(d);
            if (ah.ie && ah.win && typeof aL.styleSheets != aq && aL.styleSheets.length > 0) {
                aH = aL.styleSheets[aL.styleSheets.length - 1]
            }
            an = h
        }
        if (ah.ie && ah.win) {
            if (aH && typeof aH.addRule == aD) {
                aH.addRule(b, g)
            }
        } else {
            if (aH && typeof aL.createTextNode != aq) {
                aH.appendChild(aL.createTextNode(b + " {" + g + "}"))
            }
        }
    }
  
    function ay(a, c) {
        if (!aI) {
            return
        }
        var b = c ? "visible" : "hidden";
        if (ak && aS(a)) {
            aS(a).style.visibility = b
        } else {
            az("#" + a, "visibility:" + b)
        }
    }
  
    function ai(b) {
        var a = /[\\\"<>\.;]/;
        var c = a.exec(b) != null;
        return c && typeof encodeURIComponent != aq ? encodeURIComponent(b) : b
    }
    var aR = function() {
        if (ah.ie && ah.win) {
            window.attachEvent("onunload", function() {
                var a = al.length;
                for (var b = 0; b < a; b++) {
                    al[b][0].detachEvent(al[b][1], al[b][2])
                }
                var d = ag.length;
                for (var c = 0; c < d; c++) {
                    aw(ag[c])
                }
                for (var e in ah) {
                    ah[e] = null
                }
                ah = null;
                for (var g in swfobject) {
                    swfobject[g] = null
                }
                swfobject = null
            })
        }
    }();
    return {
        registerObject: function(a, e, c, b) {
            if (ah.w3 && a && e) {
                var d = {};
                d.id = a;
                d.swfVersion = e;
                d.expressInstall = c;
                d.callbackFn = b;
                aG[aG.length] = d;
                ay(a, false)
            } else {
                if (b) {
                    b({
                        success: false,
                        id: a
                    })
                }
            }
        },
        getObjectById: function(a) {
            if (ah.w3) {
                return av(a)
            }
        },
        embedSWF: function(l, e, i, g, c, a, b, j, h, k) {
            var d = {
                success: false,
                id: e
            };
            if (ah.w3 && !(ah.wk && ah.wk < 312) && l && e && i && g && c) {
                ay(e, false);
                aj(function() {
                    i += "";
                    g += "";
                    var r = {};
                    if (h && typeof h === aD) {
                        for (var p in h) {
                            r[p] = h[p]
                        }
                    }
                    r.data = l;
                    r.width = i;
                    r.height = g;
                    var o = {};
                    if (j && typeof j === aD) {
                        for (var q in j) {
                            o[q] = j[q]
                        }
                    }
                    if (b && typeof b === aD) {
                        for (var m in b) {
                            if (typeof o.flashvars != aq) {
                                o.flashvars += "&" + m + "=" + b[m]
                            } else {
                                o.flashvars = m + "=" + b[m]
                            }
                        }
                    }
                    if (ao(c)) {
                        var n = aA(r, o, e);
                        if (r.id == e) {
                            ay(e, true)
                        }
                        d.success = true;
                        d.ref = n
                    } else {
                        if (a && au()) {
                            r.data = a;
                            ae(r, o, e, k);
                            return
                        } else {
                            ay(e, true)
                        }
                    }
                    if (k) {
                        k(d)
                    }
                })
            } else {
                if (k) {
                    k(d)
                }
            }
        },
        switchOffAutoHideShow: function() {
            aI = false
        },
        ua: ah,
        getFlashPlayerVersion: function() {
            return {
                major: ah.pv[0],
                minor: ah.pv[1],
                release: ah.pv[2]
            }
        },
        hasFlashPlayerVersion: ao,
        createSWF: function(a, b, c) {
            if (ah.w3) {
                return aA(a, b, c)
            } else {
                return undefined
            }
        },
        showExpressInstall: function(b, a, d, c) {
            if (ah.w3 && au()) {
                ae(b, a, d, c)
            }
        },
        removeSWF: function(a) {
            if (ah.w3) {
                aw(a)
            }
        },
        createCSS: function(b, a, c, d) {
            if (ah.w3) {
                az(b, a, c, d)
            }
        },
        addDomLoadEvent: aj,
        addLoadEvent: aC,
        getQueryParamValue: function(b) {
            var a = aL.location.search || aL.location.hash;
            if (a) {
                if (/\?/.test(a)) {
                    a = a.split("?")[1]
                }
                if (b == null) {
                    return ai(a)
                }
                var c = a.split("&");
                for (var d = 0; d < c.length; d++) {
                    if (c[d].substring(0, c[d].indexOf("=")) == b) {
                        return ai(c[d].substring((c[d].indexOf("=") + 1)))
                    }
                }
            }
            return ""
        },
        expressInstallCallback: function() {
            if (aU) {
                var a = aS(ac);
                if (a && aJ) {
                    a.parentNode.replaceChild(aJ, a);
                    if (ad) {
                        ay(ad, true);
                        if (ah.ie && ah.win) {
                            aJ.style.display = "block"
                        }
                    }
                    if (ap) {
                        ap(at)
                    }
                }
                aU = false
            }
        }
    }
}();
function initMap(c, h, i, l) {
    var c = (c) ? c : "#map-canvas",
        h = (h) ? h : 0,
        i = (i) ? i : 0;
    var k = [{
        stylers: [{
            hue: "#000000"
        }, {
            saturation: -100
        }]
    }, {
        featureType: "road",
        elementType: "geometry",
        stylers: [{
            saturation: 0
        }, {
            visibility: "simplified"
        }]
    }, {
        featureType: "road",
        elementType: "labels",
        stylers: [{
            visibility: "off"
        }]
    }];
    var j = new google.maps.StyledMapType(k, {
        name: "Styled Map"
    });
    var g = new google.maps.LatLng(h, i);
    var d = {
        zoom: 17,
        center: g,
        mapTypeControlOptions: {
            mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"]
        },
        restriction: {
            latLngBounds: {
                east: 141.61226093919385,
                south: -12.08127799422601,
                north: 6.272652376290223,
                west: 94.50288772430834
            }, strictBounds: false
        },
    };
    var b = new google.maps.Map(document.querySelector(c), d);
    var e = l;
    var a = new google.maps.Marker({
        position: g,
        map: b,
        icon: e
    });
    b.mapTypes.set("map_style", j);
    b.setMapTypeId("map_style")
}
function switchLayout(b, a, e) {
    var d = a();

    function c() {
        var g = a();
        if (g !== d) {
            d = !d;
            log("[GLOBAL] layout switched.", b, d);
            e(d)
        }
    }
    $(window).on("resize" + (b ? "." + b : ""), function() {
        c.call(undefined, d)
    });
    e(d)
}
(function(a) {
    a.fn.simpleTab = function(b) {
        var b = a.extend({
            activeClass: "on",
            tabClass: "tab",
            scroll: false,
            scrollOffset: -100,
            easing: "swing",
            changed: function() {}
        }, b);
        return this.each(function() {
            var j = a(this),
                g = b.activeClass,
                e = b.tabClass,
                h = j.find("a." + e),
                d = a([]),
                c = h.length,
                i = h.filter("." + g).index() >= 0 ? h.filter("." + g).index() : 0;
            h.each(function(l, m) {
                var n = a(m),
                    k = a(n.attr("href"));
                if (n.parent().hasClass(g)) {
                    i = l
                }
                d = d.add(k);
                k.css({
                    display: "none",
                    outline: "0 none"
                }).attr({
                    tabindex: "0"
                });
                n.on("click", function(o) {
                    var p = a(window).scrollTop();
                    d.hide();
                    h.removeClass(g);
                    h.parent().removeClass(g);
                    n.addClass(g);
                    n.parent().addClass(g);
                    k.show();
                    k.focus();
                    if (b.scroll) {
                        p = k.offset().top + b.scrollOffset;
                        a("html, body").stop().animate({
                            scrollTop: p
                        }, 700, b.easing)
                    } else {
                        a(window).scrollTop(p)
                    }
                    b.changed();
                    o.preventDefault();
                    o.stopPropagation()
                })
            });
            d.hide();
            h.eq(i).addClass(g);
            h.eq(i).parent().addClass(g);
            d.eq(i).show()
        })
    }
})(jQuery);

(function(a) {
    a.fn.accordion = function(b) {
        var b = a.extend({
            easing: "easeOutQuint",
            speed: 400,
            titleSelector: ".q",
            contSelector: ".a",
            collapsible: false,
            callback: function() {},
            onOpen: function(c) {}
        }, b);
        return this.each(function() {
            var g = a(this),
                d = g.find(b.titleSelector),
                e = g.find(b.contSelector),
                j = d.parent(),
                i = g.filter(".on");
            var h = function() {
                var k = d.outerHeight();
                d.css("cursor", "pointer").attr("tabindex", 0);
                d.on("click keypress", function(l) {
                    if (l.type == "click" || l.which == 13) {
                        c(a(this).parent())
                    }
                });
                if (!b.collapsible) {
                    if (i.length > 0) {
                        c(i.eq(0))
                    }
                } else {
                    i.removeClass("on")
                }
                j.not(".on").find(b.contSelector).hide()
            };
            var c = function(k) {
                var l = k.hasClass("on");
                j.removeClass("on");
                e.stop(true, true).slideUp({
                    duration: b.speed,
                    easing: b.easing,
                    complete: function() {
                        b.callback();
                        e.css("zoom", 1)
                    }
                });
                if (l) {
                    return
                }
                k.addClass("on").find(b.contSelector).stop(true, true).slideDown({
                    duration: b.speed,
                    easing: b.easing,
                    complete: function() {
                        b.callback();
                        b.onOpen(k)
                    }
                })
            };
            h()
        })
    };
})(jQuery);